window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expand = 800;
window.lazySizesConfig.expFactor = 2;
/*! VelocityJS.org (1.5.0). (C) 2014 Julian Shapiro. MIT @license: en.wikipedia.org/wiki/MIT_License */
/*! VelocityJS.org jQuery Shim (1.0.1). (C) 2014 The jQuery Foundation. MIT @license: en.wikipedia.org/wiki/MIT_License. */
!function(e) {
    "use strict";
    function t(e) {
        var t = e.length
          , i = r.type(e);
        return "function" !== i && !r.isWindow(e) && (!(1 !== e.nodeType || !t) || ("array" === i || 0 === t || "number" == typeof t && t > 0 && t - 1 in e))
    }
    if (!e.jQuery) {
        var r = function(e, t) {
            return new r.fn.init(e,t)
        };
        r.isWindow = function(e) {
            return e && e === e.window
        }
        ,
        r.type = function(e) {
            return e ? "object" == typeof e || "function" == typeof e ? n[a.call(e)] || "object" : typeof e : e + ""
        }
        ,
        r.isArray = Array.isArray || function(e) {
            return "array" === r.type(e)
        }
        ,
        r.isPlainObject = function(e) {
            var t;
            if (!e || "object" !== r.type(e) || e.nodeType || r.isWindow(e))
                return !1;
            try {
                if (e.constructor && !o.call(e, "constructor") && !o.call(e.constructor.prototype, "isPrototypeOf"))
                    return !1
            } catch (i) {
                return !1
            }
            for (t in e)
                ;
            return void 0 === t || o.call(e, t)
        }
        ,
        r.each = function(e, r, i) {
            var n, o = 0, a = e.length, s = t(e);
            if (i) {
                if (s)
                    for (; o < a && (n = r.apply(e[o], i),
                    n !== !1); o++)
                        ;
                else
                    for (o in e)
                        if (e.hasOwnProperty(o) && (n = r.apply(e[o], i),
                        n === !1))
                            break
            } else if (s)
                for (; o < a && (n = r.call(e[o], o, e[o]),
                n !== !1); o++)
                    ;
            else
                for (o in e)
                    if (e.hasOwnProperty(o) && (n = r.call(e[o], o, e[o]),
                    n === !1))
                        break;
            return e
        }
        ,
        r.data = function(e, t, n) {
            if (void 0 === n) {
                var o = e[r.expando]
                  , a = o && i[o];
                if (void 0 === t)
                    return a;
                if (a && t in a)
                    return a[t]
            } else if (void 0 !== t) {
                var s = e[r.expando] || (e[r.expando] = ++r.uuid);
                return i[s] = i[s] || {},
                i[s][t] = n,
                n
            }
        }
        ,
        r.removeData = function(e, t) {
            var n = e[r.expando]
              , o = n && i[n];
            o && (t ? r.each(t, function(e, t) {
                delete o[t]
            }) : delete i[n])
        }
        ,
        r.extend = function() {
            var e, t, i, n, o, a, s = arguments[0] || {}, l = 1, u = arguments.length, c = !1;
            for ("boolean" == typeof s && (c = s,
            s = arguments[l] || {},
            l++),
            "object" != typeof s && "function" !== r.type(s) && (s = {}),
            l === u && (s = this,
            l--); l < u; l++)
                if (o = arguments[l])
                    for (n in o)
                        o.hasOwnProperty(n) && (e = s[n],
                        i = o[n],
                        s !== i && (c && i && (r.isPlainObject(i) || (t = r.isArray(i))) ? (t ? (t = !1,
                        a = e && r.isArray(e) ? e : []) : a = e && r.isPlainObject(e) ? e : {},
                        s[n] = r.extend(c, a, i)) : void 0 !== i && (s[n] = i)));
            return s
        }
        ,
        r.queue = function(e, i, n) {
            function o(e, r) {
                var i = r || [];
                return e && (t(Object(e)) ? !function(e, t) {
                    for (var r = +t.length, i = 0, n = e.length; i < r; )
                        e[n++] = t[i++];
                    if (r !== r)
                        for (; void 0 !== t[i]; )
                            e[n++] = t[i++];
                    return e.length = n,
                    e
                }(i, "string" == typeof e ? [e] : e) : [].push.call(i, e)),
                i
            }
            if (e) {
                i = (i || "fx") + "queue";
                var a = r.data(e, i);
                return n ? (!a || r.isArray(n) ? a = r.data(e, i, o(n)) : a.push(n),
                a) : a || []
            }
        }
        ,
        r.dequeue = function(e, t) {
            r.each(e.nodeType ? [e] : e, function(e, i) {
                t = t || "fx";
                var n = r.queue(i, t)
                  , o = n.shift();
                "inprogress" === o && (o = n.shift()),
                o && ("fx" === t && n.unshift("inprogress"),
                o.call(i, function() {
                    r.dequeue(i, t)
                }))
            })
        }
        ,
        r.fn = r.prototype = {
            init: function(e) {
                if (e.nodeType)
                    return this[0] = e,
                    this;
                throw new Error("Not a DOM node.")
            },
            offset: function() {
                var t = this[0].getBoundingClientRect ? this[0].getBoundingClientRect() : {
                    top: 0,
                    left: 0
                };
                return {
                    top: t.top + (e.pageYOffset || document.scrollTop || 0) - (document.clientTop || 0),
                    left: t.left + (e.pageXOffset || document.scrollLeft || 0) - (document.clientLeft || 0)
                }
            },
            position: function() {
                function e(e) {
                    for (var t = e.offsetParent; t && "html" !== t.nodeName.toLowerCase() && t.style && "static" === t.style.position; )
                        t = t.offsetParent;
                    return t || document
                }
                var t = this[0]
                  , i = e(t)
                  , n = this.offset()
                  , o = /^(?:body|html)$/i.test(i.nodeName) ? {
                    top: 0,
                    left: 0
                } : r(i).offset();
                return n.top -= parseFloat(t.style.marginTop) || 0,
                n.left -= parseFloat(t.style.marginLeft) || 0,
                i.style && (o.top += parseFloat(i.style.borderTopWidth) || 0,
                o.left += parseFloat(i.style.borderLeftWidth) || 0),
                {
                    top: n.top - o.top,
                    left: n.left - o.left
                }
            }
        };
        var i = {};
        r.expando = "velocity" + (new Date).getTime(),
        r.uuid = 0;
        for (var n = {}, o = n.hasOwnProperty, a = n.toString, s = "Boolean Number String Function Array Date RegExp Object Error".split(" "), l = 0; l < s.length; l++)
            n["[object " + s[l] + "]"] = s[l].toLowerCase();
        r.fn.init.prototype = r.fn,
        e.Velocity = {
            Utilities: r
        }
    }
}(window),
function(e) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : e()
}(function() {
    "use strict";
    return function(e, t, r, i) {
        /* Array compacting. Copyright Lo-Dash. MIT License: https://github.com/lodash/lodash/blob/master/LICENSE.txt */
        function n(e) {
            for (var t = -1, r = e ? e.length : 0, i = []; ++t < r; ) {
                var n = e[t];
                n && i.push(n)
            }
            return i
        }
        function o(e) {
            return b.isWrapped(e) ? e = y.call(e) : b.isNode(e) && (e = [e]),
            e
        }
        function a(e) {
            var t = m.data(e, "velocity");
            return null === t ? i : t
        }
        function s(e, t) {
            var r = a(e);
            r && r.delayTimer && !r.delayPaused && (r.delayRemaining = r.delay - t + r.delayBegin,
            r.delayPaused = !0,
            clearTimeout(r.delayTimer.setTimeout))
        }
        function l(e, t) {
            var r = a(e);
            r && r.delayTimer && r.delayPaused && (r.delayPaused = !1,
            r.delayTimer.setTimeout = setTimeout(r.delayTimer.next, r.delayRemaining))
        }
        function u(e) {
            return function(t) {
                return Math.round(t * e) * (1 / e)
            }
        }
        /* Bezier curve function generator. Copyright Gaetan Renaudeau. MIT License: http://en.wikipedia.org/wiki/MIT_License */
        function c(e, r, i, n) {
            function o(e, t) {
                return 1 - 3 * t + 3 * e
            }
            function a(e, t) {
                return 3 * t - 6 * e
            }
            function s(e) {
                return 3 * e
            }
            function l(e, t, r) {
                return ((o(t, r) * e + a(t, r)) * e + s(t)) * e
            }
            function u(e, t, r) {
                return 3 * o(t, r) * e * e + 2 * a(t, r) * e + s(t)
            }
            function c(t, r) {
                for (var n = 0; n < h; ++n) {
                    var o = u(r, e, i);
                    if (0 === o)
                        return r;
                    var a = l(r, e, i) - t;
                    r -= a / o
                }
                return r
            }
            function p() {
                for (var t = 0; t < w; ++t)
                    C[t] = l(t * b, e, i)
            }
            function d(t, r, n) {
                var o, a, s = 0;
                do
                    a = r + (n - r) / 2,
                    o = l(a, e, i) - t,
                    o > 0 ? n = a : r = a;
                while (Math.abs(o) > v && ++s < y);
                return a
            }
            function f(t) {
                for (var r = 0, n = 1, o = w - 1; n !== o && C[n] <= t; ++n)
                    r += b;
                --n;
                var a = (t - C[n]) / (C[n + 1] - C[n])
                  , s = r + a * b
                  , l = u(s, e, i);
                return l >= g ? c(t, s) : 0 === l ? s : d(t, r, r + b)
            }
            function m() {
                P = !0,
                e === r && i === n || p()
            }
            var h = 4
              , g = .001
              , v = 1e-7
              , y = 10
              , w = 11
              , b = 1 / (w - 1)
              , x = "Float32Array"in t;
            if (4 !== arguments.length)
                return !1;
            for (var S = 0; S < 4; ++S)
                if ("number" != typeof arguments[S] || isNaN(arguments[S]) || !isFinite(arguments[S]))
                    return !1;
            e = Math.min(e, 1),
            i = Math.min(i, 1),
            e = Math.max(e, 0),
            i = Math.max(i, 0);
            var C = x ? new Float32Array(w) : new Array(w)
              , P = !1
              , T = function(t) {
                return P || m(),
                e === r && i === n ? t : 0 === t ? 0 : 1 === t ? 1 : l(f(t), r, n)
            };
            T.getControlPoints = function() {
                return [{
                    x: e,
                    y: r
                }, {
                    x: i,
                    y: n
                }]
            }
            ;
            var I = "generateBezier(" + [e, r, i, n] + ")";
            return T.toString = function() {
                return I
            }
            ,
            T
        }
        function p(e, t) {
            var r = e;
            return b.isString(e) ? P.Easings[e] || (r = !1) : r = b.isArray(e) && 1 === e.length ? u.apply(null, e) : b.isArray(e) && 2 === e.length ? T.apply(null, e.concat([t])) : !(!b.isArray(e) || 4 !== e.length) && c.apply(null, e),
            r === !1 && (r = P.Easings[P.defaults.easing] ? P.defaults.easing : C),
            r
        }
        function d(e) {
            if (e) {
                var t = P.timestamp && e !== !0 ? e : v.now()
                  , r = P.State.calls.length;
                r > 1e4 && (P.State.calls = n(P.State.calls),
                r = P.State.calls.length);
                for (var o = 0; o < r; o++)
                    if (P.State.calls[o]) {
                        var s = P.State.calls[o]
                          , l = s[0]
                          , u = s[2]
                          , c = s[3]
                          , p = !!c
                          , g = null
                          , y = s[5]
                          , w = s[6];
                        if (c || (c = P.State.calls[o][3] = t - 16),
                        y) {
                            if (y.resume !== !0)
                                continue;
                            c = s[3] = Math.round(t - w - 16),
                            s[5] = null
                        }
                        w = s[6] = t - c;
                        for (var x = Math.min(w / u.duration, 1), S = 0, C = l.length; S < C; S++) {
                            var T = l[S]
                              , A = T.element;
                            if (a(A)) {
                                var z = !1;
                                if (u.display !== i && null !== u.display && "none" !== u.display) {
                                    if ("flex" === u.display) {
                                        var V = ["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex"];
                                        m.each(V, function(e, t) {
                                            I.setPropertyValue(A, "display", t)
                                        })
                                    }
                                    I.setPropertyValue(A, "display", u.display)
                                }
                                u.visibility !== i && "hidden" !== u.visibility && I.setPropertyValue(A, "visibility", u.visibility);
                                for (var N in T)
                                    if (T.hasOwnProperty(N) && "element" !== N) {
                                        var E, $ = T[N], F = b.isString($.easing) ? P.Easings[$.easing] : $.easing;
                                        if (b.isString($.pattern)) {
                                            var j = 1 === x ? function(e, t, r) {
                                                var i = $.endValue[t];
                                                return r ? Math.round(i) : i
                                            }
                                            : function(e, t, r) {
                                                var i = $.startValue[t]
                                                  , n = $.endValue[t] - i
                                                  , o = i + n * F(x, u, n);
                                                return r ? Math.round(o) : o
                                            }
                                            ;
                                            E = $.pattern.replace(/{(\d+)(!)?}/g, j)
                                        } else if (1 === x)
                                            E = $.endValue;
                                        else {
                                            var M = $.endValue - $.startValue;
                                            E = $.startValue + M * F(x, u, M)
                                        }
                                        if (!p && E === $.currentValue)
                                            continue;
                                        if ($.currentValue = E,
                                        "tween" === N)
                                            g = E;
                                        else {
                                            var W;
                                            if (I.Hooks.registered[N]) {
                                                W = I.Hooks.getRoot(N);
                                                var O = a(A).rootPropertyValueCache[W];
                                                O && ($.rootPropertyValue = O)
                                            }
                                            var L = I.setPropertyValue(A, N, $.currentValue + (h < 9 && 0 === parseFloat(E) ? "" : $.unitType), $.rootPropertyValue, $.scrollData);
                                            I.Hooks.registered[N] && (I.Normalizations.registered[W] ? a(A).rootPropertyValueCache[W] = I.Normalizations.registered[W]("extract", null, L[1]) : a(A).rootPropertyValueCache[W] = L[1]),
                                            "transform" === L[0] && (z = !0)
                                        }
                                    }
                                u.mobileHA && a(A).transformCache.translate3d === i && (a(A).transformCache.translate3d = "(0px, 0px, 0px)",
                                z = !0),
                                z && I.flushTransformCache(A)
                            }
                        }
                        u.display !== i && "none" !== u.display && (P.State.calls[o][2].display = !1),
                        u.visibility !== i && "hidden" !== u.visibility && (P.State.calls[o][2].visibility = !1),
                        u.progress && u.progress.call(s[1], s[1], x, Math.max(0, c + u.duration - t), c, g),
                        1 === x && f(o)
                    }
            }
            P.State.isTicking && k(d)
        }
        function f(e, t) {
            if (!P.State.calls[e])
                return !1;
            for (var r = P.State.calls[e][0], n = P.State.calls[e][1], o = P.State.calls[e][2], s = P.State.calls[e][4], l = !1, u = 0, c = r.length; u < c; u++) {
                var p = r[u].element;
                t || o.loop || ("none" === o.display && I.setPropertyValue(p, "display", o.display),
                "hidden" === o.visibility && I.setPropertyValue(p, "visibility", o.visibility));
                var d = a(p);
                if (o.loop !== !0 && (m.queue(p)[1] === i || !/\.velocityQueueEntryFlag/i.test(m.queue(p)[1])) && d) {
                    d.isAnimating = !1,
                    d.rootPropertyValueCache = {};
                    var f = !1;
                    m.each(I.Lists.transforms3D, function(e, t) {
                        var r = /^scale/.test(t) ? 1 : 0
                          , n = d.transformCache[t];
                        d.transformCache[t] !== i && new RegExp("^\\(" + r + "[^.]").test(n) && (f = !0,
                        delete d.transformCache[t])
                    }),
                    o.mobileHA && (f = !0,
                    delete d.transformCache.translate3d),
                    f && I.flushTransformCache(p),
                    I.Values.removeClass(p, "velocity-animating")
                }
                if (!t && o.complete && !o.loop && u === c - 1)
                    try {
                        o.complete.call(n, n)
                    } catch (h) {
                        setTimeout(function() {
                            throw h
                        }, 1)
                    }
                s && o.loop !== !0 && s(n),
                d && o.loop === !0 && !t && (m.each(d.tweensContainer, function(e, t) {
                    if (/^rotate/.test(e) && (parseFloat(t.startValue) - parseFloat(t.endValue)) % 360 === 0) {
                        var r = t.startValue;
                        t.startValue = t.endValue,
                        t.endValue = r
                    }
                    /^backgroundPosition/.test(e) && 100 === parseFloat(t.endValue) && "%" === t.unitType && (t.endValue = 0,
                    t.startValue = 100)
                }),
                P(p, "reverse", {
                    loop: !0,
                    delay: o.delay
                })),
                o.queue !== !1 && m.dequeue(p, o.queue)
            }
            P.State.calls[e] = !1;
            for (var g = 0, v = P.State.calls.length; g < v; g++)
                if (P.State.calls[g] !== !1) {
                    l = !0;
                    break
                }
            l === !1 && (P.State.isTicking = !1,
            delete P.State.calls,
            P.State.calls = [])
        }
        var m, h = function() {
            if (r.documentMode)
                return r.documentMode;
            for (var e = 7; e > 4; e--) {
                var t = r.createElement("div");
                if (t.innerHTML = "<!--[if IE " + e + "]><span></span><![endif]-->",
                t.getElementsByTagName("span").length)
                    return t = null,
                    e
            }
            return i
        }(), g = function() {
            var e = 0;
            return t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || function(t) {
                var r, i = (new Date).getTime();
                /* Technique by Erik Moller. MIT license: https://gist.github.com/paulirish/1579671 */
                return r = Math.max(0, 16 - (i - e)),
                e = i + r,
                setTimeout(function() {
                    t(i + r)
                }, r)
            }
        }(), v = function() {
            var e = t.performance || {};
            if ("function" != typeof e.now) {
                var r = e.timing && e.timing.navigationStart ? e.timing.navigationStart : (new Date).getTime();
                e.now = function() {
                    return (new Date).getTime() - r
                }
            }
            return e
        }(), y = function() {
            var e = Array.prototype.slice;
            try {
                return e.call(r.documentElement),
                e
            } catch (t) {
                return function(t, r) {
                    var i = this.length;
                    if ("number" != typeof t && (t = 0),
                    "number" != typeof r && (r = i),
                    this.slice)
                        return e.call(this, t, r);
                    var n, o = [], a = t >= 0 ? t : Math.max(0, i + t), s = r < 0 ? i + r : Math.min(r, i), l = s - a;
                    if (l > 0)
                        if (o = new Array(l),
                        this.charAt)
                            for (n = 0; n < l; n++)
                                o[n] = this.charAt(a + n);
                        else
                            for (n = 0; n < l; n++)
                                o[n] = this[a + n];
                    return o
                }
            }
        }(), w = function() {
            return Array.prototype.includes ? function(e, t) {
                return e.includes(t)
            }
            : Array.prototype.indexOf ? function(e, t) {
                return e.indexOf(t) >= 0
            }
            : function(e, t) {
                for (var r = 0; r < e.length; r++)
                    if (e[r] === t)
                        return !0;
                return !1
            }
        }, b = {
            isNumber: function(e) {
                return "number" == typeof e
            },
            isString: function(e) {
                return "string" == typeof e
            },
            isArray: Array.isArray || function(e) {
                return "[object Array]" === Object.prototype.toString.call(e)
            }
            ,
            isFunction: function(e) {
                return "[object Function]" === Object.prototype.toString.call(e)
            },
            isNode: function(e) {
                return e && e.nodeType
            },
            isWrapped: function(e) {
                return e && e !== t && b.isNumber(e.length) && !b.isString(e) && !b.isFunction(e) && !b.isNode(e) && (0 === e.length || b.isNode(e[0]))
            },
            isSVG: function(e) {
                return t.SVGElement && e instanceof t.SVGElement
            },
            isEmptyObject: function(e) {
                for (var t in e)
                    if (e.hasOwnProperty(t))
                        return !1;
                return !0
            }
        }, x = !1;
        if (e.fn && e.fn.jquery ? (m = e,
        x = !0) : m = t.Velocity.Utilities,
        h <= 8 && !x)
            throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");
        if (h <= 7)
            return void (jQuery.fn.velocity = jQuery.fn.animate);
        var S = 400
          , C = "swing"
          , P = {
            State: {
                isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
                isAndroid: /Android/i.test(navigator.userAgent),
                isGingerbread: /Android 2\.3\.[3-7]/i.test(navigator.userAgent),
                isChrome: t.chrome,
                isFirefox: /Firefox/i.test(navigator.userAgent),
                prefixElement: r.createElement("div"),
                prefixMatches: {},
                scrollAnchor: null,
                scrollPropertyLeft: null,
                scrollPropertyTop: null,
                isTicking: !1,
                calls: [],
                delayedElements: {
                    count: 0
                }
            },
            CSS: {},
            Utilities: m,
            Redirects: {},
            Easings: {},
            Promise: t.Promise,
            defaults: {
                queue: "",
                duration: S,
                easing: C,
                begin: i,
                complete: i,
                progress: i,
                display: i,
                visibility: i,
                loop: !1,
                delay: !1,
                mobileHA: !0,
                _cacheValues: !0,
                promiseRejectEmpty: !0
            },
            init: function(e) {
                m.data(e, "velocity", {
                    isSVG: b.isSVG(e),
                    isAnimating: !1,
                    computedStyle: null,
                    tweensContainer: null,
                    rootPropertyValueCache: {},
                    transformCache: {}
                })
            },
            hook: null,
            mock: !1,
            version: {
                major: 1,
                minor: 5,
                patch: 0
            },
            debug: !1,
            timestamp: !0,
            pauseAll: function(e) {
                var t = (new Date).getTime();
                m.each(P.State.calls, function(t, r) {
                    if (r) {
                        if (e !== i && (r[2].queue !== e || r[2].queue === !1))
                            return !0;
                        r[5] = {
                            resume: !1
                        }
                    }
                }),
                m.each(P.State.delayedElements, function(e, r) {
                    r && s(r, t)
                })
            },
            resumeAll: function(e) {
                var t = (new Date).getTime();
                m.each(P.State.calls, function(t, r) {
                    if (r) {
                        if (e !== i && (r[2].queue !== e || r[2].queue === !1))
                            return !0;
                        r[5] && (r[5].resume = !0)
                    }
                }),
                m.each(P.State.delayedElements, function(e, r) {
                    r && l(r, t)
                })
            }
        };
        t.pageYOffset !== i ? (P.State.scrollAnchor = t,
        P.State.scrollPropertyLeft = "pageXOffset",
        P.State.scrollPropertyTop = "pageYOffset") : (P.State.scrollAnchor = r.documentElement || r.body.parentNode || r.body,
        P.State.scrollPropertyLeft = "scrollLeft",
        P.State.scrollPropertyTop = "scrollTop");
        /* Runge-Kutta spring physics function generator. Adapted from Framer.js, copyright Koen Bok. MIT License: http://en.wikipedia.org/wiki/MIT_License */
        /* Given a tension, friction, and duration, a simulation at 60FPS will first run without a defined duration in order to calculate the full path. A second pass
		 then adjusts the time delta -- using the relation between actual time and duration -- to calculate the path for the duration-constrained animation. */
        var T = function() {
            function e(e) {
                return -e.tension * e.x - e.friction * e.v
            }
            function t(t, r, i) {
                var n = {
                    x: t.x + i.dx * r,
                    v: t.v + i.dv * r,
                    tension: t.tension,
                    friction: t.friction
                };
                return {
                    dx: n.v,
                    dv: e(n)
                }
            }
            function r(r, i) {
                var n = {
                    dx: r.v,
                    dv: e(r)
                }
                  , o = t(r, .5 * i, n)
                  , a = t(r, .5 * i, o)
                  , s = t(r, i, a)
                  , l = 1 / 6 * (n.dx + 2 * (o.dx + a.dx) + s.dx)
                  , u = 1 / 6 * (n.dv + 2 * (o.dv + a.dv) + s.dv);
                return r.x = r.x + l * i,
                r.v = r.v + u * i,
                r
            }
            return function i(e, t, n) {
                var o, a, s, l = {
                    x: -1,
                    v: 0,
                    tension: null,
                    friction: null
                }, u = [0], c = 0, p = 1e-4, d = .016;
                for (e = parseFloat(e) || 500,
                t = parseFloat(t) || 20,
                n = n || null,
                l.tension = e,
                l.friction = t,
                o = null !== n,
                o ? (c = i(e, t),
                a = c / n * d) : a = d; ; )
                    if (s = r(s || l, a),
                    u.push(1 + s.x),
                    c += 16,
                    !(Math.abs(s.x) > p && Math.abs(s.v) > p))
                        break;
                return o ? function(e) {
                    return u[e * (u.length - 1) | 0]
                }
                : c
            }
        }();
        P.Easings = {
            linear: function(e) {
                return e
            },
            swing: function(e) {
                return .5 - Math.cos(e * Math.PI) / 2
            },
            spring: function(e) {
                return 1 - Math.cos(4.5 * e * Math.PI) * Math.exp(6 * -e)
            }
        },
        m.each([["ease", [.25, .1, .25, 1]], ["ease-in", [.42, 0, 1, 1]], ["ease-out", [0, 0, .58, 1]], ["ease-in-out", [.42, 0, .58, 1]], ["easeInSine", [.47, 0, .745, .715]], ["easeOutSine", [.39, .575, .565, 1]], ["easeInOutSine", [.445, .05, .55, .95]], ["easeInQuad", [.55, .085, .68, .53]], ["easeOutQuad", [.25, .46, .45, .94]], ["easeInOutQuad", [.455, .03, .515, .955]], ["easeInCubic", [.55, .055, .675, .19]], ["easeOutCubic", [.215, .61, .355, 1]], ["easeInOutCubic", [.645, .045, .355, 1]], ["easeInQuart", [.895, .03, .685, .22]], ["easeOutQuart", [.165, .84, .44, 1]], ["easeInOutQuart", [.77, 0, .175, 1]], ["easeInQuint", [.755, .05, .855, .06]], ["easeOutQuint", [.23, 1, .32, 1]], ["easeInOutQuint", [.86, 0, .07, 1]], ["easeInExpo", [.95, .05, .795, .035]], ["easeOutExpo", [.19, 1, .22, 1]], ["easeInOutExpo", [1, 0, 0, 1]], ["easeInCirc", [.6, .04, .98, .335]], ["easeOutCirc", [.075, .82, .165, 1]], ["easeInOutCirc", [.785, .135, .15, .86]]], function(e, t) {
            P.Easings[t[0]] = c.apply(null, t[1])
        });
        var I = P.CSS = {
            RegEx: {
                isHex: /^#([A-f\d]{3}){1,2}$/i,
                valueUnwrap: /^[A-z]+\((.*)\)$/i,
                wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
                valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/gi
            },
            Lists: {
                colors: ["fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor"],
                transformsBase: ["translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ"],
                transforms3D: ["transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY"],
                units: ["%", "em", "ex", "ch", "rem", "vw", "vh", "vmin", "vmax", "cm", "mm", "Q", "in", "pc", "pt", "px", "deg", "grad", "rad", "turn", "s", "ms"],
                colorNames: {
                    aliceblue: "240,248,255",
                    antiquewhite: "250,235,215",
                    aquamarine: "127,255,212",
                    aqua: "0,255,255",
                    azure: "240,255,255",
                    beige: "245,245,220",
                    bisque: "255,228,196",
                    black: "0,0,0",
                    blanchedalmond: "255,235,205",
                    blueviolet: "138,43,226",
                    blue: "0,0,255",
                    brown: "165,42,42",
                    burlywood: "222,184,135",
                    cadetblue: "95,158,160",
                    chartreuse: "127,255,0",
                    chocolate: "210,105,30",
                    coral: "255,127,80",
                    cornflowerblue: "100,149,237",
                    cornsilk: "255,248,220",
                    crimson: "220,20,60",
                    cyan: "0,255,255",
                    darkblue: "0,0,139",
                    darkcyan: "0,139,139",
                    darkgoldenrod: "184,134,11",
                    darkgray: "169,169,169",
                    darkgrey: "169,169,169",
                    darkgreen: "0,100,0",
                    darkkhaki: "189,183,107",
                    darkmagenta: "139,0,139",
                    darkolivegreen: "85,107,47",
                    darkorange: "255,140,0",
                    darkorchid: "153,50,204",
                    darkred: "139,0,0",
                    darksalmon: "233,150,122",
                    darkseagreen: "143,188,143",
                    darkslateblue: "72,61,139",
                    darkslategray: "47,79,79",
                    darkturquoise: "0,206,209",
                    darkviolet: "148,0,211",
                    deeppink: "255,20,147",
                    deepskyblue: "0,191,255",
                    dimgray: "105,105,105",
                    dimgrey: "105,105,105",
                    dodgerblue: "30,144,255",
                    firebrick: "178,34,34",
                    floralwhite: "255,250,240",
                    forestgreen: "34,139,34",
                    fuchsia: "255,0,255",
                    gainsboro: "220,220,220",
                    ghostwhite: "248,248,255",
                    gold: "255,215,0",
                    goldenrod: "218,165,32",
                    gray: "128,128,128",
                    grey: "128,128,128",
                    greenyellow: "173,255,47",
                    green: "0,128,0",
                    honeydew: "240,255,240",
                    hotpink: "255,105,180",
                    indianred: "205,92,92",
                    indigo: "75,0,130",
                    ivory: "255,255,240",
                    khaki: "240,230,140",
                    lavenderblush: "255,240,245",
                    lavender: "230,230,250",
                    lawngreen: "124,252,0",
                    lemonchiffon: "255,250,205",
                    lightblue: "173,216,230",
                    lightcoral: "240,128,128",
                    lightcyan: "224,255,255",
                    lightgoldenrodyellow: "250,250,210",
                    lightgray: "211,211,211",
                    lightgrey: "211,211,211",
                    lightgreen: "144,238,144",
                    lightpink: "255,182,193",
                    lightsalmon: "255,160,122",
                    lightseagreen: "32,178,170",
                    lightskyblue: "135,206,250",
                    lightslategray: "119,136,153",
                    lightsteelblue: "176,196,222",
                    lightyellow: "255,255,224",
                    limegreen: "50,205,50",
                    lime: "0,255,0",
                    linen: "250,240,230",
                    magenta: "255,0,255",
                    maroon: "128,0,0",
                    mediumaquamarine: "102,205,170",
                    mediumblue: "0,0,205",
                    mediumorchid: "186,85,211",
                    mediumpurple: "147,112,219",
                    mediumseagreen: "60,179,113",
                    mediumslateblue: "123,104,238",
                    mediumspringgreen: "0,250,154",
                    mediumturquoise: "72,209,204",
                    mediumvioletred: "199,21,133",
                    midnightblue: "25,25,112",
                    mintcream: "245,255,250",
                    mistyrose: "255,228,225",
                    moccasin: "255,228,181",
                    navajowhite: "255,222,173",
                    navy: "0,0,128",
                    oldlace: "253,245,230",
                    olivedrab: "107,142,35",
                    olive: "128,128,0",
                    orangered: "255,69,0",
                    orange: "255,165,0",
                    orchid: "218,112,214",
                    palegoldenrod: "238,232,170",
                    palegreen: "152,251,152",
                    paleturquoise: "175,238,238",
                    palevioletred: "219,112,147",
                    papayawhip: "255,239,213",
                    peachpuff: "255,218,185",
                    peru: "205,133,63",
                    pink: "255,192,203",
                    plum: "221,160,221",
                    powderblue: "176,224,230",
                    purple: "128,0,128",
                    red: "255,0,0",
                    rosybrown: "188,143,143",
                    royalblue: "65,105,225",
                    saddlebrown: "139,69,19",
                    salmon: "250,128,114",
                    sandybrown: "244,164,96",
                    seagreen: "46,139,87",
                    seashell: "255,245,238",
                    sienna: "160,82,45",
                    silver: "192,192,192",
                    skyblue: "135,206,235",
                    slateblue: "106,90,205",
                    slategray: "112,128,144",
                    snow: "255,250,250",
                    springgreen: "0,255,127",
                    steelblue: "70,130,180",
                    tan: "210,180,140",
                    teal: "0,128,128",
                    thistle: "216,191,216",
                    tomato: "255,99,71",
                    turquoise: "64,224,208",
                    violet: "238,130,238",
                    wheat: "245,222,179",
                    whitesmoke: "245,245,245",
                    white: "255,255,255",
                    yellowgreen: "154,205,50",
                    yellow: "255,255,0"
                }
            },
            Hooks: {
                templates: {
                    textShadow: ["Color X Y Blur", "black 0px 0px 0px"],
                    boxShadow: ["Color X Y Blur Spread", "black 0px 0px 0px 0px"],
                    clip: ["Top Right Bottom Left", "0px 0px 0px 0px"],
                    backgroundPosition: ["X Y", "0% 0%"],
                    transformOrigin: ["X Y Z", "50% 50% 0px"],
                    perspectiveOrigin: ["X Y", "50% 50%"]
                },
                registered: {},
                register: function() {
                    for (var e = 0; e < I.Lists.colors.length; e++) {
                        var t = "color" === I.Lists.colors[e] ? "0 0 0 1" : "255 255 255 1";
                        I.Hooks.templates[I.Lists.colors[e]] = ["Red Green Blue Alpha", t]
                    }
                    var r, i, n;
                    if (h)
                        for (r in I.Hooks.templates)
                            if (I.Hooks.templates.hasOwnProperty(r)) {
                                i = I.Hooks.templates[r],
                                n = i[0].split(" ");
                                var o = i[1].match(I.RegEx.valueSplit);
                                "Color" === n[0] && (n.push(n.shift()),
                                o.push(o.shift()),
                                I.Hooks.templates[r] = [n.join(" "), o.join(" ")])
                            }
                    for (r in I.Hooks.templates)
                        if (I.Hooks.templates.hasOwnProperty(r)) {
                            i = I.Hooks.templates[r],
                            n = i[0].split(" ");
                            for (var a in n)
                                if (n.hasOwnProperty(a)) {
                                    var s = r + n[a]
                                      , l = a;
                                    I.Hooks.registered[s] = [r, l]
                                }
                        }
                },
                getRoot: function(e) {
                    var t = I.Hooks.registered[e];
                    return t ? t[0] : e
                },
                getUnit: function(e, t) {
                    var r = (e.substr(t || 0, 5).match(/^[a-z%]+/) || [])[0] || "";
                    return r && w(I.Lists.units, r) ? r : ""
                },
                fixColors: function(e) {
                    return e.replace(/(rgba?\(\s*)?(\b[a-z]+\b)/g, function(e, t, r) {
                        return I.Lists.colorNames.hasOwnProperty(r) ? (t ? t : "rgba(") + I.Lists.colorNames[r] + (t ? "" : ",1)") : t + r
                    })
                },
                cleanRootPropertyValue: function(e, t) {
                    return I.RegEx.valueUnwrap.test(t) && (t = t.match(I.RegEx.valueUnwrap)[1]),
                    I.Values.isCSSNullValue(t) && (t = I.Hooks.templates[e][1]),
                    t
                },
                extractValue: function(e, t) {
                    var r = I.Hooks.registered[e];
                    if (r) {
                        var i = r[0]
                          , n = r[1];
                        return t = I.Hooks.cleanRootPropertyValue(i, t),
                        t.toString().match(I.RegEx.valueSplit)[n]
                    }
                    return t
                },
                injectValue: function(e, t, r) {
                    var i = I.Hooks.registered[e];
                    if (i) {
                        var n, o, a = i[0], s = i[1];
                        return r = I.Hooks.cleanRootPropertyValue(a, r),
                        n = r.toString().match(I.RegEx.valueSplit),
                        n[s] = t,
                        o = n.join(" ")
                    }
                    return r
                }
            },
            Normalizations: {
                registered: {
                    clip: function(e, t, r) {
                        switch (e) {
                        case "name":
                            return "clip";
                        case "extract":
                            var i;
                            return I.RegEx.wrappedValueAlreadyExtracted.test(r) ? i = r : (i = r.toString().match(I.RegEx.valueUnwrap),
                            i = i ? i[1].replace(/,(\s+)?/g, " ") : r),
                            i;
                        case "inject":
                            return "rect(" + r + ")"
                        }
                    },
                    blur: function(e, t, r) {
                        switch (e) {
                        case "name":
                            return P.State.isFirefox ? "filter" : "-webkit-filter";
                        case "extract":
                            var i = parseFloat(r);
                            if (!i && 0 !== i) {
                                var n = r.toString().match(/blur\(([0-9]+[A-z]+)\)/i);
                                i = n ? n[1] : 0
                            }
                            return i;
                        case "inject":
                            return parseFloat(r) ? "blur(" + r + ")" : "none"
                        }
                    },
                    opacity: function(e, t, r) {
                        if (h <= 8)
                            switch (e) {
                            case "name":
                                return "filter";
                            case "extract":
                                var i = r.toString().match(/alpha\(opacity=(.*)\)/i);
                                return r = i ? i[1] / 100 : 1;
                            case "inject":
                                return t.style.zoom = 1,
                                parseFloat(r) >= 1 ? "" : "alpha(opacity=" + parseInt(100 * parseFloat(r), 10) + ")"
                            }
                        else
                            switch (e) {
                            case "name":
                                return "opacity";
                            case "extract":
                                return r;
                            case "inject":
                                return r
                            }
                    }
                },
                register: function() {
                    function e(e, t, r) {
                        var i = "border-box" === I.getPropertyValue(t, "boxSizing").toString().toLowerCase();
                        if (i === (r || !1)) {
                            var n, o, a = 0, s = "width" === e ? ["Left", "Right"] : ["Top", "Bottom"], l = ["padding" + s[0], "padding" + s[1], "border" + s[0] + "Width", "border" + s[1] + "Width"];
                            for (n = 0; n < l.length; n++)
                                o = parseFloat(I.getPropertyValue(t, l[n])),
                                isNaN(o) || (a += o);
                            return r ? -a : a
                        }
                        return 0
                    }
                    function t(t, r) {
                        return function(i, n, o) {
                            switch (i) {
                            case "name":
                                return t;
                            case "extract":
                                return parseFloat(o) + e(t, n, r);
                            case "inject":
                                return parseFloat(o) - e(t, n, r) + "px"
                            }
                        }
                    }
                    h && !(h > 9) || P.State.isGingerbread || (I.Lists.transformsBase = I.Lists.transformsBase.concat(I.Lists.transforms3D));
                    for (var r = 0; r < I.Lists.transformsBase.length; r++)
                        !function() {
                            var e = I.Lists.transformsBase[r];
                            I.Normalizations.registered[e] = function(t, r, n) {
                                switch (t) {
                                case "name":
                                    return "transform";
                                case "extract":
                                    return a(r) === i || a(r).transformCache[e] === i ? /^scale/i.test(e) ? 1 : 0 : a(r).transformCache[e].replace(/[()]/g, "");
                                case "inject":
                                    var o = !1;
                                    switch (e.substr(0, e.length - 1)) {
                                    case "translate":
                                        o = !/(%|px|em|rem|vw|vh|\d)$/i.test(n);
                                        break;
                                    case "scal":
                                    case "scale":
                                        P.State.isAndroid && a(r).transformCache[e] === i && n < 1 && (n = 1),
                                        o = !/(\d)$/i.test(n);
                                        break;
                                    case "skew":
                                        o = !/(deg|\d)$/i.test(n);
                                        break;
                                    case "rotate":
                                        o = !/(deg|\d)$/i.test(n)
                                    }
                                    return o || (a(r).transformCache[e] = "(" + n + ")"),
                                    a(r).transformCache[e]
                                }
                            }
                        }();
                    for (var n = 0; n < I.Lists.colors.length; n++)
                        !function() {
                            var e = I.Lists.colors[n];
                            I.Normalizations.registered[e] = function(t, r, n) {
                                switch (t) {
                                case "name":
                                    return e;
                                case "extract":
                                    var o;
                                    if (I.RegEx.wrappedValueAlreadyExtracted.test(n))
                                        o = n;
                                    else {
                                        var a, s = {
                                            black: "rgb(0, 0, 0)",
                                            blue: "rgb(0, 0, 255)",
                                            gray: "rgb(128, 128, 128)",
                                            green: "rgb(0, 128, 0)",
                                            red: "rgb(255, 0, 0)",
                                            white: "rgb(255, 255, 255)"
                                        };
                                        /^[A-z]+$/i.test(n) ? a = s[n] !== i ? s[n] : s.black : I.RegEx.isHex.test(n) ? a = "rgb(" + I.Values.hexToRgb(n).join(" ") + ")" : /^rgba?\(/i.test(n) || (a = s.black),
                                        o = (a || n).toString().match(I.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " ")
                                    }
                                    return (!h || h > 8) && 3 === o.split(" ").length && (o += " 1"),
                                    o;
                                case "inject":
                                    return /^rgb/.test(n) ? n : (h <= 8 ? 4 === n.split(" ").length && (n = n.split(/\s+/).slice(0, 3).join(" ")) : 3 === n.split(" ").length && (n += " 1"),
                                    (h <= 8 ? "rgb" : "rgba") + "(" + n.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")")
                                }
                            }
                        }();
                    I.Normalizations.registered.innerWidth = t("width", !0),
                    I.Normalizations.registered.innerHeight = t("height", !0),
                    I.Normalizations.registered.outerWidth = t("width"),
                    I.Normalizations.registered.outerHeight = t("height")
                }
            },
            Names: {
                camelCase: function(e) {
                    return e.replace(/-(\w)/g, function(e, t) {
                        return t.toUpperCase()
                    })
                },
                SVGAttribute: function(e) {
                    var t = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";
                    return (h || P.State.isAndroid && !P.State.isChrome) && (t += "|transform"),
                    new RegExp("^(" + t + ")$","i").test(e)
                },
                prefixCheck: function(e) {
                    if (P.State.prefixMatches[e])
                        return [P.State.prefixMatches[e], !0];
                    for (var t = ["", "Webkit", "Moz", "ms", "O"], r = 0, i = t.length; r < i; r++) {
                        var n;
                        if (n = 0 === r ? e : t[r] + e.replace(/^\w/, function(e) {
                            return e.toUpperCase()
                        }),
                        b.isString(P.State.prefixElement.style[n]))
                            return P.State.prefixMatches[e] = n,
                            [n, !0]
                    }
                    return [e, !1]
                }
            },
            Values: {
                /* Hex to RGB conversion. Copyright Tim Down: http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb */
                hexToRgb: function(e) {
                    var t, r = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, i = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
                    return e = e.replace(r, function(e, t, r, i) {
                        return t + t + r + r + i + i
                    }),
                    t = i.exec(e),
                    t ? [parseInt(t[1], 16), parseInt(t[2], 16), parseInt(t[3], 16)] : [0, 0, 0]
                },
                isCSSNullValue: function(e) {
                    return !e || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(e)
                },
                getUnitType: function(e) {
                    return /^(rotate|skew)/i.test(e) ? "deg" : /(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(e) ? "" : "px"
                },
                getDisplayType: function(e) {
                    var t = e && e.tagName.toString().toLowerCase();
                    return /^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(t) ? "inline" : /^(li)$/i.test(t) ? "list-item" : /^(tr)$/i.test(t) ? "table-row" : /^(table)$/i.test(t) ? "table" : /^(tbody)$/i.test(t) ? "table-row-group" : "block"
                },
                addClass: function(e, t) {
                    if (e)
                        if (e.classList)
                            e.classList.add(t);
                        else if (b.isString(e.className))
                            e.className += (e.className.length ? " " : "") + t;
                        else {
                            var r = e.getAttribute(h <= 7 ? "className" : "class") || "";
                            e.setAttribute("class", r + (r ? " " : "") + t)
                        }
                },
                removeClass: function(e, t) {
                    if (e)
                        if (e.classList)
                            e.classList.remove(t);
                        else if (b.isString(e.className))
                            e.className = e.className.toString().replace(new RegExp("(^|\\s)" + t.split(" ").join("|") + "(\\s|$)","gi"), " ");
                        else {
                            var r = e.getAttribute(h <= 7 ? "className" : "class") || "";
                            e.setAttribute("class", r.replace(new RegExp("(^|s)" + t.split(" ").join("|") + "(s|$)","gi"), " "))
                        }
                }
            },
            getPropertyValue: function(e, r, n, o) {
                function s(e, r) {
                    var n = 0;
                    if (h <= 8)
                        n = m.css(e, r);
                    else {
                        var l = !1;
                        /^(width|height)$/.test(r) && 0 === I.getPropertyValue(e, "display") && (l = !0,
                        I.setPropertyValue(e, "display", I.Values.getDisplayType(e)));
                        var u = function() {
                            l && I.setPropertyValue(e, "display", "none")
                        };
                        if (!o) {
                            if ("height" === r && "border-box" !== I.getPropertyValue(e, "boxSizing").toString().toLowerCase()) {
                                var c = e.offsetHeight - (parseFloat(I.getPropertyValue(e, "borderTopWidth")) || 0) - (parseFloat(I.getPropertyValue(e, "borderBottomWidth")) || 0) - (parseFloat(I.getPropertyValue(e, "paddingTop")) || 0) - (parseFloat(I.getPropertyValue(e, "paddingBottom")) || 0);
                                return u(),
                                c
                            }
                            if ("width" === r && "border-box" !== I.getPropertyValue(e, "boxSizing").toString().toLowerCase()) {
                                var p = e.offsetWidth - (parseFloat(I.getPropertyValue(e, "borderLeftWidth")) || 0) - (parseFloat(I.getPropertyValue(e, "borderRightWidth")) || 0) - (parseFloat(I.getPropertyValue(e, "paddingLeft")) || 0) - (parseFloat(I.getPropertyValue(e, "paddingRight")) || 0);
                                return u(),
                                p
                            }
                        }
                        var d;
                        d = a(e) === i ? t.getComputedStyle(e, null) : a(e).computedStyle ? a(e).computedStyle : a(e).computedStyle = t.getComputedStyle(e, null),
                        "borderColor" === r && (r = "borderTopColor"),
                        n = 9 === h && "filter" === r ? d.getPropertyValue(r) : d[r],
                        "" !== n && null !== n || (n = e.style[r]),
                        u()
                    }
                    if ("auto" === n && /^(top|right|bottom|left)$/i.test(r)) {
                        var f = s(e, "position");
                        ("fixed" === f || "absolute" === f && /top|left/i.test(r)) && (n = m(e).position()[r] + "px")
                    }
                    return n
                }
                var l;
                if (I.Hooks.registered[r]) {
                    var u = r
                      , c = I.Hooks.getRoot(u);
                    n === i && (n = I.getPropertyValue(e, I.Names.prefixCheck(c)[0])),
                    I.Normalizations.registered[c] && (n = I.Normalizations.registered[c]("extract", e, n)),
                    l = I.Hooks.extractValue(u, n)
                } else if (I.Normalizations.registered[r]) {
                    var p, d;
                    p = I.Normalizations.registered[r]("name", e),
                    "transform" !== p && (d = s(e, I.Names.prefixCheck(p)[0]),
                    I.Values.isCSSNullValue(d) && I.Hooks.templates[r] && (d = I.Hooks.templates[r][1])),
                    l = I.Normalizations.registered[r]("extract", e, d)
                }
                if (!/^[\d-]/.test(l)) {
                    var f = a(e);
                    if (f && f.isSVG && I.Names.SVGAttribute(r))
                        if (/^(height|width)$/i.test(r))
                            try {
                                l = e.getBBox()[r]
                            } catch (g) {
                                l = 0
                            }
                        else
                            l = e.getAttribute(r);
                    else
                        l = s(e, I.Names.prefixCheck(r)[0])
                }
                return I.Values.isCSSNullValue(l) && (l = 0),
                P.debug >= 2 && console.log("Get " + r + ": " + l),
                l
            },
            setPropertyValue: function(e, r, i, n, o) {
                var s = r;
                if ("scroll" === r)
                    o.container ? o.container["scroll" + o.direction] = i : "Left" === o.direction ? t.scrollTo(i, o.alternateValue) : t.scrollTo(o.alternateValue, i);
                else if (I.Normalizations.registered[r] && "transform" === I.Normalizations.registered[r]("name", e))
                    I.Normalizations.registered[r]("inject", e, i),
                    s = "transform",
                    i = a(e).transformCache[r];
                else {
                    if (I.Hooks.registered[r]) {
                        var l = r
                          , u = I.Hooks.getRoot(r);
                        n = n || I.getPropertyValue(e, u),
                        i = I.Hooks.injectValue(l, i, n),
                        r = u
                    }
                    if (I.Normalizations.registered[r] && (i = I.Normalizations.registered[r]("inject", e, i),
                    r = I.Normalizations.registered[r]("name", e)),
                    s = I.Names.prefixCheck(r)[0],
                    h <= 8)
                        try {
                            e.style[s] = i
                        } catch (c) {
                            P.debug && console.log("Browser does not support [" + i + "] for [" + s + "]")
                        }
                    else {
                        var p = a(e);
                        p && p.isSVG && I.Names.SVGAttribute(r) ? e.setAttribute(r, i) : e.style[s] = i
                    }
                    P.debug >= 2 && console.log("Set " + r + " (" + s + "): " + i)
                }
                return [s, i]
            },
            flushTransformCache: function(e) {
                var t = ""
                  , r = a(e);
                if ((h || P.State.isAndroid && !P.State.isChrome) && r && r.isSVG) {
                    var i = function(t) {
                        return parseFloat(I.getPropertyValue(e, t))
                    }
                      , n = {
                        translate: [i("translateX"), i("translateY")],
                        skewX: [i("skewX")],
                        skewY: [i("skewY")],
                        scale: 1 !== i("scale") ? [i("scale"), i("scale")] : [i("scaleX"), i("scaleY")],
                        rotate: [i("rotateZ"), 0, 0]
                    };
                    m.each(a(e).transformCache, function(e) {
                        /^translate/i.test(e) ? e = "translate" : /^scale/i.test(e) ? e = "scale" : /^rotate/i.test(e) && (e = "rotate"),
                        n[e] && (t += e + "(" + n[e].join(" ") + ") ",
                        delete n[e])
                    })
                } else {
                    var o, s;
                    m.each(a(e).transformCache, function(r) {
                        return o = a(e).transformCache[r],
                        "transformPerspective" === r ? (s = o,
                        !0) : (9 === h && "rotateZ" === r && (r = "rotate"),
                        void (t += r + o + " "))
                    }),
                    s && (t = "perspective" + s + " " + t)
                }
                I.setPropertyValue(e, "transform", t)
            }
        };
        I.Hooks.register(),
        I.Normalizations.register(),
        P.hook = function(e, t, r) {
            var n;
            return e = o(e),
            m.each(e, function(e, o) {
                if (a(o) === i && P.init(o),
                r === i)
                    n === i && (n = I.getPropertyValue(o, t));
                else {
                    var s = I.setPropertyValue(o, t, r);
                    "transform" === s[0] && P.CSS.flushTransformCache(o),
                    n = s
                }
            }),
            n
        }
        ;
        var A = function() {
            function e() {
                return c ? T.promise || null : h
            }
            function n(e, n) {
                function o(o) {
                    var c, f;
                    if (l.begin && 0 === z)
                        try {
                            l.begin.call(v, v)
                        } catch (h) {
                            setTimeout(function() {
                                throw h
                            }, 1)
                        }
                    if ("scroll" === E) {
                        var g, S, C, A = /^x$/i.test(l.axis) ? "Left" : "Top", V = parseFloat(l.offset) || 0;
                        l.container ? b.isWrapped(l.container) || b.isNode(l.container) ? (l.container = l.container[0] || l.container,
                        g = l.container["scroll" + A],
                        C = g + m(e).position()[A.toLowerCase()] + V) : l.container = null : (g = P.State.scrollAnchor[P.State["scrollProperty" + A]],
                        S = P.State.scrollAnchor[P.State["scrollProperty" + ("Left" === A ? "Top" : "Left")]],
                        C = m(e).offset()[A.toLowerCase()] + V),
                        u = {
                            scroll: {
                                rootPropertyValue: !1,
                                startValue: g,
                                currentValue: g,
                                endValue: C,
                                unitType: "",
                                easing: l.easing,
                                scrollData: {
                                    container: l.container,
                                    direction: A,
                                    alternateValue: S
                                }
                            },
                            element: e
                        },
                        P.debug && console.log("tweensContainer (scroll): ", u.scroll, e)
                    } else if ("reverse" === E) {
                        if (c = a(e),
                        !c)
                            return;
                        if (!c.tweensContainer)
                            return void m.dequeue(e, l.queue);
                        "none" === c.opts.display && (c.opts.display = "auto"),
                        "hidden" === c.opts.visibility && (c.opts.visibility = "visible"),
                        c.opts.loop = !1,
                        c.opts.begin = null,
                        c.opts.complete = null,
                        x.easing || delete l.easing,
                        x.duration || delete l.duration,
                        l = m.extend({}, c.opts, l),
                        f = m.extend(!0, {}, c ? c.tweensContainer : null);
                        for (var N in f)
                            if (f.hasOwnProperty(N) && "element" !== N) {
                                var $ = f[N].startValue;
                                f[N].startValue = f[N].currentValue = f[N].endValue,
                                f[N].endValue = $,
                                b.isEmptyObject(x) || (f[N].easing = l.easing),
                                P.debug && console.log("reverse tweensContainer (" + N + "): " + JSON.stringify(f[N]), e)
                            }
                        u = f
                    } else if ("start" === E) {
                        c = a(e),
                        c && c.tweensContainer && c.isAnimating === !0 && (f = c.tweensContainer);
                        var F = function(t, r) {
                            var i, o, a;
                            return b.isFunction(t) && (t = t.call(e, n, k)),
                            b.isArray(t) ? (i = t[0],
                            !b.isArray(t[1]) && /^[\d-]/.test(t[1]) || b.isFunction(t[1]) || I.RegEx.isHex.test(t[1]) ? a = t[1] : b.isString(t[1]) && !I.RegEx.isHex.test(t[1]) && P.Easings[t[1]] || b.isArray(t[1]) ? (o = r ? t[1] : p(t[1], l.duration),
                            a = t[2]) : a = t[1] || t[2]) : i = t,
                            r || (o = o || l.easing),
                            b.isFunction(i) && (i = i.call(e, n, k)),
                            b.isFunction(a) && (a = a.call(e, n, k)),
                            [i || 0, o, a]
                        }
                          , j = function(n, o) {
                            var a, p = I.Hooks.getRoot(n), d = !1, h = o[0], g = o[1], v = o[2];
                            if (!(c && c.isSVG || "tween" === p || I.Names.prefixCheck(p)[1] !== !1 || I.Normalizations.registered[p] !== i))
                                return void (P.debug && console.log("Skipping [" + p + "] due to a lack of browser support."));
                            (l.display !== i && null !== l.display && "none" !== l.display || l.visibility !== i && "hidden" !== l.visibility) && /opacity|filter/.test(n) && !v && 0 !== h && (v = 0),
                            l._cacheValues && f && f[n] ? (v === i && (v = f[n].endValue + f[n].unitType),
                            d = c.rootPropertyValueCache[p]) : I.Hooks.registered[n] ? v === i ? (d = I.getPropertyValue(e, p),
                            v = I.getPropertyValue(e, n, d)) : d = I.Hooks.templates[p][1] : v === i && (v = I.getPropertyValue(e, n));
                            var y, w, x, S = !1, C = function(e, t) {
                                var r, i;
                                return i = (t || "0").toString().toLowerCase().replace(/[%A-z]+$/, function(e) {
                                    return r = e,
                                    ""
                                }),
                                r || (r = I.Values.getUnitType(e)),
                                [i, r]
                            };
                            if (v !== h && b.isString(v) && b.isString(h)) {
                                a = "";
                                var T = 0
                                  , A = 0
                                  , k = []
                                  , z = []
                                  , V = 0
                                  , N = 0
                                  , E = 0;
                                for (v = I.Hooks.fixColors(v),
                                h = I.Hooks.fixColors(h); T < v.length && A < h.length; ) {
                                    var $ = v[T]
                                      , F = h[A];
                                    if (/[\d\.-]/.test($) && /[\d\.-]/.test(F)) {
                                        for (var j = $, M = F, W = ".", L = "."; ++T < v.length; ) {
                                            if ($ = v[T],
                                            $ === W)
                                                W = "..";
                                            else if (!/\d/.test($))
                                                break;
                                            j += $
                                        }
                                        for (; ++A < h.length; ) {
                                            if (F = h[A],
                                            F === L)
                                                L = "..";
                                            else if (!/\d/.test(F))
                                                break;
                                            M += F
                                        }
                                        var H = I.Hooks.getUnit(v, T)
                                          , R = I.Hooks.getUnit(h, A);
                                        if (T += H.length,
                                        A += R.length,
                                        H === R)
                                            j === M ? a += j + H : (a += "{" + k.length + (N ? "!" : "") + "}" + H,
                                            k.push(parseFloat(j)),
                                            z.push(parseFloat(M)));
                                        else {
                                            var D = parseFloat(j)
                                              , q = parseFloat(M);
                                            a += (V < 5 ? "calc" : "") + "(" + (D ? "{" + k.length + (N ? "!" : "") + "}" : "0") + H + " + " + (q ? "{" + (k.length + (D ? 1 : 0)) + (N ? "!" : "") + "}" : "0") + R + ")",
                                            D && (k.push(D),
                                            z.push(0)),
                                            q && (k.push(0),
                                            z.push(q))
                                        }
                                    } else {
                                        if ($ !== F) {
                                            V = 0;
                                            break
                                        }
                                        a += $,
                                        T++,
                                        A++,
                                        0 === V && "c" === $ || 1 === V && "a" === $ || 2 === V && "l" === $ || 3 === V && "c" === $ || V >= 4 && "(" === $ ? V++ : (V && V < 5 || V >= 4 && ")" === $ && --V < 5) && (V = 0),
                                        0 === N && "r" === $ || 1 === N && "g" === $ || 2 === N && "b" === $ || 3 === N && "a" === $ || N >= 3 && "(" === $ ? (3 === N && "a" === $ && (E = 1),
                                        N++) : E && "," === $ ? ++E > 3 && (N = E = 0) : (E && N < (E ? 5 : 4) || N >= (E ? 4 : 3) && ")" === $ && --N < (E ? 5 : 4)) && (N = E = 0)
                                    }
                                }
                                T === v.length && A === h.length || (P.debug && console.error('Trying to pattern match mis-matched strings ["' + h + '", "' + v + '"]'),
                                a = i),
                                a && (k.length ? (P.debug && console.log('Pattern found "' + a + '" -> ', k, z, "[" + v + "," + h + "]"),
                                v = k,
                                h = z,
                                w = x = "") : a = i)
                            }
                            a || (y = C(n, v),
                            v = y[0],
                            x = y[1],
                            y = C(n, h),
                            h = y[0].replace(/^([+-\/*])=/, function(e, t) {
                                return S = t,
                                ""
                            }),
                            w = y[1],
                            v = parseFloat(v) || 0,
                            h = parseFloat(h) || 0,
                            "%" === w && (/^(fontSize|lineHeight)$/.test(n) ? (h /= 100,
                            w = "em") : /^scale/.test(n) ? (h /= 100,
                            w = "") : /(Red|Green|Blue)$/i.test(n) && (h = h / 100 * 255,
                            w = "")));
                            var B = function() {
                                var i = {
                                    myParent: e.parentNode || r.body,
                                    position: I.getPropertyValue(e, "position"),
                                    fontSize: I.getPropertyValue(e, "fontSize")
                                }
                                  , n = i.position === O.lastPosition && i.myParent === O.lastParent
                                  , o = i.fontSize === O.lastFontSize;
                                O.lastParent = i.myParent,
                                O.lastPosition = i.position,
                                O.lastFontSize = i.fontSize;
                                var a = 100
                                  , s = {};
                                if (o && n)
                                    s.emToPx = O.lastEmToPx,
                                    s.percentToPxWidth = O.lastPercentToPxWidth,
                                    s.percentToPxHeight = O.lastPercentToPxHeight;
                                else {
                                    var l = c && c.isSVG ? r.createElementNS("http://www.w3.org/2000/svg", "rect") : r.createElement("div");
                                    P.init(l),
                                    i.myParent.appendChild(l),
                                    m.each(["overflow", "overflowX", "overflowY"], function(e, t) {
                                        P.CSS.setPropertyValue(l, t, "hidden")
                                    }),
                                    P.CSS.setPropertyValue(l, "position", i.position),
                                    P.CSS.setPropertyValue(l, "fontSize", i.fontSize),
                                    P.CSS.setPropertyValue(l, "boxSizing", "content-box"),
                                    m.each(["minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height"], function(e, t) {
                                        P.CSS.setPropertyValue(l, t, a + "%")
                                    }),
                                    P.CSS.setPropertyValue(l, "paddingLeft", a + "em"),
                                    s.percentToPxWidth = O.lastPercentToPxWidth = (parseFloat(I.getPropertyValue(l, "width", null, !0)) || 1) / a,
                                    s.percentToPxHeight = O.lastPercentToPxHeight = (parseFloat(I.getPropertyValue(l, "height", null, !0)) || 1) / a,
                                    s.emToPx = O.lastEmToPx = (parseFloat(I.getPropertyValue(l, "paddingLeft")) || 1) / a,
                                    i.myParent.removeChild(l)
                                }
                                return null === O.remToPx && (O.remToPx = parseFloat(I.getPropertyValue(r.body, "fontSize")) || 16),
                                null === O.vwToPx && (O.vwToPx = parseFloat(t.innerWidth) / 100,
                                O.vhToPx = parseFloat(t.innerHeight) / 100),
                                s.remToPx = O.remToPx,
                                s.vwToPx = O.vwToPx,
                                s.vhToPx = O.vhToPx,
                                P.debug >= 1 && console.log("Unit ratios: " + JSON.stringify(s), e),
                                s
                            };
                            if (/[\/*]/.test(S))
                                w = x;
                            else if (x !== w && 0 !== v)
                                if (0 === h)
                                    w = x;
                                else {
                                    s = s || B();
                                    var _ = /margin|padding|left|right|width|text|word|letter/i.test(n) || /X$/.test(n) || "x" === n ? "x" : "y";
                                    switch (x) {
                                    case "%":
                                        v *= "x" === _ ? s.percentToPxWidth : s.percentToPxHeight;
                                        break;
                                    case "px":
                                        break;
                                    default:
                                        v *= s[x + "ToPx"]
                                    }
                                    switch (w) {
                                    case "%":
                                        v *= 1 / ("x" === _ ? s.percentToPxWidth : s.percentToPxHeight);
                                        break;
                                    case "px":
                                        break;
                                    default:
                                        v *= 1 / s[w + "ToPx"]
                                    }
                                }
                            switch (S) {
                            case "+":
                                h = v + h;
                                break;
                            case "-":
                                h = v - h;
                                break;
                            case "*":
                                h = v * h;
                                break;
                            case "/":
                                h = v / h
                            }
                            u[n] = {
                                rootPropertyValue: d,
                                startValue: v,
                                currentValue: v,
                                endValue: h,
                                unitType: w,
                                easing: g
                            },
                            a && (u[n].pattern = a),
                            P.debug && console.log("tweensContainer (" + n + "): " + JSON.stringify(u[n]), e)
                        };
                        for (var M in y)
                            if (y.hasOwnProperty(M)) {
                                var W = I.Names.camelCase(M)
                                  , H = F(y[M]);
                                if (w(I.Lists.colors, W)) {
                                    var R = H[0]
                                      , D = H[1]
                                      , q = H[2];
                                    if (I.RegEx.isHex.test(R)) {
                                        for (var B = ["Red", "Green", "Blue"], _ = I.Values.hexToRgb(R), X = q ? I.Values.hexToRgb(q) : i, U = 0; U < B.length; U++) {
                                            var Y = [_[U]];
                                            D && Y.push(D),
                                            X !== i && Y.push(X[U]),
                                            j(W + B[U], Y)
                                        }
                                        continue
                                    }
                                }
                                j(W, H)
                            }
                        u.element = e
                    }
                    u.element && (I.Values.addClass(e, "velocity-animating"),
                    L.push(u),
                    c = a(e),
                    c && ("" === l.queue && (c.tweensContainer = u,
                    c.opts = l),
                    c.isAnimating = !0),
                    z === k - 1 ? (P.State.calls.push([L, v, l, null, T.resolver, null, 0]),
                    P.State.isTicking === !1 && (P.State.isTicking = !0,
                    d())) : z++)
                }
                var s, l = m.extend({}, P.defaults, x), u = {};
                switch (a(e) === i && P.init(e),
                parseFloat(l.delay) && l.queue !== !1 && m.queue(e, l.queue, function(t) {
                    P.velocityQueueEntryFlag = !0;
                    var r = P.State.delayedElements.count++;
                    P.State.delayedElements[r] = e;
                    var i = function(e) {
                        return function() {
                            P.State.delayedElements[e] = !1,
                            t()
                        }
                    }(r);
                    a(e).delayBegin = (new Date).getTime(),
                    a(e).delay = parseFloat(l.delay),
                    a(e).delayTimer = {
                        setTimeout: setTimeout(t, parseFloat(l.delay)),
                        next: i
                    }
                }),
                l.duration.toString().toLowerCase()) {
                case "fast":
                    l.duration = 200;
                    break;
                case "normal":
                    l.duration = S;
                    break;
                case "slow":
                    l.duration = 600;
                    break;
                default:
                    l.duration = parseFloat(l.duration) || 1
                }
                if (P.mock !== !1 && (P.mock === !0 ? l.duration = l.delay = 1 : (l.duration *= parseFloat(P.mock) || 1,
                l.delay *= parseFloat(P.mock) || 1)),
                l.easing = p(l.easing, l.duration),
                l.begin && !b.isFunction(l.begin) && (l.begin = null),
                l.progress && !b.isFunction(l.progress) && (l.progress = null),
                l.complete && !b.isFunction(l.complete) && (l.complete = null),
                l.display !== i && null !== l.display && (l.display = l.display.toString().toLowerCase(),
                "auto" === l.display && (l.display = P.CSS.Values.getDisplayType(e))),
                l.visibility !== i && null !== l.visibility && (l.visibility = l.visibility.toString().toLowerCase()),
                l.mobileHA = l.mobileHA && P.State.isMobile && !P.State.isGingerbread,
                l.queue === !1)
                    if (l.delay) {
                        var c = P.State.delayedElements.count++;
                        P.State.delayedElements[c] = e;
                        var f = function(e) {
                            return function() {
                                P.State.delayedElements[e] = !1,
                                o()
                            }
                        }(c);
                        a(e).delayBegin = (new Date).getTime(),
                        a(e).delay = parseFloat(l.delay),
                        a(e).delayTimer = {
                            setTimeout: setTimeout(o, parseFloat(l.delay)),
                            next: f
                        }
                    } else
                        o();
                else
                    m.queue(e, l.queue, function(e, t) {
                        return t === !0 ? (T.promise && T.resolver(v),
                        !0) : (P.velocityQueueEntryFlag = !0,
                        void o(e))
                    });
                "" !== l.queue && "fx" !== l.queue || "inprogress" === m.queue(e)[0] || m.dequeue(e)
            }
            var u, c, h, g, v, y, x, C = arguments[0] && (arguments[0].p || m.isPlainObject(arguments[0].properties) && !arguments[0].properties.names || b.isString(arguments[0].properties));
            b.isWrapped(this) ? (c = !1,
            g = 0,
            v = this,
            h = this) : (c = !0,
            g = 1,
            v = C ? arguments[0].elements || arguments[0].e : arguments[0]);
            var T = {
                promise: null,
                resolver: null,
                rejecter: null
            };
            if (c && P.Promise && (T.promise = new P.Promise(function(e, t) {
                T.resolver = e,
                T.rejecter = t
            }
            )),
            C ? (y = arguments[0].properties || arguments[0].p,
            x = arguments[0].options || arguments[0].o) : (y = arguments[g],
            x = arguments[g + 1]),
            v = o(v),
            !v)
                return void (T.promise && (y && x && x.promiseRejectEmpty === !1 ? T.resolver() : T.rejecter()));
            var k = v.length
              , z = 0;
            if (!/^(stop|finish|finishAll|pause|resume)$/i.test(y) && !m.isPlainObject(x)) {
                var V = g + 1;
                x = {};
                for (var N = V; N < arguments.length; N++)
                    b.isArray(arguments[N]) || !/^(fast|normal|slow)$/i.test(arguments[N]) && !/^\d/.test(arguments[N]) ? b.isString(arguments[N]) || b.isArray(arguments[N]) ? x.easing = arguments[N] : b.isFunction(arguments[N]) && (x.complete = arguments[N]) : x.duration = arguments[N]
            }
            var E;
            switch (y) {
            case "scroll":
                E = "scroll";
                break;
            case "reverse":
                E = "reverse";
                break;
            case "pause":
                var $ = (new Date).getTime();
                return m.each(v, function(e, t) {
                    s(t, $)
                }),
                m.each(P.State.calls, function(e, t) {
                    var r = !1;
                    t && m.each(t[1], function(e, n) {
                        var o = x === i ? "" : x;
                        return o !== !0 && t[2].queue !== o && (x !== i || t[2].queue !== !1) || (m.each(v, function(e, i) {
                            if (i === n)
                                return t[5] = {
                                    resume: !1
                                },
                                r = !0,
                                !1
                        }),
                        !r && void 0)
                    })
                }),
                e();
            case "resume":
                return m.each(v, function(e, t) {
                    l(t, $)
                }),
                m.each(P.State.calls, function(e, t) {
                    var r = !1;
                    t && m.each(t[1], function(e, n) {
                        var o = x === i ? "" : x;
                        return o !== !0 && t[2].queue !== o && (x !== i || t[2].queue !== !1) || (!t[5] || (m.each(v, function(e, i) {
                            if (i === n)
                                return t[5].resume = !0,
                                r = !0,
                                !1
                        }),
                        !r && void 0))
                    })
                }),
                e();
            case "finish":
            case "finishAll":
            case "stop":
                m.each(v, function(e, t) {
                    a(t) && a(t).delayTimer && (clearTimeout(a(t).delayTimer.setTimeout),
                    a(t).delayTimer.next && a(t).delayTimer.next(),
                    delete a(t).delayTimer),
                    "finishAll" !== y || x !== !0 && !b.isString(x) || (m.each(m.queue(t, b.isString(x) ? x : ""), function(e, t) {
                        b.isFunction(t) && t()
                    }),
                    m.queue(t, b.isString(x) ? x : "", []))
                });
                var F = [];
                return m.each(P.State.calls, function(e, t) {
                    t && m.each(t[1], function(r, n) {
                        var o = x === i ? "" : x;
                        return o !== !0 && t[2].queue !== o && (x !== i || t[2].queue !== !1) || void m.each(v, function(r, i) {
                            if (i === n)
                                if ((x === !0 || b.isString(x)) && (m.each(m.queue(i, b.isString(x) ? x : ""), function(e, t) {
                                    b.isFunction(t) && t(null, !0)
                                }),
                                m.queue(i, b.isString(x) ? x : "", [])),
                                "stop" === y) {
                                    var s = a(i);
                                    s && s.tweensContainer && o !== !1 && m.each(s.tweensContainer, function(e, t) {
                                        t.endValue = t.currentValue
                                    }),
                                    F.push(e)
                                } else
                                    "finish" !== y && "finishAll" !== y || (t[2].duration = 1)
                        })
                    })
                }),
                "stop" === y && (m.each(F, function(e, t) {
                    f(t, !0)
                }),
                T.promise && T.resolver(v)),
                e();
            default:
                if (!m.isPlainObject(y) || b.isEmptyObject(y)) {
                    if (b.isString(y) && P.Redirects[y]) {
                        u = m.extend({}, x);
                        var j = u.duration
                          , M = u.delay || 0;
                        return u.backwards === !0 && (v = m.extend(!0, [], v).reverse()),
                        m.each(v, function(e, t) {
                            parseFloat(u.stagger) ? u.delay = M + parseFloat(u.stagger) * e : b.isFunction(u.stagger) && (u.delay = M + u.stagger.call(t, e, k)),
                            u.drag && (u.duration = parseFloat(j) || (/^(callout|transition)/.test(y) ? 1e3 : S),
                            u.duration = Math.max(u.duration * (u.backwards ? 1 - e / k : (e + 1) / k), .75 * u.duration, 200)),
                            P.Redirects[y].call(t, t, u || {}, e, k, v, T.promise ? T : i)
                        }),
                        e()
                    }
                    var W = "Velocity: First argument (" + y + ") was not a property map, a known action, or a registered redirect. Aborting.";
                    return T.promise ? T.rejecter(new Error(W)) : t.console && console.log(W),
                    e()
                }
                E = "start"
            }
            var O = {
                lastParent: null,
                lastPosition: null,
                lastFontSize: null,
                lastPercentToPxWidth: null,
                lastPercentToPxHeight: null,
                lastEmToPx: null,
                remToPx: null,
                vwToPx: null,
                vhToPx: null
            }
              , L = [];
            m.each(v, function(e, t) {
                b.isNode(t) && n(t, e)
            }),
            u = m.extend({}, P.defaults, x),
            u.loop = parseInt(u.loop, 10);
            var H = 2 * u.loop - 1;
            if (u.loop)
                for (var R = 0; R < H; R++) {
                    var D = {
                        delay: u.delay,
                        progress: u.progress
                    };
                    R === H - 1 && (D.display = u.display,
                    D.visibility = u.visibility,
                    D.complete = u.complete),
                    A(v, "reverse", D)
                }
            return e()
        };
        P = m.extend(A, P),
        P.animate = A;
        var k = t.requestAnimationFrame || g;
        if (!P.State.isMobile && r.hidden !== i) {
            var z = function() {
                r.hidden ? (k = function(e) {
                    return setTimeout(function() {
                        e(!0)
                    }, 16)
                }
                ,
                d()) : k = t.requestAnimationFrame || g
            };
            z(),
            r.addEventListener("visibilitychange", z)
        }
        return e.Velocity = P,
        e !== t && (e.fn.velocity = A,
        e.fn.velocity.defaults = P.defaults),
        m.each(["Down", "Up"], function(e, t) {
            P.Redirects["slide" + t] = function(e, r, n, o, a, s) {
                var l = m.extend({}, r)
                  , u = l.begin
                  , c = l.complete
                  , p = {}
                  , d = {
                    height: "",
                    marginTop: "",
                    marginBottom: "",
                    paddingTop: "",
                    paddingBottom: ""
                };
                l.display === i && (l.display = "Down" === t ? "inline" === P.CSS.Values.getDisplayType(e) ? "inline-block" : "block" : "none"),
                l.begin = function() {
                    0 === n && u && u.call(a, a);
                    for (var r in d)
                        if (d.hasOwnProperty(r)) {
                            p[r] = e.style[r];
                            var i = I.getPropertyValue(e, r);
                            d[r] = "Down" === t ? [i, 0] : [0, i]
                        }
                    p.overflow = e.style.overflow,
                    e.style.overflow = "hidden"
                }
                ,
                l.complete = function() {
                    for (var t in p)
                        p.hasOwnProperty(t) && (e.style[t] = p[t]);
                    n === o - 1 && (c && c.call(a, a),
                    s && s.resolver(a))
                }
                ,
                P(e, d, l)
            }
        }),
        m.each(["In", "Out"], function(e, t) {
            P.Redirects["fade" + t] = function(e, r, n, o, a, s) {
                var l = m.extend({}, r)
                  , u = l.complete
                  , c = {
                    opacity: "In" === t ? 1 : 0
                };
                0 !== n && (l.begin = null),
                n !== o - 1 ? l.complete = null : l.complete = function() {
                    u && u.call(a, a),
                    s && s.resolver(a)
                }
                ,
                l.display === i && (l.display = "In" === t ? "auto" : "none"),
                P(this, c, l)
            }
        }),
        P
    }(window.jQuery || window.Zepto || window, window, window ? window.document : void 0)
}),
function(e, t) {
    var r = t(e, e.document);
    e.lazySizes = r,
    "object" == typeof module && module.exports && (module.exports = r)
}(window, function(e, t) {
    "use strict";
    if (t.getElementsByClassName) {
        var r, i, n = t.documentElement, o = e.Date, a = e.HTMLPictureElement, s = "addEventListener", l = "getAttribute", u = e[s], c = e.setTimeout, p = e.requestAnimationFrame || c, d = e.requestIdleCallback, f = /^picture$/i, m = ["load", "error", "lazyincluded", "_lazyloaded"], h = {}, g = Array.prototype.forEach, v = function(e, t) {
            return h[t] || (h[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")),
            h[t].test(e[l]("class") || "") && h[t]
        }, y = function(e, t) {
            v(e, t) || e.setAttribute("class", (e[l]("class") || "").trim() + " " + t)
        }, w = function(e, t) {
            var r;
            (r = v(e, t)) && e.setAttribute("class", (e[l]("class") || "").replace(r, " "))
        }, b = function(e, t, r) {
            var i = r ? s : "removeEventListener";
            r && b(e, t),
            m.forEach(function(r) {
                e[i](r, t)
            })
        }, x = function(e, i, n, o, a) {
            var s = t.createEvent("CustomEvent");
            return n || (n = {}),
            n.instance = r,
            s.initCustomEvent(i, !o, !a, n),
            e.dispatchEvent(s),
            s
        }, S = function(t, r) {
            var n;
            !a && (n = e.picturefill || i.pf) ? n({
                reevaluate: !0,
                elements: [t]
            }) : r && r.src && (t.src = r.src)
        }, C = function(e, t) {
            return (getComputedStyle(e, null) || {})[t]
        }, P = function(e, t, r) {
            for (r = r || e.offsetWidth; r < i.minSize && t && !e._lazysizesWidth; )
                r = t.offsetWidth,
                t = t.parentNode;
            return r
        }, T = function() {
            var e, r, i = [], n = [], o = i, a = function() {
                var t = o;
                for (o = i.length ? n : i,
                e = !0,
                r = !1; t.length; )
                    t.shift()();
                e = !1
            }, s = function(i, n) {
                e && !n ? i.apply(this, arguments) : (o.push(i),
                r || (r = !0,
                (t.hidden ? c : p)(a)))
            };
            return s._lsFlush = a,
            s
        }(), I = function(e, t) {
            return t ? function() {
                T(e)
            }
            : function() {
                var t = this
                  , r = arguments;
                T(function() {
                    e.apply(t, r)
                })
            }
        }, A = function(e) {
            var t, r = 0, n = 125, a = i.ricTimeout, s = function() {
                t = !1,
                r = o.now(),
                e()
            }, l = d && i.ricTimeout ? function() {
                d(s, {
                    timeout: a
                }),
                a !== i.ricTimeout && (a = i.ricTimeout)
            }
            : I(function() {
                c(s)
            }, !0);
            return function(e) {
                var i;
                (e = e === !0) && (a = 33),
                t || (t = !0,
                i = n - (o.now() - r),
                i < 0 && (i = 0),
                e || i < 9 && d ? l() : c(l, i))
            }
        }, k = function(e) {
            var t, r, i = 99, n = function() {
                t = null,
                e()
            }, a = function() {
                var e = o.now() - r;
                e < i ? c(a, i - e) : (d || n)(n)
            };
            return function() {
                r = o.now(),
                t || (t = c(a, i))
            }
        };
        !function() {
            var t, r = {
                lazyClass: "lazyload",
                loadedClass: "lazyloaded",
                loadingClass: "lazyloading",
                preloadClass: "lazypreload",
                errorClass: "lazyerror",
                autosizesClass: "lazyautosizes",
                srcAttr: "data-src",
                srcsetAttr: "data-srcset",
                sizesAttr: "data-sizes",
                minSize: 40,
                customMedia: {},
                init: !0,
                expFactor: 1.5,
                hFac: .8,
                loadMode: 2,
                loadHidden: !0,
                ricTimeout: 300
            };
            i = e.lazySizesConfig || e.lazysizesConfig || {};
            for (t in r)
                t in i || (i[t] = r[t]);
            e.lazySizesConfig = i,
            c(function() {
                i.init && N()
            })
        }();
        var z = function() {
            var a, p, d, m, h, P, z, N, E, $, F, j, M, W, O = /^img$/i, L = /^iframe$/i, H = "onscroll"in e && !/glebot/.test(navigator.userAgent), R = 0, D = 0, q = 0, B = -1, _ = function(e) {
                q--,
                e && e.target && b(e.target, _),
                (!e || q < 0 || !e.target) && (q = 0)
            }, X = function(e, r) {
                var i, o = e, a = "hidden" == C(t.body, "visibility") || "hidden" != C(e, "visibility");
                for (N -= r,
                F += r,
                E -= r,
                $ += r; a && (o = o.offsetParent) && o != t.body && o != n; )
                    a = (C(o, "opacity") || 1) > 0,
                    a && "visible" != C(o, "overflow") && (i = o.getBoundingClientRect(),
                    a = $ > i.left && E < i.right && F > i.top - 1 && N < i.bottom + 1);
                return a
            }, U = function() {
                var e, o, s, u, c, d, f, h, g, v = r.elements;
                if ((m = i.loadMode) && q < 8 && (e = v.length)) {
                    o = 0,
                    B++,
                    null == M && ("expand"in i || (i.expand = n.clientHeight > 500 && n.clientWidth > 500 ? 500 : 370),
                    j = i.expand,
                    M = j * i.expFactor),
                    D < M && q < 1 && B > 2 && m > 2 && !t.hidden ? (D = M,
                    B = 0) : D = m > 1 && B > 1 && q < 6 ? j : R;
                    for (; o < e; o++)
                        if (v[o] && !v[o]._lazyRace)
                            if (H)
                                if ((h = v[o][l]("data-expand")) && (d = 1 * h) || (d = D),
                                g !== d && (P = innerWidth + d * W,
                                z = innerHeight + d,
                                f = d * -1,
                                g = d),
                                s = v[o].getBoundingClientRect(),
                                (F = s.bottom) >= f && (N = s.top) <= z && ($ = s.right) >= f * W && (E = s.left) <= P && (F || $ || E || N) && (i.loadHidden || "hidden" != C(v[o], "visibility")) && (p && q < 3 && !h && (m < 3 || B < 4) || X(v[o], d))) {
                                    if (te(v[o]),
                                    c = !0,
                                    q > 9)
                                        break
                                } else
                                    !c && p && !u && q < 4 && B < 4 && m > 2 && (a[0] || i.preloadAfterLoad) && (a[0] || !h && (F || $ || E || N || "auto" != v[o][l](i.sizesAttr))) && (u = a[0] || v[o]);
                            else
                                te(v[o]);
                    u && !c && te(u)
                }
            }, Y = A(U), G = function(e) {
                y(e.target, i.loadedClass),
                w(e.target, i.loadingClass),
                b(e.target, Z),
                x(e.target, "lazyloaded")
            }, Q = I(G), Z = function(e) {
                Q({
                    target: e.target
                })
            }, J = function(e, t) {
                try {
                    e.contentWindow.location.replace(t)
                } catch (r) {
                    e.src = t
                }
            }, K = function(e) {
                var t, r = e[l](i.srcsetAttr);
                (t = i.customMedia[e[l]("data-media") || e[l]("media")]) && e.setAttribute("media", t),
                r && e.setAttribute("srcset", r)
            }, ee = I(function(e, t, r, n, o) {
                var a, s, u, p, m, h;
                (m = x(e, "lazybeforeunveil", t)).defaultPrevented || (n && (r ? y(e, i.autosizesClass) : e.setAttribute("sizes", n)),
                s = e[l](i.srcsetAttr),
                a = e[l](i.srcAttr),
                o && (u = e.parentNode,
                p = u && f.test(u.nodeName || "")),
                h = t.firesLoad || "src"in e && (s || a || p),
                m = {
                    target: e
                },
                h && (b(e, _, !0),
                clearTimeout(d),
                d = c(_, 2500),
                y(e, i.loadingClass),
                b(e, Z, !0)),
                p && g.call(u.getElementsByTagName("source"), K),
                s ? e.setAttribute("srcset", s) : a && !p && (L.test(e.nodeName) ? J(e, a) : e.src = a),
                o && (s || p) && S(e, {
                    src: a
                })),
                e._lazyRace && delete e._lazyRace,
                w(e, i.lazyClass),
                T(function() {
                    (!h || e.complete && e.naturalWidth > 1) && (h ? _(m) : q--,
                    G(m))
                }, !0)
            }), te = function(e) {
                var t, r = O.test(e.nodeName), n = r && (e[l](i.sizesAttr) || e[l]("sizes")), o = "auto" == n;
                (!o && p || !r || !e[l]("src") && !e.srcset || e.complete || v(e, i.errorClass) || !v(e, i.lazyClass)) && (t = x(e, "lazyunveilread").detail,
                o && V.updateElem(e, !0, e.offsetWidth),
                e._lazyRace = !0,
                q++,
                ee(e, t, o, n, r))
            }, re = function() {
                if (!p) {
                    if (o.now() - h < 999)
                        return void c(re, 999);
                    var e = k(function() {
                        i.loadMode = 3,
                        Y()
                    });
                    p = !0,
                    i.loadMode = 3,
                    Y(),
                    u("scroll", function() {
                        3 == i.loadMode && (i.loadMode = 2),
                        e()
                    }, !0)
                }
            };
            return {
                _: function() {
                    h = o.now(),
                    r.elements = t.getElementsByClassName(i.lazyClass),
                    a = t.getElementsByClassName(i.lazyClass + " " + i.preloadClass),
                    W = i.hFac,
                    u("scroll", Y, !0),
                    u("resize", Y, !0),
                    e.MutationObserver ? new MutationObserver(Y).observe(n, {
                        childList: !0,
                        subtree: !0,
                        attributes: !0
                    }) : (n[s]("DOMNodeInserted", Y, !0),
                    n[s]("DOMAttrModified", Y, !0),
                    setInterval(Y, 999)),
                    u("hashchange", Y, !0),
                    ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function(e) {
                        t[s](e, Y, !0)
                    }),
                    /d$|^c/.test(t.readyState) ? re() : (u("load", re),
                    t[s]("DOMContentLoaded", Y),
                    c(re, 2e4)),
                    r.elements.length ? (U(),
                    T._lsFlush()) : Y()
                },
                checkElems: Y,
                unveil: te
            }
        }()
          , V = function() {
            var e, r = I(function(e, t, r, i) {
                var n, o, a;
                if (e._lazysizesWidth = i,
                i += "px",
                e.setAttribute("sizes", i),
                f.test(t.nodeName || ""))
                    for (n = t.getElementsByTagName("source"),
                    o = 0,
                    a = n.length; o < a; o++)
                        n[o].setAttribute("sizes", i);
                r.detail.dataAttr || S(e, r.detail)
            }), n = function(e, t, i) {
                var n, o = e.parentNode;
                o && (i = P(e, o, i),
                n = x(e, "lazybeforesizes", {
                    width: i,
                    dataAttr: !!t
                }),
                n.defaultPrevented || (i = n.detail.width,
                i && i !== e._lazysizesWidth && r(e, o, n, i)))
            }, o = function() {
                var t, r = e.length;
                if (r)
                    for (t = 0; t < r; t++)
                        n(e[t])
            }, a = k(o);
            return {
                _: function() {
                    e = t.getElementsByClassName(i.autosizesClass),
                    u("resize", a)
                },
                checkElems: a,
                updateElem: n
            }
        }()
          , N = function() {
            N.i || (N.i = !0,
            V._(),
            z._())
        };
        return r = {
            cfg: i,
            autoSizer: V,
            loader: z,
            init: N,
            uP: S,
            aC: y,
            rC: w,
            hC: v,
            fire: x,
            gW: P,
            rAF: T
        }
    }
}),
function(e, t) {
    var r = function() {
        t(e.lazySizes),
        e.removeEventListener("lazyunveilread", r, !0)
    };
    t = t.bind(null, e, e.document),
    "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? r() : e.addEventListener("lazyunveilread", r, !0)
}(window, function(e, t, r) {
    "use strict";
    function i(t, r) {
        var i, n, o, a, s = e.getComputedStyle(t);
        n = t.parentNode,
        a = {
            isPicture: !(!n || !d.test(n.nodeName || ""))
        },
        o = function(e, r) {
            var i = t.getAttribute("data-" + e);
            if (!i) {
                var n = s.getPropertyValue("--ls-" + e);
                n && (i = n.trim())
            }
            if (i) {
                if ("true" == i)
                    i = !0;
                else if ("false" == i)
                    i = !1;
                else if (p.test(i))
                    i = parseFloat(i);
                else if ("function" == typeof u[e])
                    i = u[e](t, i);
                else if (g.test(i))
                    try {
                        i = JSON.parse(i)
                    } catch (o) {}
                a[e] = i
            } else
                e in u && "function" != typeof u[e] ? a[e] = u[e] : r && "function" == typeof u[e] && (a[e] = u[e](t, i))
        }
        ;
        for (i in u)
            o(i);
        return r.replace(h, function(e, t) {
            t in a || o(t, !0)
        }),
        a
    }
    function n(e, t) {
        var r = []
          , i = function(e, r) {
            return c[typeof t[r]] ? t[r] : e
        };
        return r.srcset = [],
        t.absUrl && (y.setAttribute("href", e),
        e = y.href),
        e = ((t.prefix || "") + e + (t.postfix || "")).replace(h, i),
        t.widths.forEach(function(i) {
            var n = t.widthmap[i] || i
              , o = {
                u: e.replace(f, n).replace(m, t.ratio ? Math.round(i * t.ratio) : ""),
                w: i
            };
            r.push(o),
            r.srcset.push(o.c = o.u + " " + i + "w")
        }),
        r
    }
    function o(e, r, i) {
        var o = 0
          , a = 0
          , s = i;
        if (e) {
            if ("container" === r.ratio) {
                for (o = s.scrollWidth,
                a = s.scrollHeight; !(o && a || s === t); )
                    s = s.parentNode,
                    o = s.scrollWidth,
                    a = s.scrollHeight;
                o && a && (r.ratio = a / o)
            }
            e = n(e, r),
            e.isPicture = r.isPicture,
            b && "IMG" == i.nodeName.toUpperCase() ? i.removeAttribute(l.srcsetAttr) : i.setAttribute(l.srcsetAttr, e.srcset.join(", ")),
            Object.defineProperty(i, "_lazyrias", {
                value: e,
                writable: !0
            })
        }
    }
    function a(e, t) {
        var n = i(e, t);
        return u.modifyOptions.call(e, {
            target: e,
            details: n,
            detail: n
        }),
        r.fire(e, "lazyriasmodifyoptions", n),
        n
    }
    function s(e) {
        return e.getAttribute(e.getAttribute("data-srcattr") || u.srcAttr) || e.getAttribute(l.srcsetAttr) || e.getAttribute(l.srcAttr) || e.getAttribute("data-pfsrcset") || ""
    }
    var l, u, c = {
        string: 1,
        number: 1
    }, p = /^\-*\+*\d+\.*\d*$/, d = /^picture$/i, f = /\s*\{\s*width\s*\}\s*/i, m = /\s*\{\s*height\s*\}\s*/i, h = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, g = /^\[.*\]|\{.*\}$/, v = /^(?:auto|\d+(px)?)$/, y = t.createElement("a"), w = t.createElement("img"), b = "srcset"in w && !("sizes"in w), x = !!e.HTMLPictureElement && !b;
    !function() {
        var t, i = function() {}, n = {
            prefix: "",
            postfix: "",
            srcAttr: "data-src",
            absUrl: !1,
            modifyOptions: i,
            widthmap: {},
            ratio: !1
        };
        l = r && r.cfg || e.lazySizesConfig,
        l || (l = {},
        e.lazySizesConfig = l),
        l.supportsType || (l.supportsType = function(e) {
            return !e
        }
        ),
        l.rias || (l.rias = {}),
        u = l.rias,
        "widths"in u || (u.widths = [],
        function(e) {
            for (var t, r = 0; !t || t < 3e3; )
                r += 5,
                r > 30 && (r += 1),
                t = 36 * r,
                e.push(t)
        }(u.widths));
        for (t in n)
            t in u || (u[t] = n[t])
    }(),
    addEventListener("lazybeforesizes", function(e) {
        if (e.detail.instance == r) {
            var t, i, n, c, p, d, m, h, g, y, w, b, C;
            if (t = e.target,
            e.detail.dataAttr && !e.defaultPrevented && !u.disabled && (g = t.getAttribute(l.sizesAttr) || t.getAttribute("sizes")) && v.test(g)) {
                if (i = s(t),
                n = a(t, i),
                w = f.test(n.prefix) || f.test(n.postfix),
                n.isPicture && (c = t.parentNode))
                    for (p = c.getElementsByTagName("source"),
                    d = 0,
                    m = p.length; d < m; d++)
                        (w || f.test(h = s(p[d]))) && (o(h, n, p[d]),
                        b = !0);
                w || f.test(i) ? (o(i, n, t),
                b = !0) : b && (C = [],
                C.srcset = [],
                C.isPicture = !0,
                Object.defineProperty(t, "_lazyrias", {
                    value: C,
                    writable: !0
                })),
                b && (x ? t.removeAttribute(l.srcAttr) : "auto" != g && (y = {
                    width: parseInt(g, 10)
                },
                S({
                    target: t,
                    detail: y
                })))
            }
        }
    }, !0);
    var S = function() {
        var i = function(e, t) {
            return e.w - t.w
        }
          , n = function(e) {
            var t, r, i = e.length, n = e[i - 1], o = 0;
            for (o; o < i; o++)
                if (n = e[o],
                n.d = n.w / e.w,
                n.d >= e.d) {
                    !n.cached && (t = e[o - 1]) && t.d > e.d - .13 * Math.pow(e.d, 2.2) && (r = Math.pow(t.d - .6, 1.6),
                    t.cached && (t.d += .15 * r),
                    t.d + (n.d - e.d) * r > e.d && (n = t));
                    break
                }
            return n
        }
          , o = function(e, t) {
            var i;
            return !e._lazyrias && r.pWS && (i = r.pWS(e.getAttribute(l.srcsetAttr || ""))).length && (Object.defineProperty(e, "_lazyrias", {
                value: i,
                writable: !0
            }),
            t && e.parentNode && (i.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase())),
            e._lazyrias
        }
          , a = function(t) {
            var i = e.devicePixelRatio || 1
              , n = r.getX && r.getX(t);
            return Math.min(n || i, 2.4, i)
        }
          , s = function(t, r) {
            var s, l, u, c, p, d;
            if (p = t._lazyrias,
            p.isPicture && e.matchMedia)
                for (l = 0,
                s = t.parentNode.getElementsByTagName("source"),
                u = s.length; l < u; l++)
                    if (o(s[l]) && !s[l].getAttribute("type") && (!(c = s[l].getAttribute("media")) || (matchMedia(c) || {}).matches)) {
                        p = s[l]._lazyrias;
                        break
                    }
            return (!p.w || p.w < r) && (p.w = r,
            p.d = a(t),
            d = n(p.sort(i))),
            d
        }
          , u = function(i) {
            if (i.detail.instance == r) {
                var n, a = i.target;
                return !b && (e.respimage || e.picturefill || lazySizesConfig.pf) ? void t.removeEventListener("lazybeforesizes", u) : void (("_lazyrias"in a || i.detail.dataAttr && o(a, !0)) && (n = s(a, i.detail.width),
                n && n.u && a._lazyrias.cur != n.u && (a._lazyrias.cur = n.u,
                n.cached = !0,
                r.rAF(function() {
                    a.setAttribute(l.srcAttr, n.u),
                    a.setAttribute("src", n.u)
                }))))
            }
        };
        return x ? u = function() {}
        : addEventListener("lazybeforesizes", u),
        u
    }()
}),
function(e) {
    "use strict";
    e.fn.fitVids = function(t) {
        var r = {
            customSelector: null,
            ignore: null
        };
        if (!document.getElementById("fit-vids-style")) {
            var i = document.head || document.getElementsByTagName("head")[0]
              , n = ".fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}"
              , o = document.createElement("div");
            o.innerHTML = '<p>x</p><style id="fit-vids-style">' + n + "</style>",
            i.appendChild(o.childNodes[1])
        }
        return t && e.extend(r, t),
        this.each(function() {
            var t = ['iframe[src*="player.vimeo.com"]', 'iframe[src*="youtube.com"]', 'iframe[src*="youtube-nocookie.com"]', 'iframe[src*="kickstarter.com"][src*="video.html"]', "object", "embed"];
            r.customSelector && t.push(r.customSelector);
            var i = ".fitvidsignore";
            r.ignore && (i = i + ", " + r.ignore);
            var n = e(this).find(t.join(","));
            n = n.not("object object"),
            n = n.not(i),
            n.each(function() {
                var t = e(this);
                if (!(t.parents(i).length > 0 || "embed" === this.tagName.toLowerCase() && t.parent("object").length || t.parent(".fluid-width-video-wrapper").length)) {
                    t.css("height") || t.css("width") || !isNaN(t.attr("height")) && !isNaN(t.attr("width")) || (t.attr("height", 9),
                    t.attr("width", 16));
                    var r = "object" === this.tagName.toLowerCase() || t.attr("height") && !isNaN(parseInt(t.attr("height"), 10)) ? parseInt(t.attr("height"), 10) : t.height()
                      , n = isNaN(parseInt(t.attr("width"), 10)) ? t.width() : parseInt(t.attr("width"), 10)
                      , o = r / n;
                    if (!t.attr("name")) {
                        var a = "fitvid" + e.fn.fitVids._count;
                        t.attr("name", a),
                        e.fn.fitVids._count++
                    }
                    t.wrap('<div class="fluid-width-video-wrapper"></div>').parent(".fluid-width-video-wrapper").css("padding-top", 100 * o + "%"),
                    t.removeAttr("height").removeAttr("width")
                }
            })
        })
    }
    ,
    e.fn.fitVids._count = 0
}(window.jQuery || window.Zepto),
/*! scrollreveal.min.js */
!function() {
    "use strict";
    function t(n) {
        return "undefined" == typeof this || Object.getPrototypeOf(this) !== t.prototype ? new t(n) : (T = this,
        T.version = "3.3.6",
        T.tools = new C,
        T.isSupported() ? (T.tools.extend(T.defaults, n || {}),
        T.defaults.container = e(T.defaults),
        T.store = {
            elements: {},
            containers: []
        },
        T.sequences = {},
        T.history = [],
        T.uid = 0,
        T.initialized = !1) : "undefined" != typeof console && null !== console,
        T)
    }
    function e(t) {
        if (t && t.container) {
            if ("string" == typeof t.container)
                return window.document.documentElement.querySelector(t.container);
            if (T.tools.isNode(t.container))
                return t.container
        }
        return T.defaults.container
    }
    function n(t, e) {
        return "string" == typeof t ? Array.prototype.slice.call(e.querySelectorAll(t)) : T.tools.isNode(t) ? [t] : T.tools.isNodeList(t) ? Array.prototype.slice.call(t) : []
    }
    function i() {
        return ++T.uid
    }
    function r(t, e, n) {
        e.container && (e.container = n),
        t.config ? t.config = T.tools.extendClone(t.config, e) : t.config = T.tools.extendClone(T.defaults, e),
        "top" === t.config.origin || "bottom" === t.config.origin ? t.config.axis = "Y" : t.config.axis = "X"
    }
    function o(t) {
        var e = window.getComputedStyle(t.domEl);
        t.styles || (t.styles = {
            transition: {},
            transform: {},
            computed: {}
        },
        t.styles.inline = t.domEl.getAttribute("style") || "",
        t.styles.inline += "; visibility: visible; ",
        t.styles.computed.opacity = e.opacity,
        e.transition && "all 0s ease 0s" !== e.transition ? t.styles.computed.transition = e.transition + ", " : t.styles.computed.transition = ""),
        t.styles.transition.instant = s(t, 0),
        t.styles.transition.delayed = s(t, t.config.delay),
        t.styles.transform.initial = " -webkit-transform:",
        t.styles.transform.target = " -webkit-transform:",
        a(t),
        t.styles.transform.initial += "transform:",
        t.styles.transform.target += "transform:",
        a(t)
    }
    function s(t, e) {
        var n = t.config;
        return "-webkit-transition: " + t.styles.computed.transition + "-webkit-transform " + n.duration / 1e3 + "s " + n.easing + " " + e / 1e3 + "s, opacity " + n.duration / 1e3 + "s " + n.easing + " " + e / 1e3 + "s; transition: " + t.styles.computed.transition + "transform " + n.duration / 1e3 + "s " + n.easing + " " + e / 1e3 + "s, opacity " + n.duration / 1e3 + "s " + n.easing + " " + e / 1e3 + "s; "
    }
    function a(t) {
        var e, n = t.config, i = t.styles.transform;
        e = "top" === n.origin || "left" === n.origin ? /^-/.test(n.distance) ? n.distance.substr(1) : "-" + n.distance : n.distance,
        parseInt(n.distance) && (i.initial += " translate" + n.axis + "(" + e + ")",
        i.target += " translate" + n.axis + "(0)"),
        n.scale && (i.initial += " scale(" + n.scale + ")",
        i.target += " scale(1)"),
        n.rotate.x && (i.initial += " rotateX(" + n.rotate.x + "deg)",
        i.target += " rotateX(0)"),
        n.rotate.y && (i.initial += " rotateY(" + n.rotate.y + "deg)",
        i.target += " rotateY(0)"),
        n.rotate.z && (i.initial += " rotateZ(" + n.rotate.z + "deg)",
        i.target += " rotateZ(0)"),
        i.initial += "; opacity: " + n.opacity + ";",
        i.target += "; opacity: " + t.styles.computed.opacity + ";"
    }
    function l(t) {
        var e = t.config.container;
        e && T.store.containers.indexOf(e) === -1 && T.store.containers.push(t.config.container),
        T.store.elements[t.id] = t
    }
    function u(t, e, n) {
        var i = {
            target: t,
            config: e,
            interval: n
        };
        T.history.push(i)
    }
    function c() {
        if (T.isSupported()) {
            p();
            for (var t = 0; t < T.store.containers.length; t++)
                T.store.containers[t].addEventListener("scroll", d),
                T.store.containers[t].addEventListener("resize", d);
            T.initialized || (window.addEventListener("scroll", d),
            window.addEventListener("resize", d),
            T.initialized = !0)
        }
        return T
    }
    function d() {
        k(p)
    }
    function f() {
        var t, e, n, i;
        T.tools.forOwn(T.sequences, function(r) {
            i = T.sequences[r],
            t = !1;
            for (var o = 0; o < i.elemIds.length; o++)
                n = i.elemIds[o],
                e = T.store.elements[n],
                x(e) && !t && (t = !0);
            i.active = t
        })
    }
    function p() {
        var t, e;
        f(),
        T.tools.forOwn(T.store.elements, function(n) {
            e = T.store.elements[n],
            t = v(e),
            m(e) ? (e.config.beforeReveal(e.domEl),
            t ? e.domEl.setAttribute("style", e.styles.inline + e.styles.transform.target + e.styles.transition.delayed) : e.domEl.setAttribute("style", e.styles.inline + e.styles.transform.target + e.styles.transition.instant),
            g("reveal", e, t),
            e.revealing = !0,
            e.seen = !0,
            e.sequence && h(e, t)) : y(e) && (e.config.beforeReset(e.domEl),
            e.domEl.setAttribute("style", e.styles.inline + e.styles.transform.initial + e.styles.transition.instant),
            g("reset", e),
            e.revealing = !1)
        })
    }
    function h(t, e) {
        var n = 0
          , i = 0
          , r = T.sequences[t.sequence.id];
        r.blocked = !0,
        e && "onload" === t.config.useDelay && (i = t.config.delay),
        t.sequence.timer && (n = Math.abs(t.sequence.timer.started - new Date),
        window.clearTimeout(t.sequence.timer)),
        t.sequence.timer = {
            started: new Date
        },
        t.sequence.timer.clock = window.setTimeout(function() {
            r.blocked = !1,
            t.sequence.timer = null,
            d()
        }, Math.abs(r.interval) + i - n)
    }
    function g(t, e, n) {
        var i = 0
          , r = 0
          , o = "after";
        switch (t) {
        case "reveal":
            r = e.config.duration,
            n && (r += e.config.delay),
            o += "Reveal";
            break;
        case "reset":
            r = e.config.duration,
            o += "Reset"
        }
        e.timer && (i = Math.abs(e.timer.started - new Date),
        window.clearTimeout(e.timer.clock)),
        e.timer = {
            started: new Date
        },
        e.timer.clock = window.setTimeout(function() {
            e.config[o](e.domEl),
            e.timer = null
        }, r - i)
    }
    function m(t) {
        if (t.sequence) {
            var e = T.sequences[t.sequence.id];
            return e.active && !e.blocked && !t.revealing && !t.disabled
        }
        return x(t) && !t.revealing && !t.disabled
    }
    function v(t) {
        var e = t.config.useDelay;
        return "always" === e || "onload" === e && !T.initialized || "once" === e && !t.seen
    }
    function y(t) {
        if (t.sequence) {
            var e = T.sequences[t.sequence.id];
            return !e.active && t.config.reset && t.revealing && !t.disabled
        }
        return !x(t) && t.config.reset && t.revealing && !t.disabled
    }
    function b(t) {
        return {
            width: t.clientWidth,
            height: t.clientHeight
        }
    }
    function _(t) {
        if (t && t !== window.document.documentElement) {
            var e = w(t);
            return {
                x: t.scrollLeft + e.left,
                y: t.scrollTop + e.top
            }
        }
        return {
            x: window.pageXOffset,
            y: window.pageYOffset
        }
    }
    function w(t) {
        var e = 0
          , n = 0
          , i = t.offsetHeight
          , r = t.offsetWidth;
        do
            isNaN(t.offsetTop) || (e += t.offsetTop),
            isNaN(t.offsetLeft) || (n += t.offsetLeft),
            t = t.offsetParent;
        while (t);
        return {
            top: e,
            left: n,
            height: i,
            width: r
        }
    }
    function x(t) {
        function e() {
            var e = u + a * s
              , n = c + l * s
              , i = d - a * s
              , p = f - l * s
              , h = o.y + t.config.viewOffset.top
              , g = o.x + t.config.viewOffset.left
              , m = o.y - t.config.viewOffset.bottom + r.height
              , v = o.x - t.config.viewOffset.right + r.width;
            return e < m && i > h && n < v && p > g
        }
        function n() {
            return "fixed" === window.getComputedStyle(t.domEl).position
        }
        var i = w(t.domEl)
          , r = b(t.config.container)
          , o = _(t.config.container)
          , s = t.config.viewFactor
          , a = i.height
          , l = i.width
          , u = i.top
          , c = i.left
          , d = u + a
          , f = c + l;
        return e() || n()
    }
    function C() {}
    var T, k;
    t.prototype.defaults = {
        origin: "bottom",
        distance: "20px",
        duration: 500,
        delay: 0,
        rotate: {
            x: 0,
            y: 0,
            z: 0
        },
        opacity: 0,
        scale: .9,
        easing: "cubic-bezier(0.6, 0.2, 0.1, 1)",
        container: window.document.documentElement,
        mobile: !0,
        reset: !1,
        useDelay: "always",
        viewFactor: .2,
        viewOffset: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        },
        beforeReveal: function(t) {},
        beforeReset: function(t) {},
        afterReveal: function(t) {},
        afterReset: function(t) {}
    },
    t.prototype.isSupported = function() {
        var t = document.documentElement.style;
        return "WebkitTransition"in t && "WebkitTransform"in t || "transition"in t && "transform"in t
    }
    ,
    t.prototype.reveal = function(t, s, a, d) {
        var f, p, h, g, m, v;
        if (void 0 !== s && "number" == typeof s ? (a = s,
        s = {}) : void 0 !== s && null !== s || (s = {}),
        f = e(s),
        p = n(t, f),
        !p.length)
            return T;
        a && "number" == typeof a && (v = i(),
        m = T.sequences[v] = {
            id: v,
            interval: a,
            elemIds: [],
            active: !1
        });
        for (var y = 0; y < p.length; y++)
            g = p[y].getAttribute("data-sr-id"),
            g ? h = T.store.elements[g] : (h = {
                id: i(),
                domEl: p[y],
                seen: !1,
                revealing: !1
            },
            h.domEl.setAttribute("data-sr-id", h.id)),
            m && (h.sequence = {
                id: m.id,
                index: m.elemIds.length
            },
            m.elemIds.push(h.id)),
            r(h, s, f),
            o(h),
            l(h),
            T.tools.isMobile() && !h.config.mobile || !T.isSupported() ? (h.domEl.setAttribute("style", h.styles.inline),
            h.disabled = !0) : h.revealing || h.domEl.setAttribute("style", h.styles.inline + h.styles.transform.initial);
        return !d && T.isSupported() && (u(t, s, a),
        T.initTimeout && window.clearTimeout(T.initTimeout),
        T.initTimeout = window.setTimeout(c, 0)),
        T
    }
    ,
    t.prototype.sync = function() {
        if (T.history.length && T.isSupported()) {
            for (var t = 0; t < T.history.length; t++) {
                var e = T.history[t];
                T.reveal(e.target, e.config, e.interval, !0)
            }
            c()
        }
        return T
    }
    ,
    C.prototype.isObject = function(t) {
        return null !== t && "object" == typeof t && t.constructor === Object
    }
    ,
    C.prototype.isNode = function(t) {
        return "object" == typeof window.Node ? t instanceof window.Node : t && "object" == typeof t && "number" == typeof t.nodeType && "string" == typeof t.nodeName
    }
    ,
    C.prototype.isNodeList = function(t) {
        var e = Object.prototype.toString.call(t)
          , n = /^\[object (HTMLCollection|NodeList|Object)\]$/;
        return "object" == typeof window.NodeList ? t instanceof window.NodeList : t && "object" == typeof t && n.test(e) && "number" == typeof t.length && (0 === t.length || this.isNode(t[0]))
    }
    ,
    C.prototype.forOwn = function(t, e) {
        if (!this.isObject(t))
            throw new TypeError('Expected "object", but received "' + typeof t + '".');
        for (var n in t)
            t.hasOwnProperty(n) && e(n)
    }
    ,
    C.prototype.extend = function(t, e) {
        return this.forOwn(e, function(n) {
            this.isObject(e[n]) ? (t[n] && this.isObject(t[n]) || (t[n] = {}),
            this.extend(t[n], e[n])) : t[n] = e[n]
        }
        .bind(this)),
        t
    }
    ,
    C.prototype.extendClone = function(t, e) {
        return this.extend(this.extend({}, t), e)
    }
    ,
    C.prototype.isMobile = function() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    }
    ,
    k = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(t) {
        window.setTimeout(t, 1e3 / 60)
    }
    ,
    "function" == typeof define && "object" == typeof define.amd && define.amd ? define(function() {
        return t
    }) : "undefined" != typeof module && module.exports ? module.exports = t : window.ScrollReveal = t
}();
/*! npm.im/object-fit-images 3.2.3 */
var objectFitImages = function() {
    "use strict";
    function t(t, e) {
        return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + t + "' height='" + e + "'%3E%3C/svg%3E"
    }
    function e(t) {
        if (t.srcset && !m && window.picturefill) {
            var e = window.picturefill._;
            t[e.ns] && t[e.ns].evaled || e.fillImg(t, {
                reselect: !0
            }),
            t[e.ns].curSrc || (t[e.ns].supported = !1,
            e.fillImg(t, {
                reselect: !0
            })),
            t.currentSrc = t[e.ns].curSrc || t.src
        }
    }
    function i(t) {
        for (var e, i = getComputedStyle(t).fontFamily, r = {}; null !== (e = l.exec(i)); )
            r[e[1]] = e[2];
        return r
    }
    function r(e, i, r) {
        var n = t(i || 1, r || 0);
        p.call(e, "src") !== n && b.call(e, "src", n)
    }
    function n(t, e) {
        t.naturalWidth ? e(t) : setTimeout(n, 100, t, e)
    }
    function c(t) {
        var c = i(t)
          , o = t[a];
        if (c["object-fit"] = c["object-fit"] || "fill",
        !o.img) {
            if ("fill" === c["object-fit"])
                return;
            if (!o.skipTest && g && !c["object-position"])
                return
        }
        if (!o.img) {
            o.img = new Image(t.width,t.height),
            o.img.srcset = p.call(t, "data-ofi-srcset") || t.srcset,
            o.img.src = p.call(t, "data-ofi-src") || t.src,
            b.call(t, "data-ofi-src", t.src),
            t.srcset && b.call(t, "data-ofi-srcset", t.srcset),
            r(t, t.naturalWidth || t.width, t.naturalHeight || t.height),
            t.srcset && (t.srcset = "");
            try {
                s(t)
            } catch (t) {
                window.console && console.warn("https://bit.ly/ofi-old-browser")
            }
        }
        e(o.img),
        t.style.backgroundImage = 'url("' + (o.img.currentSrc || o.img.src).replace(/"/g, '\\"') + '")',
        t.style.backgroundPosition = c["object-position"] || "center",
        t.style.backgroundRepeat = "no-repeat",
        t.style.backgroundOrigin = "content-box",
        /scale-down/.test(c["object-fit"]) ? n(o.img, function() {
            o.img.naturalWidth > t.width || o.img.naturalHeight > t.height ? t.style.backgroundSize = "contain" : t.style.backgroundSize = "auto"
        }) : t.style.backgroundSize = c["object-fit"].replace("none", "auto").replace("fill", "100% 100%"),
        n(o.img, function(e) {
            r(t, e.naturalWidth, e.naturalHeight)
        })
    }
    function s(t) {
        var e = {
            get: function(e) {
                return t[a].img[e || "src"]
            },
            set: function(e, i) {
                return t[a].img[i || "src"] = e,
                b.call(t, "data-ofi-" + i, e),
                c(t),
                e
            }
        };
        Object.defineProperty(t, "src", e),
        Object.defineProperty(t, "currentSrc", {
            get: function() {
                return e.get("currentSrc")
            }
        }),
        Object.defineProperty(t, "srcset", {
            get: function() {
                return e.get("srcset")
            },
            set: function(t) {
                return e.set(t, "srcset")
            }
        })
    }
    function o(t, e) {
        var i = !h && !t;
        if (e = e || {},
        t = t || "img",
        f && !e.skipTest || !d)
            return !1;
        "img" === t ? t = document.getElementsByTagName("img") : "string" == typeof t ? t = document.querySelectorAll(t) : "length"in t || (t = [t]);
        for (var r = 0; r < t.length; r++)
            t[r][a] = t[r][a] || {
                skipTest: e.skipTest
            },
            c(t[r]);
        i && (document.body.addEventListener("load", function(t) {
            "IMG" === t.target.tagName && o(t.target, {
                skipTest: e.skipTest
            })
        }, !0),
        h = !0,
        t = "img"),
        e.watchMQ && window.addEventListener("resize", o.bind(null, t, {
            skipTest: e.skipTest
        }))
    }
    var a = "bfred-it:object-fit-images"
      , l = /(object-fit|object-position)\s*:\s*([-\w\s%]+)/g
      , u = "undefined" == typeof Image ? {
        style: {
            "object-position": 1
        }
    } : new Image
      , g = "object-fit"in u.style
      , f = "object-position"in u.style
      , d = "background-size"in u.style
      , m = "string" == typeof u.currentSrc
      , p = u.getAttribute
      , b = u.setAttribute
      , h = !1;
    return o.supportsObjectFit = g,
    o.supportsObjectPosition = f,
    function() {
        function t(t, e) {
            return t[a] && t[a].img && ("src" === e || "srcset" === e) ? t[a].img : t
        }
        f || (HTMLImageElement.prototype.getAttribute = function(e) {
            return p.call(t(this, e), e)
        }
        ,
        HTMLImageElement.prototype.setAttribute = function(e, i) {
            return b.call(t(this, e), e, String(i))
        }
        )
    }(),
    o
}();
/*!
 matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. Dual MIT/BSD license 
*/
window.matchMedia || (window.matchMedia = function() {
    "use strict";
    var e = window.styleMedia || window.media;
    if (!e) {
        var t = document.createElement("style")
          , r = document.getElementsByTagName("script")[0]
          , i = null;
        t.type = "text/css",
        t.id = "matchmediajs-test",
        r.parentNode.insertBefore(t, r),
        i = "getComputedStyle"in window && window.getComputedStyle(t, null) || t.currentStyle,
        e = {
            matchMedium: function(e) {
                var r = "@media " + e + "{ #matchmediajs-test { width: 1px; } }";
                return t.styleSheet ? t.styleSheet.cssText = r : t.textContent = r,
                "1px" === i.width
            }
        }
    }
    return function(t) {
        return {
            matches: e.matchMedium(t || "all"),
            media: t || "all"
        }
    }
}()),
/*! modernizr 3.5.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-cssgrid_cssgridlegacy-localstorage-touchevents-setclasses !*/
!function(e, t, r) {
    function i(e, t) {
        return typeof e === t
    }
    function n() {
        var e, t, r, n, o, a, s;
        for (var l in b)
            if (b.hasOwnProperty(l)) {
                if (e = [],
                t = b[l],
                t.name && (e.push(t.name.toLowerCase()),
                t.options && t.options.aliases && t.options.aliases.length))
                    for (r = 0; r < t.options.aliases.length; r++)
                        e.push(t.options.aliases[r].toLowerCase());
                for (n = i(t.fn, "function") ? t.fn() : t.fn,
                o = 0; o < e.length; o++)
                    a = e[o],
                    s = a.split("."),
                    1 === s.length ? S[s[0]] = n : (!S[s[0]] || S[s[0]]instanceof Boolean || (S[s[0]] = new Boolean(S[s[0]])),
                    S[s[0]][s[1]] = n),
                    w.push((n ? "" : "no-") + s.join("-"))
            }
    }
    function o(e) {
        var t = C.className
          , r = S._config.classPrefix || "";
        if (P && (t = t.baseVal),
        S._config.enableJSClass) {
            var i = new RegExp("(^|\\s)" + r + "no-js(\\s|$)");
            t = t.replace(i, "$1" + r + "js$2")
        }
        S._config.enableClasses && (t += " " + r + e.join(" " + r),
        P ? C.className.baseVal = t : C.className = t)
    }
    function a() {
        return "function" != typeof t.createElement ? t.createElement(arguments[0]) : P ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments)
    }
    function s() {
        var e = t.body;
        return e || (e = a(P ? "svg" : "body"),
        e.fake = !0),
        e
    }
    function l(e, r, i, n) {
        var o, l, u, c, p = "modernizr", d = a("div"), f = s();
        if (parseInt(i, 10))
            for (; i--; )
                u = a("div"),
                u.id = n ? n[i] : p + (i + 1),
                d.appendChild(u);
        return o = a("style"),
        o.type = "text/css",
        o.id = "s" + p,
        (f.fake ? f : d).appendChild(o),
        f.appendChild(d),
        o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(t.createTextNode(e)),
        d.id = p,
        f.fake && (f.style.background = "",
        f.style.overflow = "hidden",
        c = C.style.overflow,
        C.style.overflow = "hidden",
        C.appendChild(f)),
        l = r(d, e),
        f.fake ? (f.parentNode.removeChild(f),
        C.style.overflow = c,
        C.offsetHeight) : d.parentNode.removeChild(d),
        !!l
    }
    function u(e, t) {
        return !!~("" + e).indexOf(t)
    }
    function c(e) {
        return e.replace(/([a-z])-([a-z])/g, function(e, t, r) {
            return t + r.toUpperCase()
        }).replace(/^-/, "")
    }
    function p(e, t) {
        return function() {
            return e.apply(t, arguments)
        }
    }
    function d(e, t, r) {
        var n;
        for (var o in e)
            if (e[o]in t)
                return r === !1 ? e[o] : (n = t[e[o]],
                i(n, "function") ? p(n, r || t) : n);
        return !1
    }
    function f(e) {
        return e.replace(/([A-Z])/g, function(e, t) {
            return "-" + t.toLowerCase()
        }).replace(/^ms-/, "-ms-")
    }
    function m(t, r, i) {
        var n;
        if ("getComputedStyle"in e) {
            n = getComputedStyle.call(e, t, r);
            var o = e.console;
            if (null !== n)
                i && (n = n.getPropertyValue(i));
            else if (o) {
                var a = o.error ? "error" : "log";
                o[a].call(o, "getComputedStyle returning null, its possible modernizr test results are inaccurate")
            }
        } else
            n = !r && t.currentStyle && t.currentStyle[i];
        return n
    }
    function h(t, i) {
        var n = t.length;
        if ("CSS"in e && "supports"in e.CSS) {
            for (; n--; )
                if (e.CSS.supports(f(t[n]), i))
                    return !0;
            return !1
        }
        if ("CSSSupportsRule"in e) {
            for (var o = []; n--; )
                o.push("(" + f(t[n]) + ":" + i + ")");
            return o = o.join(" or "),
            l("@supports (" + o + ") { #modernizr { position: absolute; } }", function(e) {
                return "absolute" == m(e, null, "position")
            })
        }
        return r
    }
    function g(e, t, n, o) {
        function s() {
            p && (delete N.style,
            delete N.modElem)
        }
        if (o = !i(o, "undefined") && o,
        !i(n, "undefined")) {
            var l = h(e, n);
            if (!i(l, "undefined"))
                return l
        }
        for (var p, d, f, m, g, v = ["modernizr", "tspan", "samp"]; !N.style && v.length; )
            p = !0,
            N.modElem = a(v.shift()),
            N.style = N.modElem.style;
        for (f = e.length,
        d = 0; f > d; d++)
            if (m = e[d],
            g = N.style[m],
            u(m, "-") && (m = c(m)),
            N.style[m] !== r) {
                if (o || i(n, "undefined"))
                    return s(),
                    "pfx" != t || m;
                try {
                    N.style[m] = n
                } catch (y) {}
                if (N.style[m] != g)
                    return s(),
                    "pfx" != t || m
            }
        return s(),
        !1
    }
    function v(e, t, r, n, o) {
        var a = e.charAt(0).toUpperCase() + e.slice(1)
          , s = (e + " " + k.join(a + " ") + a).split(" ");
        return i(t, "string") || i(t, "undefined") ? g(s, t, n, o) : (s = (e + " " + z.join(a + " ") + a).split(" "),
        d(s, t, r))
    }
    function y(e, t, i) {
        return v(e, r, r, t, i)
    }
    var w = []
      , b = []
      , x = {
        _version: "3.5.0",
        _config: {
            classPrefix: "",
            enableClasses: !0,
            enableJSClass: !0,
            usePrefixes: !0
        },
        _q: [],
        on: function(e, t) {
            var r = this;
            setTimeout(function() {
                t(r[e])
            }, 0)
        },
        addTest: function(e, t, r) {
            b.push({
                name: e,
                fn: t,
                options: r
            })
        },
        addAsyncTest: function(e) {
            b.push({
                name: null,
                fn: e
            })
        }
    }
      , S = function() {};
    S.prototype = x,
    S = new S,
    S.addTest("localstorage", function() {
        var e = "modernizr";
        try {
            return localStorage.setItem(e, e),
            localStorage.removeItem(e),
            !0
        } catch (t) {
            return !1
        }
    });
    var C = t.documentElement
      , P = "svg" === C.nodeName.toLowerCase()
      , T = x._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
    x._prefixes = T;
    var I = x.testStyles = l;
    S.addTest("touchevents", function() {
        var r;
        if ("ontouchstart"in e || e.DocumentTouch && t instanceof DocumentTouch)
            r = !0;
        else {
            var i = ["@media (", T.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");
            I(i, function(e) {
                r = 9 === e.offsetTop
            })
        }
        return r
    });
    var A = "Moz O ms Webkit"
      , k = x._config.usePrefixes ? A.split(" ") : [];
    x._cssomPrefixes = k;
    var z = x._config.usePrefixes ? A.toLowerCase().split(" ") : [];
    x._domPrefixes = z;
    var V = {
        elem: a("modernizr")
    };
    S._q.push(function() {
        delete V.elem
    });
    var N = {
        style: V.elem.style
    };
    S._q.unshift(function() {
        delete N.style
    }),
    x.testAllProps = v,
    x.testAllProps = y,
    S.addTest("cssgridlegacy", y("grid-columns", "10px", !0)),
    S.addTest("cssgrid", y("grid-template-rows", "none", !0)),
    n(),
    o(w),
    delete x.addTest,
    delete x.addAsyncTest;
    for (var E = 0; E < S._q.length; E++)
        S._q[E]();
    e.Modernizr = S
}(window, document),
/*!
 *	jQuery OwlCarousel v1.31
 *
 *	Copyright (c) 2013 Bartosz Wojciechowski
 *	http://www.owlgraphic.com/owlcarousel/
 *
 *	Licensed under MIT
 *
 */
"function" != typeof Object.create && (Object.create = function(e) {
    function t() {}
    return t.prototype = e,
    new t
}
),
function(e, t, r, i) {
    var n = {
        init: function(t, r) {
            var i = this;
            i.$elem = e(r),
            i.options = e.extend({}, e.fn.owlCarousel.options, i.$elem.data(), t),
            i.userOptions = t,
            i.loadContent()
        },
        loadContent: function() {
            function t(e) {
                if ("function" == typeof r.options.jsonSuccess)
                    r.options.jsonSuccess.apply(this, [e]);
                else {
                    var t = "";
                    for (var i in e.owl)
                        t += e.owl[i].item;
                    r.$elem.html(t)
                }
                r.logIn()
            }
            var r = this;
            if ("function" == typeof r.options.beforeInit && r.options.beforeInit.apply(this, [r.$elem]),
            "string" == typeof r.options.jsonPath) {
                var i = r.options.jsonPath;
                e.getJSON(i, t)
            } else
                r.logIn()
        },
        logIn: function(e) {
            var t = this;
            t.$elem.data("owl-originalStyles", t.$elem.attr("style")).data("owl-originalClasses", t.$elem.attr("class")),
            t.$elem.css({
                opacity: 0
            }),
            t.orignalItems = t.options.items,
            t.checkBrowser(),
            t.wrapperWidth = 0,
            t.checkVisible,
            t.setVars()
        },
        setVars: function() {
            var e = this;
            return 0 !== e.$elem.children().length && (e.baseClass(),
            e.eventTypes(),
            e.$userItems = e.$elem.children(),
            e.itemsAmount = e.$userItems.length,
            e.wrapItems(),
            e.$owlItems = e.$elem.find(".owl-item"),
            e.$owlWrapper = e.$elem.find(".owl-wrapper"),
            e.playDirection = "next",
            e.prevItem = 0,
            e.prevArr = [0],
            e.currentItem = 0,
            e.customEvents(),
            void e.onStartup())
        },
        onStartup: function() {
            var e = this;
            e.updateItems(),
            e.calculateAll(),
            e.buildControls(),
            e.updateControls(),
            e.response(),
            e.moveEvents(),
            e.stopOnHover(),
            e.owlStatus(),
            e.options.transitionStyle !== !1 && e.transitionTypes(e.options.transitionStyle),
            e.options.autoPlay === !0 && (e.options.autoPlay = 5e3),
            e.play(),
            e.$elem.find(".owl-wrapper").css("display", "block"),
            e.$elem.is(":visible") ? e.$elem.css("opacity", 1) : e.watchVisibility(),
            e.onstartup = !1,
            e.eachMoveUpdate(),
            "function" == typeof e.options.afterInit && e.options.afterInit.apply(this, [e.$elem])
        },
        eachMoveUpdate: function() {
            var e = this;
            e.options.lazyLoad === !0 && e.lazyLoad(),
            e.options.autoHeight === !0 && e.autoHeight(),
            e.onVisibleItems(),
            "function" == typeof e.options.afterAction && e.options.afterAction.apply(this, [e.$elem])
        },
        updateVars: function() {
            var e = this;
            "function" == typeof e.options.beforeUpdate && e.options.beforeUpdate.apply(this, [e.$elem]),
            e.watchVisibility(),
            e.updateItems(),
            e.calculateAll(),
            e.updatePosition(),
            e.updateControls(),
            e.eachMoveUpdate(),
            "function" == typeof e.options.afterUpdate && e.options.afterUpdate.apply(this, [e.$elem])
        },
        reload: function(e) {
            var t = this;
            setTimeout(function() {
                t.updateVars()
            }, 0)
        },
        watchVisibility: function() {
            var e = this;
            return e.$elem.is(":visible") === !1 && (e.$elem.css({
                opacity: 0
            }),
            clearInterval(e.autoPlayInterval),
            clearInterval(e.checkVisible),
            void (e.checkVisible = setInterval(function() {
                e.$elem.is(":visible") && (e.reload(),
                e.$elem.animate({
                    opacity: 1
                }, 200),
                clearInterval(e.checkVisible))
            }, 500)))
        },
        wrapItems: function() {
            var e = this;
            e.$userItems.wrapAll('<div class="owl-wrapper">').wrap('<div class="owl-item"></div>'),
            e.$elem.find(".owl-wrapper").wrap('<div class="owl-wrapper-outer">'),
            e.wrapperOuter = e.$elem.find(".owl-wrapper-outer"),
            e.$elem.css("display", "block")
        },
        baseClass: function() {
            var e = this
              , t = e.$elem.hasClass(e.options.baseClass)
              , r = e.$elem.hasClass(e.options.theme);
            t || e.$elem.addClass(e.options.baseClass),
            r || e.$elem.addClass(e.options.theme)
        },
        updateItems: function() {
            var t = this;
            if (t.options.responsive === !1)
                return !1;
            if (t.options.singleItem === !0)
                return t.options.items = t.orignalItems = 1,
                t.options.itemsCustom = !1,
                t.options.itemsDesktop = !1,
                t.options.itemsDesktopSmall = !1,
                t.options.itemsTablet = !1,
                t.options.itemsTabletSmall = !1,
                t.options.itemsMobile = !1,
                !1;
            var r = e(t.options.responsiveBaseWidth).width();
            if (r > (t.options.itemsDesktop[0] || t.orignalItems) && (t.options.items = t.orignalItems),
            "undefined" != typeof t.options.itemsCustom && t.options.itemsCustom !== !1) {
                t.options.itemsCustom.sort(function(e, t) {
                    return e[0] - t[0]
                });
                for (var i in t.options.itemsCustom)
                    "undefined" != typeof t.options.itemsCustom[i] && t.options.itemsCustom[i][0] <= r && (t.options.items = t.options.itemsCustom[i][1])
            } else
                r <= t.options.itemsDesktop[0] && t.options.itemsDesktop !== !1 && (t.options.items = t.options.itemsDesktop[1]),
                r <= t.options.itemsDesktopSmall[0] && t.options.itemsDesktopSmall !== !1 && (t.options.items = t.options.itemsDesktopSmall[1]),
                r <= t.options.itemsTablet[0] && t.options.itemsTablet !== !1 && (t.options.items = t.options.itemsTablet[1]),
                r <= t.options.itemsTabletSmall[0] && t.options.itemsTabletSmall !== !1 && (t.options.items = t.options.itemsTabletSmall[1]),
                r <= t.options.itemsMobile[0] && t.options.itemsMobile !== !1 && (t.options.items = t.options.itemsMobile[1]);
            t.options.items > t.itemsAmount && t.options.itemsScaleUp === !0 && (t.options.items = t.itemsAmount)
        },
        response: function() {
            var r, i = this;
            if (i.options.responsive !== !0)
                return !1;
            var n = e(t).width();
            i.resizer = function() {
                e(t).width() !== n && (i.options.autoPlay !== !1 && clearInterval(i.autoPlayInterval),
                clearTimeout(r),
                r = setTimeout(function() {
                    n = e(t).width(),
                    i.updateVars()
                }, i.options.responsiveRefreshRate))
            }
            ,
            e(t).resize(i.resizer)
        },
        updatePosition: function() {
            var e = this;
            e.jumpTo(e.currentItem),
            e.options.autoPlay !== !1 && e.checkAp()
        },
        appendItemsSizes: function() {
            var t = this
              , r = 0
              , i = t.itemsAmount - t.options.items;
            t.$owlItems.each(function(n) {
                var o = e(this);
                o.css({
                    width: t.itemWidth
                }).data("owl-item", Number(n)),
                n % t.options.items !== 0 && n !== i || n > i || (r += 1),
                o.data("owl-roundPages", r)
            })
        },
        appendWrapperSizes: function() {
            var e = this
              , t = 0
              , t = e.$owlItems.length * e.itemWidth;
            e.$owlWrapper.css({
                width: 2 * t,
                left: 0
            }),
            e.appendItemsSizes()
        },
        calculateAll: function() {
            var e = this;
            e.calculateWidth(),
            e.appendWrapperSizes(),
            e.loops(),
            e.max()
        },
        calculateWidth: function() {
            var e = this;
            e.itemWidth = Math.floor(e.$elem.width() / e.options.items)
        },
        max: function() {
            var e = this
              , t = (e.itemsAmount * e.itemWidth - e.options.items * e.itemWidth) * -1;
            return e.options.items > e.itemsAmount ? (e.maximumItem = 0,
            t = 0,
            e.maximumPixels = 0) : (e.maximumItem = e.itemsAmount - e.options.items,
            e.maximumPixels = t),
            t
        },
        min: function() {
            return 0
        },
        loops: function() {
            var t = this;
            t.positionsInArray = [0],
            t.pagesInArray = [];
            for (var r = 0, i = 0, n = 0; n < t.itemsAmount; n++)
                if (i += t.itemWidth,
                t.positionsInArray.push(-i),
                t.options.scrollPerPage === !0) {
                    var o = e(t.$owlItems[n])
                      , a = o.data("owl-roundPages");
                    a !== r && (t.pagesInArray[r] = t.positionsInArray[n],
                    r = a)
                }
        },
        buildControls: function() {
            var t = this;
            t.options.navigation !== !0 && t.options.pagination !== !0 || (t.owlControls = e('<div class="owl-controls"/>').toggleClass("clickable", !t.browser.isTouch).appendTo(t.$elem)),
            t.options.pagination === !0 && t.buildPagination(),
            t.options.navigation === !0 && t.buildButtons()
        },
        buildButtons: function() {
            var t = this
              , r = e('<div class="owl-buttons"/>');
            t.owlControls.append(r),
            t.buttonPrev = e("<div/>", {
                "class": "owl-prev",
                html: t.options.navigationText[0] || ""
            }),
            t.buttonNext = e("<div/>", {
                "class": "owl-next",
                html: t.options.navigationText[1] || ""
            }),
            r.append(t.buttonPrev).append(t.buttonNext),
            r.on("touchstart.owlControls mousedown.owlControls", 'div[class^="owl"]', function(e) {
                e.preventDefault()
            }),
            r.on("touchend.owlControls mouseup.owlControls", 'div[class^="owl"]', function(r) {
                r.preventDefault(),
                e(this).hasClass("owl-next") ? t.next() : t.prev()
            })
        },
        buildPagination: function() {
            var t = this;
            t.paginationWrapper = e('<div class="owl-pagination"/>'),
            t.owlControls.append(t.paginationWrapper),
            t.paginationWrapper.on("touchend.owlControls mouseup.owlControls", ".owl-page", function(r) {
                r.preventDefault(),
                Number(e(this).data("owl-page")) !== t.currentItem && t.goTo(Number(e(this).data("owl-page")), !0)
            })
        },
        updatePagination: function() {
            var t = this;
            if (t.options.pagination === !1)
                return !1;
            t.paginationWrapper.html("");
            for (var r = 0, i = t.itemsAmount - t.itemsAmount % t.options.items, n = 0; n < t.itemsAmount; n++)
                if (n % t.options.items === 0) {
                    if (r += 1,
                    i === n)
                        var o = t.itemsAmount - t.options.items;
                    var a = e("<div/>", {
                        "class": "owl-page"
                    })
                      , s = e("<span></span>", {
                        text: t.options.paginationNumbers === !0 ? r : "",
                        "class": t.options.paginationNumbers === !0 ? "owl-numbers" : ""
                    });
                    a.append(s),
                    a.data("owl-page", i === n ? o : n),
                    a.data("owl-roundPages", r),
                    t.paginationWrapper.append(a)
                }
            t.checkPagination()
        },
        checkPagination: function() {
            var t = this;
            return t.options.pagination !== !1 && void t.paginationWrapper.find(".owl-page").each(function(r, i) {
                e(this).data("owl-roundPages") === e(t.$owlItems[t.currentItem]).data("owl-roundPages") && (t.paginationWrapper.find(".owl-page").removeClass("active"),
                e(this).addClass("active"))
            })
        },
        checkNavigation: function() {
            var e = this;
            return e.options.navigation !== !1 && void (e.options.rewindNav === !1 && (0 === e.currentItem && 0 === e.maximumItem ? (e.buttonPrev.addClass("disabled"),
            e.buttonNext.addClass("disabled")) : 0 === e.currentItem && 0 !== e.maximumItem ? (e.buttonPrev.addClass("disabled"),
            e.buttonNext.removeClass("disabled")) : e.currentItem === e.maximumItem ? (e.buttonPrev.removeClass("disabled"),
            e.buttonNext.addClass("disabled")) : 0 !== e.currentItem && e.currentItem !== e.maximumItem && (e.buttonPrev.removeClass("disabled"),
            e.buttonNext.removeClass("disabled"))))
        },
        updateControls: function() {
            var e = this;
            e.updatePagination(),
            e.checkNavigation(),
            e.owlControls && (e.options.items >= e.itemsAmount ? e.owlControls.hide() : e.owlControls.show())
        },
        destroyControls: function() {
            var e = this;
            e.owlControls && e.owlControls.remove()
        },
        next: function(e) {
            var t = this;
            if (t.isTransition)
                return !1;
            if (t.currentItem += t.options.scrollPerPage === !0 ? t.options.items : 1,
            t.currentItem > t.maximumItem + (1 == t.options.scrollPerPage ? t.options.items - 1 : 0)) {
                if (t.options.rewindNav !== !0)
                    return t.currentItem = t.maximumItem,
                    !1;
                t.currentItem = 0,
                e = "rewind"
            }
            t.goTo(t.currentItem, e)
        },
        prev: function(e) {
            var t = this;
            if (t.isTransition)
                return !1;
            if (t.options.scrollPerPage === !0 && t.currentItem > 0 && t.currentItem < t.options.items ? t.currentItem = 0 : t.currentItem -= t.options.scrollPerPage === !0 ? t.options.items : 1,
            t.currentItem < 0) {
                if (t.options.rewindNav !== !0)
                    return t.currentItem = 0,
                    !1;
                t.currentItem = t.maximumItem,
                e = "rewind"
            }
            t.goTo(t.currentItem, e)
        },
        goTo: function(e, t, r) {
            var i = this;
            if (i.isTransition)
                return !1;
            if ("function" == typeof i.options.beforeMove && i.options.beforeMove.apply(this, [i.$elem]),
            e >= i.maximumItem ? e = i.maximumItem : e <= 0 && (e = 0),
            i.currentItem = i.owl.currentItem = e,
            i.options.transitionStyle !== !1 && "drag" !== r && 1 === i.options.items && i.browser.support3d === !0)
                return i.swapSpeed(0),
                i.browser.support3d === !0 ? i.transition3d(i.positionsInArray[e]) : i.css2slide(i.positionsInArray[e], 1),
                i.afterGo(),
                i.singleItemTransition(),
                !1;
            var n = i.positionsInArray[e];
            i.browser.support3d === !0 ? (i.isCss3Finish = !1,
            t === !0 ? (i.swapSpeed("paginationSpeed"),
            setTimeout(function() {
                i.isCss3Finish = !0
            }, i.options.paginationSpeed)) : "rewind" === t ? (i.swapSpeed(i.options.rewindSpeed),
            setTimeout(function() {
                i.isCss3Finish = !0
            }, i.options.rewindSpeed)) : (i.swapSpeed("slideSpeed"),
            setTimeout(function() {
                i.isCss3Finish = !0
            }, i.options.slideSpeed)),
            i.transition3d(n)) : t === !0 ? i.css2slide(n, i.options.paginationSpeed) : "rewind" === t ? i.css2slide(n, i.options.rewindSpeed) : i.css2slide(n, i.options.slideSpeed),
            i.afterGo()
        },
        jumpTo: function(e) {
            var t = this;
            "function" == typeof t.options.beforeMove && t.options.beforeMove.apply(this, [t.$elem]),
            e >= t.maximumItem || e === -1 ? e = t.maximumItem : e <= 0 && (e = 0),
            t.swapSpeed(0),
            t.browser.support3d === !0 ? t.transition3d(t.positionsInArray[e]) : t.css2slide(t.positionsInArray[e], 1),
            t.currentItem = t.owl.currentItem = e,
            t.afterGo()
        },
        afterGo: function() {
            var e = this;
            e.prevArr.push(e.currentItem),
            e.prevItem = e.owl.prevItem = e.prevArr[e.prevArr.length - 2],
            e.prevArr.shift(0),
            e.prevItem !== e.currentItem && (e.checkPagination(),
            e.checkNavigation(),
            e.eachMoveUpdate(),
            e.options.autoPlay !== !1 && e.checkAp()),
            "function" == typeof e.options.afterMove && e.prevItem !== e.currentItem && e.options.afterMove.apply(this, [e.$elem])
        },
        stop: function() {
            var e = this;
            e.apStatus = "stop",
            clearInterval(e.autoPlayInterval)
        },
        checkAp: function() {
            var e = this;
            "stop" !== e.apStatus && e.play()
        },
        play: function() {
            var e = this;
            return e.apStatus = "play",
            e.options.autoPlay !== !1 && (clearInterval(e.autoPlayInterval),
            void (e.autoPlayInterval = setInterval(function() {
                e.next(!0)
            }, e.options.autoPlay)))
        },
        swapSpeed: function(e) {
            var t = this;
            "slideSpeed" === e ? t.$owlWrapper.css(t.addCssSpeed(t.options.slideSpeed)) : "paginationSpeed" === e ? t.$owlWrapper.css(t.addCssSpeed(t.options.paginationSpeed)) : "string" != typeof e && t.$owlWrapper.css(t.addCssSpeed(e))
        },
        addCssSpeed: function(e) {
            return {
                "-webkit-transition": "all " + e + "ms ease",
                "-moz-transition": "all " + e + "ms ease",
                "-o-transition": "all " + e + "ms ease",
                transition: "all " + e + "ms ease"
            }
        },
        removeTransition: function() {
            return {
                "-webkit-transition": "",
                "-moz-transition": "",
                "-o-transition": "",
                transition: ""
            }
        },
        doTranslate: function(e) {
            return {
                "-webkit-transform": "translate3d(" + e + "px, 0px, 0px)",
                "-moz-transform": "translate3d(" + e + "px, 0px, 0px)",
                "-o-transform": "translate3d(" + e + "px, 0px, 0px)",
                "-ms-transform": "translate3d(" + e + "px, 0px, 0px)",
                transform: "translate3d(" + e + "px, 0px,0px)"
            }
        },
        transition3d: function(e) {
            var t = this;
            t.$owlWrapper.css(t.doTranslate(e))
        },
        css2move: function(e) {
            var t = this;
            t.$owlWrapper.css({
                left: e
            })
        },
        css2slide: function(e, t) {
            var r = this;
            r.isCssFinish = !1,
            r.$owlWrapper.stop(!0, !0).animate({
                left: e
            }, {
                duration: t || r.options.slideSpeed,
                complete: function() {
                    r.isCssFinish = !0
                }
            })
        },
        checkBrowser: function() {
            var e = this
              , i = "translate3d(0px, 0px, 0px)"
              , n = r.createElement("div");
            n.style.cssText = "  -moz-transform:" + i + "; -ms-transform:" + i + "; -o-transform:" + i + "; -webkit-transform:" + i + "; transform:" + i;
            var o = /translate3d\(0px, 0px, 0px\)/g
              , a = n.style.cssText.match(o)
              , s = null !== a && 1 === a.length
              , l = "ontouchstart"in t || navigator.msMaxTouchPoints;
            e.browser = {
                support3d: s,
                isTouch: l
            }
        },
        moveEvents: function() {
            var e = this;
            e.options.mouseDrag === !1 && e.options.touchDrag === !1 || (e.gestures(),
            e.disabledEvents())
        },
        eventTypes: function() {
            var e = this
              , t = ["s", "e", "x"];
            e.ev_types = {},
            e.options.mouseDrag === !0 && e.options.touchDrag === !0 ? t = ["touchstart.owl mousedown.owl", "touchmove.owl mousemove.owl", "touchend.owl touchcancel.owl mouseup.owl"] : e.options.mouseDrag === !1 && e.options.touchDrag === !0 ? t = ["touchstart.owl", "touchmove.owl", "touchend.owl touchcancel.owl"] : e.options.mouseDrag === !0 && e.options.touchDrag === !1 && (t = ["mousedown.owl", "mousemove.owl", "mouseup.owl"]),
            e.ev_types.start = t[0],
            e.ev_types.move = t[1],
            e.ev_types.end = t[2]
        },
        disabledEvents: function() {
            var t = this;
            t.$elem.on("dragstart.owl", function(e) {
                e.preventDefault()
            }),
            t.$elem.on("mousedown.disableTextSelect", function(t) {
                return e(t.target).is("input, textarea, select, option")
            })
        },
        gestures: function() {
            function n(e) {
                return e.touches ? {
                    x: e.touches[0].pageX,
                    y: e.touches[0].pageY
                } : e.pageX !== i ? {
                    x: e.pageX,
                    y: e.pageY
                } : {
                    x: e.clientX,
                    y: e.clientY
                }
            }
            function o(t) {
                "on" === t ? (e(r).on(u.ev_types.move, s),
                e(r).on(u.ev_types.end, l)) : "off" === t && (e(r).off(u.ev_types.move),
                e(r).off(u.ev_types.end))
            }
            function a(r) {
                var r = r.originalEvent || r || t.event;
                if (3 === r.which)
                    return !1;
                if (!(u.itemsAmount <= u.options.items)) {
                    if (u.isCssFinish === !1 && !u.options.dragBeforeAnimFinish)
                        return !1;
                    if (u.isCss3Finish === !1 && !u.options.dragBeforeAnimFinish)
                        return !1;
                    u.options.autoPlay !== !1 && clearInterval(u.autoPlayInterval),
                    u.browser.isTouch === !0 || u.$owlWrapper.hasClass("grabbing") || u.$owlWrapper.addClass("grabbing"),
                    u.newPosX = 0,
                    u.newRelativeX = 0,
                    e(this).css(u.removeTransition());
                    var i = e(this).position();
                    c.relativePos = i.left,
                    c.offsetX = n(r).x - i.left,
                    c.offsetY = n(r).y - i.top,
                    o("on"),
                    c.sliding = !1,
                    c.targetElement = r.target || r.srcElement
                }
            }
            function s(i) {
                var i = i.originalEvent || i || t.event;
                u.newPosX = n(i).x - c.offsetX,
                u.newPosY = n(i).y - c.offsetY,
                u.newRelativeX = u.newPosX - c.relativePos,
                "function" == typeof u.options.startDragging && c.dragging !== !0 && 0 !== u.newRelativeX && (c.dragging = !0,
                u.options.startDragging.apply(u, [u.$elem])),
                (u.newRelativeX > 8 || u.newRelativeX < -8 && u.browser.isTouch === !0) && (i.preventDefault ? i.preventDefault() : i.returnValue = !1,
                c.sliding = !0),
                (u.newPosY > 10 || u.newPosY < -10) && c.sliding === !1 && e(r).off("touchmove.owl");
                var o = function() {
                    return u.newRelativeX / 5
                }
                  , a = function() {
                    return u.maximumPixels + u.newRelativeX / 5
                };
                u.newPosX = Math.max(Math.min(u.newPosX, o()), a()),
                u.browser.support3d === !0 ? u.transition3d(u.newPosX) : u.css2move(u.newPosX)
            }
            function l(r) {
                var r = r.originalEvent || r || t.event;
                if (r.target = r.target || r.srcElement,
                c.dragging = !1,
                u.browser.isTouch !== !0 && u.$owlWrapper.removeClass("grabbing"),
                u.newRelativeX < 0 ? u.dragDirection = u.owl.dragDirection = "left" : u.dragDirection = u.owl.dragDirection = "right",
                0 !== u.newRelativeX) {
                    var i = u.getNewPosition();
                    if (u.goTo(i, !1, "drag"),
                    c.targetElement === r.target && u.browser.isTouch !== !0) {
                        e(r.target).on("click.disable", function(t) {
                            t.stopImmediatePropagation(),
                            t.stopPropagation(),
                            t.preventDefault(),
                            e(r.target).off("click.disable")
                        });
                        var n = e._data(r.target, "events").click
                          , a = n.pop();
                        n.splice(0, 0, a)
                    }
                }
                o("off")
            }
            var u = this
              , c = {
                offsetX: 0,
                offsetY: 0,
                baseElWidth: 0,
                relativePos: 0,
                position: null,
                minSwipe: null,
                maxSwipe: null,
                sliding: null,
                dargging: null,
                targetElement: null
            };
            u.isCssFinish = !0,
            u.$elem.on(u.ev_types.start, ".owl-wrapper", a)
        },
        getNewPosition: function() {
            var e, t = this;
            return e = t.closestItem(),
            e > t.maximumItem ? (t.currentItem = t.maximumItem,
            e = t.maximumItem) : t.newPosX >= 0 && (e = 0,
            t.currentItem = 0),
            e
        },
        closestItem: function() {
            var t = this
              , r = t.options.scrollPerPage === !0 ? t.pagesInArray : t.positionsInArray
              , i = t.newPosX
              , n = null;
            return e.each(r, function(o, a) {
                i - t.itemWidth / 20 > r[o + 1] && i - t.itemWidth / 20 < a && "left" === t.moveDirection() ? (n = a,
                t.options.scrollPerPage === !0 ? t.currentItem = e.inArray(n, t.positionsInArray) : t.currentItem = o) : i + t.itemWidth / 20 < a && i + t.itemWidth / 20 > (r[o + 1] || r[o] - t.itemWidth) && "right" === t.moveDirection() && (t.options.scrollPerPage === !0 ? (n = r[o + 1] || r[r.length - 1],
                t.currentItem = e.inArray(n, t.positionsInArray)) : (n = r[o + 1],
                t.currentItem = o + 1))
            }),
            t.currentItem
        },
        moveDirection: function() {
            var e, t = this;
            return t.newRelativeX < 0 ? (e = "right",
            t.playDirection = "next") : (e = "left",
            t.playDirection = "prev"),
            e
        },
        customEvents: function() {
            var e = this;
            e.$elem.on("owl.next", function() {
                e.next()
            }),
            e.$elem.on("owl.prev", function() {
                e.prev()
            }),
            e.$elem.on("owl.play", function(t, r) {
                e.options.autoPlay = r,
                e.play(),
                e.hoverStatus = "play"
            }),
            e.$elem.on("owl.stop", function() {
                e.stop(),
                e.hoverStatus = "stop"
            }),
            e.$elem.on("owl.goTo", function(t, r) {
                e.goTo(r)
            }),
            e.$elem.on("owl.jumpTo", function(t, r) {
                e.jumpTo(r)
            })
        },
        stopOnHover: function() {
            var e = this;
            e.options.stopOnHover === !0 && e.browser.isTouch !== !0 && e.options.autoPlay !== !1 && (e.$elem.on("mouseover", function() {
                e.stop()
            }),
            e.$elem.on("mouseout", function() {
                "stop" !== e.hoverStatus && e.play()
            }))
        },
        lazyLoad: function() {
            var t = this;
            if (t.options.lazyLoad === !1)
                return !1;
            for (var r = 0; r < t.itemsAmount; r++) {
                var n = e(t.$owlItems[r]);
                if ("loaded" !== n.data("owl-loaded")) {
                    var o, a = n.data("owl-item"), s = n.find(".lazyOwl");
                    "string" == typeof s.data("src") ? (n.data("owl-loaded") === i && (s.hide(),
                    n.addClass("loading").data("owl-loaded", "checked")),
                    o = t.options.lazyFollow !== !0 || a >= t.currentItem,
                    o && a < t.currentItem + t.options.items && s.length && t.lazyPreload(n, s)) : n.data("owl-loaded", "loaded")
                }
            }
        },
        lazyPreload: function(e, t) {
            function r() {
                o += 1,
                n.completeImg(t.get(0)) || a === !0 ? i() : o <= 100 ? setTimeout(r, 100) : i()
            }
            function i() {
                e.data("owl-loaded", "loaded").removeClass("loading"),
                t.removeAttr("data-src"),
                "fade" === n.options.lazyEffect ? t.fadeIn(400) : t.show(),
                "function" == typeof n.options.afterLazyLoad && n.options.afterLazyLoad.apply(this, [n.$elem])
            }
            var n = this
              , o = 0;
            if ("DIV" === t.prop("tagName")) {
                t.css("background-image", "url(" + t.data("src") + ")");
                var a = !0
            } else
                t[0].src = t.data("src");
            r()
        },
        autoHeight: function() {
            function t() {
                a += 1,
                n.completeImg(o.get(0)) ? r() : a <= 100 ? setTimeout(t, 100) : n.wrapperOuter.css("height", "")
            }
            function r() {
                var t = e(n.$owlItems[n.currentItem]).height();
                n.wrapperOuter.css("height", t + "px"),
                n.wrapperOuter.hasClass("autoHeight") || setTimeout(function() {
                    n.wrapperOuter.addClass("autoHeight")
                }, 0)
            }
            var n = this
              , o = e(n.$owlItems[n.currentItem]).find("img");
            if (o.get(0) !== i) {
                var a = 0;
                t()
            } else
                r()
        },
        completeImg: function(e) {
            return !!e.complete && ("undefined" == typeof e.naturalWidth || 0 != e.naturalWidth)
        },
        onVisibleItems: function() {
            var t = this;
            t.options.addClassActive === !0 && t.$owlItems.removeClass("active"),
            t.visibleItems = [];
            for (var r = t.currentItem; r < t.currentItem + t.options.items; r++)
                t.visibleItems.push(r),
                t.options.addClassActive === !0 && e(t.$owlItems[r]).addClass("active");
            t.owl.visibleItems = t.visibleItems
        },
        transitionTypes: function(e) {
            var t = this;
            t.outClass = "owl-" + e + "-out",
            t.inClass = "owl-" + e + "-in"
        },
        singleItemTransition: function() {
            function e(e, t) {
                return {
                    position: "relative",
                    left: e + "px"
                }
            }
            var t = this;
            t.isTransition = !0;
            var r = t.outClass
              , i = t.inClass
              , n = t.$owlItems.eq(t.currentItem)
              , o = t.$owlItems.eq(t.prevItem)
              , a = Math.abs(t.positionsInArray[t.currentItem]) + t.positionsInArray[t.prevItem]
              , s = Math.abs(t.positionsInArray[t.currentItem]) + t.itemWidth / 2;
            t.$owlWrapper.addClass("owl-origin").css({
                "-webkit-transform-origin": s + "px",
                "-moz-perspective-origin": s + "px",
                "perspective-origin": s + "px"
            });
            var l = "webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend";
            o.css(e(a, 10)).addClass(r).on(l, function() {
                t.endPrev = !0,
                o.off(l),
                t.clearTransStyle(o, r)
            }),
            n.addClass(i).on(l, function() {
                t.endCurrent = !0,
                n.off(l),
                t.clearTransStyle(n, i)
            })
        },
        clearTransStyle: function(e, t) {
            var r = this;
            e.css({
                position: "",
                left: ""
            }).removeClass(t),
            r.endPrev && r.endCurrent && (r.$owlWrapper.removeClass("owl-origin"),
            r.endPrev = !1,
            r.endCurrent = !1,
            r.isTransition = !1)
        },
        owlStatus: function() {
            var e = this;
            e.owl = {
                userOptions: e.userOptions,
                baseElement: e.$elem,
                userItems: e.$userItems,
                owlItems: e.$owlItems,
                currentItem: e.currentItem,
                prevItem: e.prevItem,
                visibleItems: e.visibleItems,
                isTouch: e.browser.isTouch,
                browser: e.browser,
                dragDirection: e.dragDirection
            }
        },
        clearEvents: function() {
            var i = this;
            i.$elem.off(".owl owl mousedown.disableTextSelect"),
            e(r).off(".owl owl"),
            e(t).off("resize", i.resizer)
        },
        unWrap: function() {
            var e = this;
            0 !== e.$elem.children().length && (e.$owlWrapper.unwrap(),
            e.$userItems.unwrap().unwrap(),
            e.owlControls && e.owlControls.remove()),
            e.clearEvents(),
            e.$elem.attr("style", e.$elem.data("owl-originalStyles") || "").attr("class", e.$elem.data("owl-originalClasses"))
        },
        destroy: function() {
            var e = this;
            e.stop(),
            clearInterval(e.checkVisible),
            e.unWrap(),
            e.$elem.removeData()
        },
        reinit: function(t) {
            var r = this
              , i = e.extend({}, r.userOptions, t);
            r.unWrap(),
            r.init(i, r.$elem)
        },
        addItem: function(e, t) {
            var r, n = this;
            return !!e && (0 === n.$elem.children().length ? (n.$elem.append(e),
            n.setVars(),
            !1) : (n.unWrap(),
            r = t === i || t === -1 ? -1 : t,
            r >= n.$userItems.length || r === -1 ? n.$userItems.eq(-1).after(e) : n.$userItems.eq(r).before(e),
            void n.setVars()))
        },
        removeItem: function(e) {
            var t, r = this;
            return 0 !== r.$elem.children().length && (t = e === i || e === -1 ? -1 : e,
            r.unWrap(),
            r.$userItems.eq(t).remove(),
            void r.setVars())
        }
    };
    e.fn.owlCarousel = function(t) {
        return this.each(function() {
            if (e(this).data("owl-init") === !0)
                return !1;
            e(this).data("owl-init", !0);
            var r = Object.create(n);
            r.init(t, this),
            e.data(this, "owlCarousel", r)
        })
    }
    ,
    e.fn.owlCarousel.options = {
        items: 5,
        itemsCustom: !1,
        itemsDesktop: [1199, 4],
        itemsDesktopSmall: [979, 3],
        itemsTablet: [768, 2],
        itemsTabletSmall: !1,
        itemsMobile: [479, 1],
        singleItem: !1,
        itemsScaleUp: !1,
        slideSpeed: 200,
        paginationSpeed: 800,
        rewindSpeed: 1e3,
        autoPlay: !1,
        stopOnHover: !1,
        navigation: !1,
        navigationText: ["prev", "next"],
        rewindNav: !0,
        scrollPerPage: !1,
        pagination: !0,
        paginationNumbers: !1,
        responsive: !0,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: t,
        baseClass: "owl-carousel",
        theme: "owl-theme",
        lazyLoad: !1,
        lazyFollow: !0,
        lazyEffect: "fade",
        autoHeight: !1,
        jsonPath: !1,
        jsonSuccess: !1,
        dragBeforeAnimFinish: !0,
        mouseDrag: !0,
        touchDrag: !0,
        addClassActive: !1,
        transitionStyle: !1,
        beforeUpdate: !1,
        afterUpdate: !1,
        beforeInit: !1,
        afterInit: !1,
        beforeMove: !1,
        afterMove: !1,
        afterAction: !1,
        startDragging: !1,
        afterLazyLoad: !1
    }
}(jQuery, window, document),
/*!
 *
 * Spin.js
 * Copyright (c) 2011-2013 Felix Gnass
 * Licensed under the MIT license
 */
function(e, t) {
    "object" == typeof exports ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e.Spinner = t()
}(this, function() {
    "use strict";
    function e(e, t) {
        var r, i = document.createElement(e || "div");
        for (r in t)
            i[r] = t[r];
        return i
    }
    function t(e) {
        for (var t = 1, r = arguments.length; t < r; t++)
            e.appendChild(arguments[t]);
        return e
    }
    function r(e, t, r, i) {
        var n = ["opacity", t, ~~(100 * e), r, i].join("-")
          , o = .01 + r / i * 100
          , a = Math.max(1 - (1 - e) / t * (100 - o), e)
          , s = c.substring(0, c.indexOf("Animation")).toLowerCase()
          , l = s && "-" + s + "-" || "";
        return d[n] || (f.insertRule("@" + l + "keyframes " + n + "{0%{opacity:" + a + "}" + o + "%{opacity:" + e + "}" + (o + .01) + "%{opacity:1}" + (o + t) % 100 + "%{opacity:" + e + "}100%{opacity:" + a + "}}", f.cssRules.length),
        d[n] = 1),
        n
    }
    function i(e, t) {
        var r, i, n = e.style;
        for (t = t.charAt(0).toUpperCase() + t.slice(1),
        i = 0; i < p.length; i++)
            if (r = p[i] + t,
            void 0 !== n[r])
                return r;
        if (void 0 !== n[t])
            return t
    }
    function n(e, t) {
        for (var r in t)
            e.style[i(e, r) || r] = t[r];
        return e
    }
    function o(e) {
        for (var t = 1; t < arguments.length; t++) {
            var r = arguments[t];
            for (var i in r)
                void 0 === e[i] && (e[i] = r[i])
        }
        return e
    }
    function a(e) {
        for (var t = {
            x: e.offsetLeft,
            y: e.offsetTop
        }; e = e.offsetParent; )
            t.x += e.offsetLeft,
            t.y += e.offsetTop;
        return t
    }
    function s(e, t) {
        return "string" == typeof e ? e : e[t % e.length]
    }
    function l(e) {
        return "undefined" == typeof this ? new l(e) : void (this.opts = o(e || {}, l.defaults, m))
    }
    function u() {
        function r(t, r) {
            return e("<" + t + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', r)
        }
        f.addRule(".spin-vml", "behavior:url(#default#VML)"),
        l.prototype.lines = function(e, i) {
            function o() {
                return n(r("group", {
                    coordsize: c + " " + c,
                    coordorigin: -u + " " + -u
                }), {
                    width: c,
                    height: c
                })
            }
            function a(e, a, l) {
                t(d, t(n(o(), {
                    rotation: 360 / i.lines * e + "deg",
                    left: ~~a
                }), t(n(r("roundrect", {
                    arcsize: i.corners
                }), {
                    width: u,
                    height: i.width,
                    left: i.radius,
                    top: -i.width >> 1,
                    filter: l
                }), r("fill", {
                    color: s(i.color, e),
                    opacity: i.opacity
                }), r("stroke", {
                    opacity: 0
                }))))
            }
            var l, u = i.length + i.width, c = 2 * u, p = 2 * -(i.width + i.length) + "px", d = n(o(), {
                position: "absolute",
                top: p,
                left: p
            });
            if (i.shadow)
                for (l = 1; l <= i.lines; l++)
                    a(l, -2, "progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)");
            for (l = 1; l <= i.lines; l++)
                a(l);
            return t(e, d)
        }
        ,
        l.prototype.opacity = function(e, t, r, i) {
            var n = e.firstChild;
            i = i.shadow && i.lines || 0,
            n && t + i < n.childNodes.length && (n = n.childNodes[t + i],
            n = n && n.firstChild,
            n = n && n.firstChild,
            n && (n.opacity = r))
        }
    }
    var c, p = ["webkit", "Moz", "ms", "O"], d = {}, f = function() {
        var r = e("style", {
            type: "text/css"
        });
        return t(document.getElementsByTagName("head")[0], r),
        r.sheet || r.styleSheet
    }(), m = {
        lines: 12,
        length: 7,
        width: 5,
        radius: 10,
        rotate: 0,
        corners: 1,
        color: "#000",
        direction: 1,
        speed: 1,
        trail: 100,
        opacity: .25,
        fps: 20,
        zIndex: 2e9,
        className: "spinner",
        top: "auto",
        left: "auto",
        position: "relative"
    };
    l.defaults = {},
    o(l.prototype, {
        spin: function(t) {
            this.stop();
            var r, i, o = this, s = o.opts, l = o.el = n(e(0, {
                className: s.className
            }), {
                position: s.position,
                width: 0,
                zIndex: s.zIndex
            }), u = s.radius + s.length + s.width;
            if (t && (t.insertBefore(l, t.firstChild || null),
            i = a(t),
            r = a(l),
            n(l, {
                left: ("auto" == s.left ? i.x - r.x + (t.offsetWidth >> 1) : parseInt(s.left, 10) + u) + "px",
                top: ("auto" == s.top ? i.y - r.y + (t.offsetHeight >> 1) : parseInt(s.top, 10) + u) + "px"
            })),
            l.setAttribute("role", "progressbar"),
            o.lines(l, o.opts),
            !c) {
                var p, d = 0, f = (s.lines - 1) * (1 - s.direction) / 2, m = s.fps, h = m / s.speed, g = (1 - s.opacity) / (h * s.trail / 100), v = h / s.lines;
                !function y() {
                    d++;
                    for (var e = 0; e < s.lines; e++)
                        p = Math.max(1 - (d + (s.lines - e) * v) % h * g, s.opacity),
                        o.opacity(l, e * s.direction + f, p, s);
                    o.timeout = o.el && setTimeout(y, ~~(1e3 / m))
                }()
            }
            return o
        },
        stop: function() {
            var e = this.el;
            return e && (clearTimeout(this.timeout),
            e.parentNode && e.parentNode.removeChild(e),
            this.el = void 0),
            this
        },
        lines: function(i, o) {
            function a(t, r) {
                return n(e(), {
                    position: "absolute",
                    width: o.length + o.width + "px",
                    height: o.width + "px",
                    background: t,
                    boxShadow: r,
                    transformOrigin: "left",
                    transform: "rotate(" + ~~(360 / o.lines * u + o.rotate) + "deg) translate(" + o.radius + "px,0)",
                    borderRadius: (o.corners * o.width >> 1) + "px"
                })
            }
            for (var l, u = 0, p = (o.lines - 1) * (1 - o.direction) / 2; u < o.lines; u++)
                l = n(e(), {
                    position: "absolute",
                    top: 1 + ~(o.width / 2) + "px",
                    transform: o.hwaccel ? "translate3d(0,0,0)" : "",
                    opacity: o.opacity,
                    animation: c && r(o.opacity, o.trail, p + u * o.direction, o.lines) + " " + 1 / o.speed + "s linear infinite"
                }),
                o.shadow && t(l, n(a("#000", "0 0 4px #000"), {
                    top: "2px"
                })),
                t(i, t(l, a(s(o.color, u), "0 0 1px rgba(0,0,0,.1)")));
            return i
        },
        opacity: function(e, t, r) {
            t < e.childNodes.length && (e.childNodes[t].style.opacity = r)
        }
    });
    var h = n(e("group"), {
        behavior: "url(#default#VML)"
    });
    return !i(h, "transform") && h.adj ? u() : c = i(h, "animation"),
    l
}),
function(e) {
    if ("object" == typeof exports)
        e(require("jquery"), require("spin"));
    else if ("function" == typeof define && define.amd)
        define(["jquery", "spin"], e);
    else {
        if (!window.Spinner)
            throw new Error("Spin.js not present");
        e(window.jQuery, window.Spinner)
    }
}(function(e, t) {
    e.fn.spin = function(r, i) {
        return this.each(function() {
            var n = e(this)
              , o = n.data();
            o.spinner && (o.spinner.stop(),
            delete o.spinner),
            r !== !1 && (r = e.extend({
                color: i || n.css("color")
            }, e.fn.spin.presets[r] || r),
            o.spinner = new t(r).spin(this))
        })
    }
    ,
    e.fn.spin.presets = {
        tiny: {
            lines: 8,
            length: 2,
            width: 2,
            radius: 3
        },
        small: {
            lines: 8,
            length: 4,
            width: 3,
            radius: 5
        },
        large: {
            lines: 10,
            length: 8,
            width: 4,
            radius: 8
        }
    }
});

/*BEGIN Swipe*/
(function(a) {
    if (typeof define === "function" && define.amd && define.amd.jQuery) {
        define(["jquery"], a)
    } else {
        a(jQuery)
    }
}(function(f) {
    var y = "1.6.12"
      , p = "left"
      , o = "right"
      , e = "up"
      , x = "down"
      , c = "in"
      , A = "out"
      , m = "none"
      , s = "auto"
      , l = "swipe"
      , t = "pinch"
      , B = "tap"
      , j = "doubletap"
      , b = "longtap"
      , z = "hold"
      , E = "horizontal"
      , u = "vertical"
      , i = "all"
      , r = 10
      , g = "start"
      , k = "move"
      , h = "end"
      , q = "cancel"
      , a = "ontouchstart"in window
      , v = window.navigator.msPointerEnabled && !window.navigator.pointerEnabled
      , d = window.navigator.pointerEnabled || window.navigator.msPointerEnabled
      , C = "TouchSwipe";
    var n = {
        fingers: 1,
        threshold: 75,
        cancelThreshold: null,
        pinchThreshold: 20,
        maxTimeThreshold: null,
        fingerReleaseThreshold: 250,
        longTapThreshold: 500,
        doubleTapThreshold: 200,
        swipe: null,
        swipeLeft: null,
        swipeRight: null,
        swipeUp: null,
        swipeDown: null,
        swipeStatus: null,
        pinchIn: null,
        pinchOut: null,
        pinchStatus: null,
        click: null,
        tap: null,
        doubleTap: null,
        longTap: null,
        hold: null,
        triggerOnTouchEnd: true,
        triggerOnTouchLeave: false,
        allowPageScroll: "auto",
        fallbackToMouseEvents: true,
        excludedElements: "label, button, input, select, textarea, a, .noSwipe",
        preventDefaultEvents: true
    };
    f.fn.swipe = function(H) {
        var G = f(this)
          , F = G.data(C);
        if (F && typeof H === "string") {
            if (F[H]) {
                return F[H].apply(this, Array.prototype.slice.call(arguments, 1))
            } else {
                f.error("Method " + H + " does not exist on jQuery.swipe")
            }
        } else {
            if (F && typeof H === "object") {
                F.option.apply(this, arguments)
            } else {
                if (!F && (typeof H === "object" || !H)) {
                    return w.apply(this, arguments)
                }
            }
        }
        return G
    }
    ;
    f.fn.swipe.version = y;
    f.fn.swipe.defaults = n;
    f.fn.swipe.phases = {
        PHASE_START: g,
        PHASE_MOVE: k,
        PHASE_END: h,
        PHASE_CANCEL: q
    };
    f.fn.swipe.directions = {
        LEFT: p,
        RIGHT: o,
        UP: e,
        DOWN: x,
        IN: c,
        OUT: A
    };
    f.fn.swipe.pageScroll = {
        NONE: m,
        HORIZONTAL: E,
        VERTICAL: u,
        AUTO: s
    };
    f.fn.swipe.fingers = {
        ONE: 1,
        TWO: 2,
        THREE: 3,
        FOUR: 4,
        FIVE: 5,
        ALL: i
    };
    function w(F) {
        if (F && (F.allowPageScroll === undefined && (F.swipe !== undefined || F.swipeStatus !== undefined))) {
            F.allowPageScroll = m
        }
        if (F.click !== undefined && F.tap === undefined) {
            F.tap = F.click
        }
        if (!F) {
            F = {}
        }
        F = f.extend({}, f.fn.swipe.defaults, F);
        return this.each(function() {
            var H = f(this);
            var G = H.data(C);
            if (!G) {
                G = new D(this,F);
                H.data(C, G)
            }
        })
    }
    function D(a4, au) {
        var au = f.extend({}, au);
        var az = (a || d || !au.fallbackToMouseEvents)
          , K = az ? (d ? (v ? "MSPointerDown" : "pointerdown") : "touchstart") : "mousedown"
          , ax = az ? (d ? (v ? "MSPointerMove" : "pointermove") : "touchmove") : "mousemove"
          , V = az ? (d ? (v ? "MSPointerUp" : "pointerup") : "touchend") : "mouseup"
          , T = az ? null : "mouseleave"
          , aD = (d ? (v ? "MSPointerCancel" : "pointercancel") : "touchcancel");
        var ag = 0
          , aP = null
          , ac = 0
          , a1 = 0
          , aZ = 0
          , H = 1
          , ap = 0
          , aJ = 0
          , N = null;
        var aR = f(a4);
        var aa = "start";
        var X = 0;
        var aQ = {};
        var U = 0
          , a2 = 0
          , a5 = 0
          , ay = 0
          , O = 0;
        var aW = null
          , af = null;
        try {
            aR.bind(K, aN);
            aR.bind(aD, a9)
        } catch (aj) {
            f.error("events not supported " + K + "," + aD + " on jQuery.swipe")
        }
        this.enable = function() {
            aR.bind(K, aN);
            aR.bind(aD, a9);
            return aR
        }
        ;
        this.disable = function() {
            aK();
            return aR
        }
        ;
        this.destroy = function() {
            aK();
            aR.data(C, null);
            aR = null
        }
        ;
        this.option = function(bc, bb) {
            if (typeof bc === "object") {
                au = f.extend(au, bc)
            } else {
                if (au[bc] !== undefined) {
                    if (bb === undefined) {
                        return au[bc]
                    } else {
                        au[bc] = bb
                    }
                } else {
                    if (!bc) {
                        return au
                    } else {
                        f.error("Option " + bc + " does not exist on jQuery.swipe.options")
                    }
                }
            }
            return null
        }
        ;
        function aN(bd) {
            if (aB()) {
                return
            }
            if (f(bd.target).closest(au.excludedElements, aR).length > 0) {
                return
            }
            var be = bd.originalEvent ? bd.originalEvent : bd;
            var bc, bf = be.touches, bb = bf ? bf[0] : be;
            aa = g;
            if (bf) {
                X = bf.length
            } else {
                if (au.preventDefaultEvents !== false) {
                    bd.preventDefault()
                }
            }
            ag = 0;
            aP = null;
            aJ = null;
            ac = 0;
            a1 = 0;
            aZ = 0;
            H = 1;
            ap = 0;
            N = ab();
            S();
            ai(0, bb);
            if (!bf || (X === au.fingers || au.fingers === i) || aX()) {
                U = ar();
                if (X == 2) {
                    ai(1, bf[1]);
                    a1 = aZ = at(aQ[0].start, aQ[1].start)
                }
                if (au.swipeStatus || au.pinchStatus) {
                    bc = P(be, aa)
                }
            } else {
                bc = false
            }
            if (bc === false) {
                aa = q;
                P(be, aa);
                return bc
            } else {
                if (au.hold) {
                    af = setTimeout(f.proxy(function() {
                        aR.trigger("hold", [be.target]);
                        if (au.hold) {
                            bc = au.hold.call(aR, be, be.target)
                        }
                    }, this), au.longTapThreshold)
                }
                an(true)
            }
            return null
        }
        function a3(be) {
            var bh = be.originalEvent ? be.originalEvent : be;
            if (aa === h || aa === q || al()) {
                return
            }
            var bd, bi = bh.touches, bc = bi ? bi[0] : bh;
            var bf = aH(bc);
            a2 = ar();
            if (bi) {
                X = bi.length
            }
            if (au.hold) {
                clearTimeout(af)
            }
            aa = k;
            if (X == 2) {
                if (a1 == 0) {
                    ai(1, bi[1]);
                    a1 = aZ = at(aQ[0].start, aQ[1].start)
                } else {
                    aH(bi[1]);
                    aZ = at(aQ[0].end, aQ[1].end);
                    aJ = aq(aQ[0].end, aQ[1].end)
                }
                H = a7(a1, aZ);
                ap = Math.abs(a1 - aZ)
            }
            if ((X === au.fingers || au.fingers === i) || !bi || aX()) {
                aP = aL(bf.start, bf.end);
                ak(be, aP);
                ag = aS(bf.start, bf.end);
                ac = aM();
                aI(aP, ag);
                if (au.swipeStatus || au.pinchStatus) {
                    bd = P(bh, aa)
                }
                if (!au.triggerOnTouchEnd || au.triggerOnTouchLeave) {
                    var bb = true;
                    if (au.triggerOnTouchLeave) {
                        var bg = aY(this);
                        bb = F(bf.end, bg)
                    }
                    if (!au.triggerOnTouchEnd && bb) {
                        aa = aC(k)
                    } else {
                        if (au.triggerOnTouchLeave && !bb) {
                            aa = aC(h)
                        }
                    }
                    if (aa == q || aa == h) {
                        P(bh, aa)
                    }
                }
            } else {
                aa = q;
                P(bh, aa)
            }
            if (bd === false) {
                aa = q;
                P(bh, aa)
            }
        }
        function M(bb) {
            var bc = bb.originalEvent ? bb.originalEvent : bb
              , bd = bc.touches;
            if (bd) {
                if (bd.length && !al()) {
                    G();
                    return true
                } else {
                    if (bd.length && al()) {
                        return true
                    }
                }
            }
            if (al()) {
                X = ay
            }
            a2 = ar();
            ac = aM();
            if (ba() || !am()) {
                aa = q;
                P(bc, aa)
            } else {
                if (au.triggerOnTouchEnd || (au.triggerOnTouchEnd == false && aa === k)) {
                    if (au.preventDefaultEvents !== false) {
                        bb.preventDefault()
                    }
                    aa = h;
                    P(bc, aa)
                } else {
                    if (!au.triggerOnTouchEnd && a6()) {
                        aa = h;
                        aF(bc, aa, B)
                    } else {
                        if (aa === k) {
                            aa = q;
                            P(bc, aa)
                        }
                    }
                }
            }
            an(false);
            return null
        }
        function a9() {
            X = 0;
            a2 = 0;
            U = 0;
            a1 = 0;
            aZ = 0;
            H = 1;
            S();
            an(false)
        }
        function L(bb) {
            var bc = bb.originalEvent ? bb.originalEvent : bb;
            if (au.triggerOnTouchLeave) {
                aa = aC(h);
                P(bc, aa)
            }
        }
        function aK() {
            aR.unbind(K, aN);
            aR.unbind(aD, a9);
            aR.unbind(ax, a3);
            aR.unbind(V, M);
            if (T) {
                aR.unbind(T, L)
            }
            an(false)
        }
        function aC(bf) {
            var be = bf;
            var bd = aA();
            var bc = am();
            var bb = ba();
            if (!bd || bb) {
                be = q
            } else {
                if (bc && bf == k && (!au.triggerOnTouchEnd || au.triggerOnTouchLeave)) {
                    be = h
                } else {
                    if (!bc && bf == h && au.triggerOnTouchLeave) {
                        be = q
                    }
                }
            }
            return be
        }
        function P(bd, bb) {
            var bc, be = bd.touches;
            if ((J() && W()) || (Q() && aX())) {
                if (J() && W()) {
                    bc = aF(bd, bb, l)
                }
                if ((Q() && aX()) && bc !== false) {
                    bc = aF(bd, bb, t)
                }
            } else {
                if (aG() && bc !== false) {
                    bc = aF(bd, bb, j)
                } else {
                    if (ao() && bc !== false) {
                        bc = aF(bd, bb, b)
                    } else {
                        if (ah() && bc !== false) {
                            bc = aF(bd, bb, B)
                        }
                    }
                }
            }
            if (bb === q) {
                if (W()) {
                    bc = aF(bd, bb, l)
                }
                if (aX()) {
                    bc = aF(bd, bb, t)
                }
                a9(bd)
            }
            if (bb === h) {
                if (be) {
                    if (!be.length) {
                        a9(bd)
                    }
                } else {
                    a9(bd)
                }
            }
            return bc
        }
        function aF(be, bb, bd) {
            var bc;
            if (bd == l) {
                aR.trigger("swipeStatus", [bb, aP || null, ag || 0, ac || 0, X, aQ]);
                if (au.swipeStatus) {
                    bc = au.swipeStatus.call(aR, be, bb, aP || null, ag || 0, ac || 0, X, aQ);
                    if (bc === false) {
                        return false
                    }
                }
                if (bb == h && aV()) {
                    aR.trigger("swipe", [aP, ag, ac, X, aQ]);
                    if (au.swipe) {
                        bc = au.swipe.call(aR, be, aP, ag, ac, X, aQ);
                        if (bc === false) {
                            return false
                        }
                    }
                    switch (aP) {
                    case p:
                        aR.trigger("swipeLeft", [aP, ag, ac, X, aQ]);
                        if (au.swipeLeft) {
                            bc = au.swipeLeft.call(aR, be, aP, ag, ac, X, aQ)
                        }
                        break;
                    case o:
                        aR.trigger("swipeRight", [aP, ag, ac, X, aQ]);
                        if (au.swipeRight) {
                            bc = au.swipeRight.call(aR, be, aP, ag, ac, X, aQ)
                        }
                        break;
                    case e:
                        aR.trigger("swipeUp", [aP, ag, ac, X, aQ]);
                        if (au.swipeUp) {
                            bc = au.swipeUp.call(aR, be, aP, ag, ac, X, aQ)
                        }
                        break;
                    case x:
                        aR.trigger("swipeDown", [aP, ag, ac, X, aQ]);
                        if (au.swipeDown) {
                            bc = au.swipeDown.call(aR, be, aP, ag, ac, X, aQ)
                        }
                        break
                    }
                }
            }
            if (bd == t) {
                aR.trigger("pinchStatus", [bb, aJ || null, ap || 0, ac || 0, X, H, aQ]);
                if (au.pinchStatus) {
                    bc = au.pinchStatus.call(aR, be, bb, aJ || null, ap || 0, ac || 0, X, H, aQ);
                    if (bc === false) {
                        return false
                    }
                }
                if (bb == h && a8()) {
                    switch (aJ) {
                    case c:
                        aR.trigger("pinchIn", [aJ || null, ap || 0, ac || 0, X, H, aQ]);
                        if (au.pinchIn) {
                            bc = au.pinchIn.call(aR, be, aJ || null, ap || 0, ac || 0, X, H, aQ)
                        }
                        break;
                    case A:
                        aR.trigger("pinchOut", [aJ || null, ap || 0, ac || 0, X, H, aQ]);
                        if (au.pinchOut) {
                            bc = au.pinchOut.call(aR, be, aJ || null, ap || 0, ac || 0, X, H, aQ)
                        }
                        break
                    }
                }
            }
            if (bd == B) {
                if (bb === q || bb === h) {
                    clearTimeout(aW);
                    clearTimeout(af);
                    if (Z() && !I()) {
                        O = ar();
                        aW = setTimeout(f.proxy(function() {
                            O = null;
                            aR.trigger("tap", [be.target]);
                            if (au.tap) {
                                bc = au.tap.call(aR, be, be.target)
                            }
                        }, this), au.doubleTapThreshold)
                    } else {
                        O = null;
                        aR.trigger("tap", [be.target]);
                        if (au.tap) {
                            bc = au.tap.call(aR, be, be.target)
                        }
                    }
                }
            } else {
                if (bd == j) {
                    if (bb === q || bb === h) {
                        clearTimeout(aW);
                        O = null;
                        aR.trigger("doubletap", [be.target]);
                        if (au.doubleTap) {
                            bc = au.doubleTap.call(aR, be, be.target)
                        }
                    }
                } else {
                    if (bd == b) {
                        if (bb === q || bb === h) {
                            clearTimeout(aW);
                            O = null;
                            aR.trigger("longtap", [be.target]);
                            if (au.longTap) {
                                bc = au.longTap.call(aR, be, be.target)
                            }
                        }
                    }
                }
            }
            return bc
        }
        function am() {
            var bb = true;
            if (au.threshold !== null) {
                bb = ag >= au.threshold
            }
            return bb
        }
        function ba() {
            var bb = false;
            if (au.cancelThreshold !== null && aP !== null) {
                bb = (aT(aP) - ag) >= au.cancelThreshold
            }
            return bb
        }
        function ae() {
            if (au.pinchThreshold !== null) {
                return ap >= au.pinchThreshold
            }
            return true
        }
        function aA() {
            var bb;
            if (au.maxTimeThreshold) {
                if (ac >= au.maxTimeThreshold) {
                    bb = false
                } else {
                    bb = true
                }
            } else {
                bb = true
            }
            return bb
        }
        function ak(bb, bc) {
            if (au.preventDefaultEvents === false) {
                return
            }
            if (au.allowPageScroll === m) {
                bb.preventDefault()
            } else {
                var bd = au.allowPageScroll === s;
                switch (bc) {
                case p:
                    if ((au.swipeLeft && bd) || (!bd && au.allowPageScroll != E)) {
                        bb.preventDefault()
                    }
                    break;
                case o:
                    if ((au.swipeRight && bd) || (!bd && au.allowPageScroll != E)) {
                        bb.preventDefault()
                    }
                    break;
                case e:
                    if ((au.swipeUp && bd) || (!bd && au.allowPageScroll != u)) {
                        bb.preventDefault()
                    }
                    break;
                case x:
                    if ((au.swipeDown && bd) || (!bd && au.allowPageScroll != u)) {
                        bb.preventDefault()
                    }
                    break
                }
            }
        }
        function a8() {
            var bc = aO();
            var bb = Y();
            var bd = ae();
            return bc && bb && bd
        }
        function aX() {
            return !!(au.pinchStatus || au.pinchIn || au.pinchOut)
        }
        function Q() {
            return !!(a8() && aX())
        }
        function aV() {
            var be = aA();
            var bg = am();
            var bd = aO();
            var bb = Y();
            var bc = ba();
            var bf = !bc && bb && bd && bg && be;
            return bf
        }
        function W() {
            return !!(au.swipe || au.swipeStatus || au.swipeLeft || au.swipeRight || au.swipeUp || au.swipeDown)
        }
        function J() {
            return !!(aV() && W())
        }
        function aO() {
            return ((X === au.fingers || au.fingers === i) || !a)
        }
        function Y() {
            return aQ[0].end.x !== 0
        }
        function a6() {
            return !!(au.tap)
        }
        function Z() {
            return !!(au.doubleTap)
        }
        function aU() {
            return !!(au.longTap)
        }
        function R() {
            if (O == null) {
                return false
            }
            var bb = ar();
            return (Z() && ((bb - O) <= au.doubleTapThreshold))
        }
        function I() {
            return R()
        }
        function aw() {
            return ((X === 1 || !a) && (isNaN(ag) || ag < au.threshold))
        }
        function a0() {
            return ((ac > au.longTapThreshold) && (ag < r))
        }
        function ah() {
            return !!(aw() && a6())
        }
        function aG() {
            return !!(R() && Z())
        }
        function ao() {
            return !!(a0() && aU())
        }
        function G() {
            a5 = ar();
            ay = event.touches.length + 1
        }
        function S() {
            a5 = 0;
            ay = 0
        }
        function al() {
            var bb = false;
            if (a5) {
                var bc = ar() - a5;
                if (bc <= au.fingerReleaseThreshold) {
                    bb = true
                }
            }
            return bb
        }
        function aB() {
            return !!(aR.data(C + "_intouch") === true)
        }
        function an(bb) {
            if (bb === true) {
                aR.bind(ax, a3);
                aR.bind(V, M);
                if (T) {
                    aR.bind(T, L)
                }
            } else {
                aR.unbind(ax, a3, false);
                aR.unbind(V, M, false);
                if (T) {
                    aR.unbind(T, L, false)
                }
            }
            aR.data(C + "_intouch", bb === true)
        }
        function ai(bd, bb) {
            var bc = {
                start: {
                    x: 0,
                    y: 0
                },
                end: {
                    x: 0,
                    y: 0
                }
            };
            bc.start.x = bc.end.x = bb.pageX || bb.clientX;
            bc.start.y = bc.end.y = bb.pageY || bb.clientY;
            aQ[bd] = bc;
            return bc
        }
        function aH(bb) {
            var bd = bb.identifier !== undefined ? bb.identifier : 0;
            var bc = ad(bd);
            if (bc === null) {
                bc = ai(bd, bb)
            }
            bc.end.x = bb.pageX || bb.clientX;
            bc.end.y = bb.pageY || bb.clientY;
            return bc
        }
        function ad(bb) {
            return aQ[bb] || null
        }
        function aI(bb, bc) {
            bc = Math.max(bc, aT(bb));
            N[bb].distance = bc
        }
        function aT(bb) {
            if (N[bb]) {
                return N[bb].distance
            }
            return undefined
        }
        function ab() {
            var bb = {};
            bb[p] = av(p);
            bb[o] = av(o);
            bb[e] = av(e);
            bb[x] = av(x);
            return bb
        }
        function av(bb) {
            return {
                direction: bb,
                distance: 0
            }
        }
        function aM() {
            return a2 - U
        }
        function at(be, bd) {
            var bc = Math.abs(be.x - bd.x);
            var bb = Math.abs(be.y - bd.y);
            return Math.round(Math.sqrt(bc * bc + bb * bb))
        }
        function a7(bb, bc) {
            var bd = (bc / bb) * 1;
            return bd.toFixed(2)
        }
        function aq() {
            if (H < 1) {
                return A
            } else {
                return c
            }
        }
        function aS(bc, bb) {
            return Math.round(Math.sqrt(Math.pow(bb.x - bc.x, 2) + Math.pow(bb.y - bc.y, 2)))
        }
        function aE(be, bc) {
            var bb = be.x - bc.x;
            var bg = bc.y - be.y;
            var bd = Math.atan2(bg, bb);
            var bf = Math.round(bd * 180 / Math.PI);
            if (bf < 0) {
                bf = 360 - Math.abs(bf)
            }
            return bf
        }
        function aL(bc, bb) {
            var bd = aE(bc, bb);
            if ((bd <= 45) && (bd >= 0)) {
                return p
            } else {
                if ((bd <= 360) && (bd >= 315)) {
                    return p
                } else {
                    if ((bd >= 135) && (bd <= 225)) {
                        return o
                    } else {
                        if ((bd > 45) && (bd < 135)) {
                            return x
                        } else {
                            return e
                        }
                    }
                }
            }
        }
        function ar() {
            var bb = new Date();
            return bb.getTime()
        }
        function aY(bb) {
            bb = f(bb);
            var bd = bb.offset();
            var bc = {
                left: bd.left,
                right: bd.left + bb.outerWidth(),
                top: bd.top,
                bottom: bd.top + bb.outerHeight()
            };
            return bc
        }
        function F(bb, bc) {
            return (bb.x > bc.left && bb.x < bc.right && bb.y > bc.top && bb.y < bc.bottom)
        }
    }
}));

/* Minified Sept. 7, 2019 */
(function() {
    var Accordion, Cart, Collection, DOC, Footer, FrameworkAlign, FullscreenSlider, HEADER, HorizontalTabs, InstagramFeed, MediaQueries, PAGE, Password, Popup, ProductSlider, PromoBar, VerticalTabs, VideoModal, WINDOW, current_window, log, mq_large, mq_medium, mq_small, touchevents_exist, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments)
        }
    }, extend = function(child, parent) {
        for (var key in parent) {
            if (hasProp.call(parent, key)) {
                child[key] = parent[key]
            }
        }
        function ctor() {
            this.constructor = child
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child
    }, hasProp = {}.hasOwnProperty;
    FrameworkAlign = (function() {
        function FrameworkAlign(element1, type1) {
            this.element = element1;
            this.type = type1;
            this.resizeListeners = bind(this.resizeListeners, this);
            this.fillYSpace = bind(this.fillYSpace, this);
            this.checkOverlap = bind(this.checkOverlap, this);
            this.createOverlapDetectors = bind(this.createOverlapDetectors, this);
            this.position = bind(this.position, this);
            this.parent = this.element.parent();
            this.left_side_border;
            this.right_element_width = null;
            this.position();
            this.fillYSpace();
            this.createOverlapDetectors();
            this.resizeListeners()
        }
        FrameworkAlign.prototype.position = function() {
            if (this.type === 'center-x') {
                this.element.css({
                    'margin-left': -(this.element.outerWidth() / 2)
                })
            }
            if (this.type === 'center-y') {
                return this.element.css({
                    'margin-top': -(this.element.outerHeight() / 2)
                })
            }
        }
        ;
        FrameworkAlign.prototype.createOverlapDetectors = function() {
            var _this;
            _this = this;
            if (_this.type === 'right') {
                return this.right_element_width = _this.element.outerWidth()
            }
        }
        ;
        FrameworkAlign.prototype.checkOverlap = function() {
            var _this, left_element, left_side_border, right_side_border;
            _this = this;
            if (_this.type === 'right') {
                _this.parent.removeClass('overlap');
                left_element = _this.parent.children().eq(_this.element.index() - 1);
                left_side_border = left_element.position().left + left_element.outerWidth();
                right_side_border = _this.parent.outerWidth() - _this.right_element_width;
                if (left_side_border >= right_side_border) {
                    return _this.parent.addClass('overlap')
                }
            }
        }
        ;
        FrameworkAlign.prototype.fillYSpace = function() {
            var _this, container_height, text_panel_height;
            _this = this;
            if (_this.type === 'fill-y--dynamic') {
                container_height = _this.parent.outerHeight();
                text_panel_height = _this.parent.find('.fw--align--fill-y--fixed').outerHeight();
                return _this.element.outerHeight(container_height - text_panel_height)
            }
        }
        ;
        FrameworkAlign.prototype.resizeListeners = function() {
            var _this;
            _this = this;
            $(window).on('resize.FrameworkAlign', function() {
                _this.checkOverlap();
                return _this.fillYSpace()
            });
            return setTimeout(function() {
                return _this.checkOverlap()
            }, 1)
        }
        ;
        return FrameworkAlign
    }
    )();
    theme.classes.FrameworkAnimation = (function() {
        function FrameworkAnimation() {}
        return FrameworkAnimation
    }
    )();
    theme.classes.FrameworkCart = (function() {
        function FrameworkCart(root) {
            var _this;
            this.root = root;
            this.convertCurrency = bind(this.convertCurrency, this);
            this.openModalListener = bind(this.openModalListener, this);
            this.openOffCanvasListener = bind(this.openOffCanvasListener, this);
            this.removeItem = bind(this.removeItem, this);
            this.removeItemListeners = bind(this.removeItemListeners, this);
            this.updateTotalsComplete = bind(this.updateTotalsComplete, this);
            this.updateTotals = bind(this.updateTotals, this);
            this.plusQuantity = bind(this.plusQuantity, this);
            this.minusQuantity = bind(this.minusQuantity, this);
            this.updateQuantityListeners = bind(this.updateQuantityListeners, this);
            this.addItem = bind(this.addItem, this);
            this.renderOther = bind(this.renderOther, this);
            this.renderListener = bind(this.renderListener, this);
            this.renderCart = bind(this.renderCart, this);
            _this = this;
            _this.adjusting_qty_timer = null;
            _this.table_content = _this.root.find('form > .content');
            _this.render_trigger = $('.fw--cart-modal--trigger-render');
            _this.totals = {};
            _this.add_locked = false;
            _this.render_locked = false;
            if (_this.root.hasClass('off-canvas')) {
                _this.view = 'off canvas'
            }
            if (_this.root.hasClass('modal--content')) {
                _this.view = 'modal'
            }
            _this.temp_quantity = 0;
            _this.renderCart();
            if (_this.view === 'off canvas') {
                _this.openOffCanvasListener()
            }
            _this.openModalListener();
            _this.renderListener()
        }
        FrameworkCart.prototype.renderCart = function(callback) {
            var _this;
            _this = this;
            if (!_this.render_locked) {
                _this.render_locked = true;
                _this.table_content.empty();
                return $.ajax({
                    type: "POST",
                    url: "/cart.js",
                    dataType: "json"
                }).done(function(data, textStatus, jqXHR) {
                    var cart, index, item, j, len, ref, row;
                    if (textStatus === 'success') {
                        cart = data;
                        if (cart.items.length) {
                            _this.root.removeClass('no-items')
                        } else {
                            _this.root.addClass('no-items')
                        }
                        ref = cart.items;
                        for (index = j = 0,
                        len = ref.length; j < len; index = ++j) {
                            item = ref[index];
                            item.image_url = Shopify.resizeImage(item.image, "400x");
                            item.price = Currency.formatMoney(item.price, theme.money_format);
                            if ((index + 1) === cart.items.length) {
                                row = '<div class="variant-id last-variant width--12" data-variant-id=' + item.variant_id + '>'
                            } else {
                                row = '<div class="variant-id width--12" data-variant-id=' + item.variant_id + '>'
                            }
                            row += '<div class="width--12 width--medium-4 width--large-6 block">';
                            if (item.image_url === null) {
                                row += '<span class="image block width--4 width--medium-12 width--large-4 spacing--3"></span>'
                            } else {
                                row += '<span class="image block width--4 width--medium-12 width--large-4 spacing--3"><a href="' + item.url + '"><img src="' + item.image_url + '" alt="' + item.title + '"></a></span>'
                            }
                            row += '<span class="title show--small show--large block width--8 spacing--3 font--size-4"><a href="' + item.url + '">' + item.title + '</a></span>';
                            row += '</div>';
                            row += '<div class="right-column width--12 width--medium-8 width--large-6 block spacing--3y text-align--left text-align--large-right">';
                            row += '<span class="title show--medium block width--12 spacing--3 font--size-4"><a href="' + item.url + '">' + item.title + '</a></span>';
                            row += '<span class="price font--accent spacing--3 font--size-3 money">' + item.price + '</span>';
                            row += '<span class="quantity spacing--3"><div class="input--number">';
                            row += '<a tabindex="0" aria-label="' + theme.translations.remove_one_item + '" class="minus">' + theme.utils.addSymbol('minus') + '</a>';
                            row += '<input type="text" value="' + item.quantity + '" min="1" pattern="[1-9]*">';
                            row += '<a tabindex="0" aria-label="' + theme.translations.add_one_item + '" class="plus">' + theme.utils.addSymbol('plus') + '</a>';
                            row += '</div></span>';
                            row += '<span class="remove spacing--3">';
                            row += '<a aria-label="' + theme.translations.remove_item + '" role="button" href="#" class="cart--remove-button remove">' + theme.utils.addSymbol('cross-circle') + '</a>';
                            row += '</span>';
                            row += '</div>';
                            row += '</div>';
                            row += '<div class="spacer spacing--3y"></div>';
                            _this.table_content.append(row)
                        }
                        row = '<div class="totals width--12 text-align--center ">';
                        row += '<div class="width--12 width--large-8 block">';
                        row += '</div>';
                        row += '<div class="block spacing--3y width--12 width--large-4 font--size-3 text--bold text-align--large-right text--uppercase">';
                        row += '<span class="spacing--3">' + theme.translations.cart_subtotal + '</span>';
                        row += '<span class="total spacing--3 money font--accent font--subheading--size">' + _this.totals.price + '</span>';
                        row += '</div>';
                        row += '</div>';
                        row += '<div class="spacer spacing--3y show--small-medium"></div>';
                        _this.table_content.append(row);
                        _this.updateTotals();
                        if (window.Shopify && Shopify.StorefrontExpressButtons) {
                            Shopify.StorefrontExpressButtons.initialize()
                        }
                        if (callback) {
                            callback()
                        }
                        $(window).trigger('resize.FrameworkModal');
                        _this.render_locked = false;
                        _this.removeItemListeners();
                        _this.updateQuantityListeners();
                        return _this.convertCurrency(_this.root.find('.money'))
                    } else {
                        return console.log('cart - render item status - ' + textStatus)
                    }
                }).fail(function(jqXHR, textStatus) {
                    console.log("cart rendering failed");
                    return _this.render_locked = false
                })
            }
        }
        ;
        FrameworkCart.prototype.renderListener = function() {
            var _this;
            _this = this;
            return _this.root.on('renderCart', function() {
                return _this.renderCart()
            })
        }
        ;
        FrameworkCart.prototype.renderOther = function() {
            var _this;
            _this = this;
            if (theme.utils.mqs.current_window === 'small') {
                return $('.fw--cart.modal--content').trigger('renderCart')
            } else {
                return $('.fw--cart.off-canvas').trigger('renderCart')
            }
        }
        ;
        FrameworkCart.prototype.addItem = function(form, callback) {
            var _this;
            _this = this;
            if (!_this.add_locked) {
                _this.add_locked = true;
                return $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    dataType: "json",
                    data: form.serialize()
                }).done(function(data, textStatus, jqXHR) {
                    callback(true);
                    _this.renderOther();
                    return _this.add_locked = false
                }).fail(function(jqXHR, textStatus) {
                    callback(false, jqXHR.responseJSON.description);
                    return _this.add_locked = false
                })
            }
        }
        ;
        FrameworkCart.prototype.updateQuantityListeners = function() {
            var _this;
            _this = this;
            _this.table_content.find('.input--number input').attr("autocomplete", "off").on('keyup.LayoutCartModal paste.LayoutCartModal', function() {
                var input, input_wrapper, variant_id;
                input_wrapper = $(this).closest('.input--number');
                input = input_wrapper.find('input');
                if (parseInt(input.val()) > 0) {
                    input_wrapper.addClass('updating');
                    clearTimeout(_this.adjusting_qty_timer);
                    variant_id = $(this).closest('.variant-id').data('variant-id');
                    _this.adjusting_qty_timer = setTimeout(function() {
                        _this.updateCart(variant_id, parseInt(input.val()));
                        input_wrapper.removeClass('updating');
                        return _this.updateTotals()
                    }, 500)
                } else if (parseInt(input.val()) === 0) {
                    variant_id = $(this).closest('.variant-id').data('variant-id');
                    _this.removeItem(variant_id);
                    if ($(this).closest('form').find('.variant-id').length === 1) {
                        _this.root.addClass('no-items')
                    } else {
                        $(this).closest('.variant-id').remove()
                    }
                }
                return false
            });
            _this.table_content.find('.input--number .minus').on('keypress.LayoutCartModal click.LayoutCartModal', function(e) {
                var input, input_wrapper, variant_id;
                if (theme.utils.a11yClick(e) === true) {
                    input_wrapper = $(this).closest('.input--number');
                    input = input_wrapper.find('input');
                    if (parseInt(input.val()) > 1) {
                        input_wrapper.addClass('updating');
                        clearTimeout(_this.adjusting_qty_timer);
                        input.val(parseInt(input.val()) - 1);
                        variant_id = $(this).closest('.variant-id').data('variant-id');
                        _this.adjusting_qty_timer = setTimeout(function() {
                            _this.minusQuantity(variant_id, parseInt(input.val()));
                            input_wrapper.removeClass('updating');
                            return _this.updateTotals()
                        }, 500)
                    }
                    return false
                }
            });
            return _this.table_content.find('.input--number .plus').on('keypress.LayoutCartModal click.LayoutCartModal', function(e) {
                var input, input_wrapper, variant_id;
                if (theme.utils.a11yClick(e) === true) {
                    clearTimeout(_this.adjusting_qty_timer);
                    input_wrapper = $(this).closest('.input--number');
                    input = input_wrapper.find('input');
                    if (_this.temp_quantity === 0) {
                        _this.temp_quantity = parseInt(input.val())
                    }
                    input_wrapper.addClass('updating');
                    input.val(1 + parseInt(input.val()));
                    variant_id = $(this).closest('.variant-id').data('variant-id');
                    _this.adjusting_qty_timer = setTimeout(function() {
                        var add_quantity;
                        add_quantity = parseInt(input.val()) - _this.temp_quantity;
                        return _this.plusQuantity(variant_id, add_quantity, function(pass, error) {
                            if (pass) {
                                input_wrapper.removeClass('updating');
                                _this.updateTotals();
                                return _this.temp_quantity = 0
                            } else {
                                input.val(_this.temp_quantity);
                                input_wrapper.removeClass('updating');
                                _this.updateTotals();
                                return _this.temp_quantity = 0
                            }
                        })
                    }, 500);
                    return false
                }
            })
        }
        ;
        FrameworkCart.prototype.minusQuantity = function(variant_id, quantity) {
            var _this;
            _this = this;
            return $.ajax({
                type: "POST",
                url: "/cart/change.js",
                dataType: "json",
                data: 'quantity=' + quantity + '&id=' + variant_id,
                async: false
            }).done(function(data, textStatus, jqXHR) {
                if (textStatus === 'success') {
                    _this.updateTotals();
                    return _this.renderOther()
                } else {
                    return console.log('cart - update cart item status - ' + textStatus)
                }
            }).fail(function(jqXHR, textStatus) {
                return console.log("cart - update failed")
            })
        }
        ;
        FrameworkCart.prototype.plusQuantity = function(variant_id, quantity, callback) {
            var _this;
            _this = this;
            if (!_this.add_locked) {
                _this.add_locked = true;
                return $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    dataType: "json",
                    data: 'quantity=' + quantity + '&id=' + variant_id
                }).done(function(data, textStatus, jqXHR) {
                    callback(true);
                    _this.renderOther();
                    return _this.add_locked = false
                }).fail(function(jqXHR, textStatus) {
                    callback(false, jqXHR.responseJSON.description);
                    return _this.add_locked = false
                })
            }
        }
        ;
        FrameworkCart.prototype.updateTotals = function() {
            var _this;
            _this = this;
            return $.ajax({
                type: "POST",
                url: "/cart.js",
                dataType: "json"
            }).done(function(data, textStatus, jqXHR) {
                var cart, cart_total, item, j, len, ref;
                if (textStatus === 'success') {
                    cart = data;
                    cart_total = {};
                    cart_total.quantity = 0;
                    cart_total.price = 0;
                    ref = cart.items;
                    for (j = 0,
                    len = ref.length; j < len; j += 1) {
                        item = ref[j];
                        cart_total.quantity += item.quantity;
                        cart_total.price += item.price * item.quantity
                    }
                    _this.totals.count = cart_total.quantity;
                    _this.totals.price = Currency.formatMoney(cart_total.price, theme.money_format);
                    _this.render_trigger.find('.count').html(_this.totals.count);
                    _this.render_trigger.find('.total-price').html(_this.totals.price);
                    _this.table_content.find('.total').html(_this.totals.price);
                    $('.layout--header .layout--off-canvas--open.right').html(_this.totals.count);
                    $('.layout--header .cart-link .count').html('(' + _this.totals.count + ')');
                    if (_this.totals.count > 0) {
                        _this.render_trigger.css('display', 'inline-block');
                        $('.layout--header .cart-link .count').css('display', 'inline');
                        $('.header--cart-count').css('display', 'inline-block')
                    } else {
                        _this.render_trigger.hide();
                        $('.layout--header .cart-link .count').hide()
                    }
                    if (theme.currency_switcher_enabled) {
                        _this.convertCurrency(_this.render_trigger.find('.total-price'));
                        _this.convertCurrency(_this.table_content.find('.total'))
                    }
                    return _this.updateTotalsComplete()
                } else {
                    return console.log('cart - update totals item status - ' + textStatus)
                }
            }).fail(function(jqXHR, textStatus) {
                return console.log("cart - updating totals failed")
            })
        }
        ;
        FrameworkCart.prototype.updateTotalsComplete = function() {
            var _this;
            return _this = this
        }
        ;
        FrameworkCart.prototype.removeItemListeners = function() {
            var _this;
            _this = this;
            return _this.table_content.find('a.remove').on('click.LayoutCartModal', function() {
                var variant_id;
                variant_id = $(this).closest('.variant-id').data('variant-id');
                _this.removeItem(variant_id);
                if ($(this).closest('form').find('.variant-id').length === 1) {
                    _this.root.addClass('no-items');
                    $(window).trigger('resize.FrameworkModal')
                } else {
                    $(this).closest('.variant-id').remove()
                }
                _this.updateTotals();
                return false
            })
        }
        ;
        FrameworkCart.prototype.removeItem = function(variant_id) {
            var _this;
            _this = this;
            return _this.minusQuantity(variant_id, 0)
        }
        ;
        FrameworkCart.prototype.openOffCanvasListener = function() {
            var _this;
            _this = this;
            return $('.layout--off-canvas--cart--open-trigger').on('click', function() {
                $('.layout--off-canvas--right-sidebar').trigger('open');
                return false
            })
        }
        ;
        FrameworkCart.prototype.openModalListener = function() {
            var _this;
            _this = this;
            return $('.fw--cart-modal--trigger-render').on('click', function() {
                $('.cart-link .modal--link').trigger('click');
                return false
            })
        }
        ;
        FrameworkCart.prototype.convertCurrency = function(elems) {
            var _this;
            _this = this;
            if (theme.currency_switcher_enabled) {
                return Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val())
            } else {
                return false
            }
        }
        ;
        return FrameworkCart
    }
    )();
    theme.classes.FrameworkFeaturedBlog = (function() {
        function FrameworkFeaturedBlog(root) {
            var _this;
            this.root = root;
            this.resizeListeners = bind(this.resizeListeners, this);
            this.matchImageHeights = bind(this.matchImageHeights, this);
            _this = this;
            _this.item_container = _this.root.find('.featured-blog--body');
            _this.items = _this.root.find('.featured-blog--item');
            _this.matchImageHeights();
            _this.resizeListeners()
        }
        FrameworkFeaturedBlog.prototype.matchImageHeights = function() {
            var _this;
            _this = this;
            return theme.utils.matchImageHeights(_this.item_container, _this.items, '.featured-blog--item--image')
        }
        ;
        FrameworkFeaturedBlog.prototype.resizeListeners = function() {
            var _this;
            _this = this;
            return $(window).on('resize.FeaturedGrid', theme.utils.debounce(100, function() {
                return _this.matchImageHeights()
            }))
        }
        ;
        return FrameworkFeaturedBlog
    }
    )();
    theme.classes.FrameworkFeaturedCollections = (function() {
        function FrameworkFeaturedCollections(root) {
            var _this;
            this.root = root;
            this.resizeListeners = bind(this.resizeListeners, this);
            this.matchImageHeights = bind(this.matchImageHeights, this);
            _this = this;
            _this.item_container = _this.root.find('.featured-collections--body');
            _this.items = _this.root.find('.featured-collections--item');
            _this.matchImageHeights();
            _this.resizeListeners()
        }
        FrameworkFeaturedCollections.prototype.matchImageHeights = function() {
            var _this;
            _this = this;
            return theme.utils.matchImageHeights(_this.item_container, _this.items, '.featured-collections--image')
        }
        ;
        FrameworkFeaturedCollections.prototype.resizeListeners = function() {
            var _this;
            _this = this;
            return $(window).on('resize.FeaturedCollections', theme.utils.debounce(100, function() {
                return _this.matchImageHeights()
            }))
        }
        ;
        return FrameworkFeaturedCollections
    }
    )();
    theme.classes.FrameworkFeaturedContent = (function() {
        function FrameworkFeaturedContent(root) {
            var _this;
            this.root = root;
            _this = this
        }
        return FrameworkFeaturedContent
    }
    )();
    theme.classes.FrameworkFeaturedGrid = (function() {
        function FrameworkFeaturedGrid(root) {
            var _this;
            this.root = root;
            this.resizeListeners = bind(this.resizeListeners, this);
            this.matchImageHeights = bind(this.matchImageHeights, this);
            _this = this;
            _this.item_container = _this.root.find('.featured-grid--body');
            _this.items = _this.root.find('.featured-grid--item');
            _this.text_position = _this.root.data('text-position');
            _this.matchImageHeights();
            _this.resizeListeners()
        }
        FrameworkFeaturedGrid.prototype.matchImageHeights = function() {
            var _this;
            _this = this;
            if (_this.text_position === 'center' && theme.utils.mqs.current_window !== 'small') {
                return
            }
            return theme.utils.matchImageHeights(_this.item_container, _this.items, '.featured-grid--item--image')
        }
        ;
        FrameworkFeaturedGrid.prototype.resizeListeners = function() {
            var _this;
            _this = this;
            return $(window).on('resize.FeaturedGrid', theme.utils.debounce(100, function() {
                return _this.matchImageHeights()
            }))
        }
        ;
        return FrameworkFeaturedGrid
    }
    )();
    theme.classes.FrameworkFeedbackBar = (function() {
        function FrameworkFeedbackBar(root) {
            var _this;
            this.root = root;
            this.load = bind(this.load, this);
            _this = this;
            _this.messages = _this.root.find('.feedback-bar--message span');
            _this.load()
        }
        FrameworkFeedbackBar.prototype.load = function() {
            var _this, anchor_tag, message, message_elem;
            _this = this;
            _this.messages.hide();
            anchor_tag = window.location.hash.substr(1);
            message = anchor_tag.replace('feedback-bar--', '');
            message_elem = _this.messages.filter('[data-feedback-bar--message="' + message + '"]');
            if (message_elem.length) {
                message_elem.show();
                setTimeout(function() {
                    return _this.root.attr('data-feedback-bar--open', 'true')
                }, 200);
                return setTimeout(function() {
                    return _this.root.attr('data-feedback-bar--open', 'false')
                }, 3000)
            }
        }
        ;
        return FrameworkFeedbackBar
    }
    )();
    theme.classes.FrameworkLoadingAnimation = (function() {
        function FrameworkLoadingAnimation(root) {
            var _this;
            this.root = root;
            _this = this;
            if (_this.root.hasClass('tiny')) {
                _this.root.spin('tiny')
            } else {
                _this.root.spin('small')
            }
        }
        return FrameworkLoadingAnimation
    }
    )();
    theme.classes.FrameworkMap = (function() {
        function FrameworkMap(root) {
            var _this;
            this.root = root;
            this.buildStyles = bind(this.buildStyles, this);
            this.buildMap = bind(this.buildMap, this);
            this.geolocate = bind(this.geolocate, this);
            this.loadMapsApi = bind(this.loadMapsApi, this);
            this.load = bind(this.load, this);
            _this = this;
            _this.api_status = null;
            _this.map_instance = null;
            _this.key = _this.root.data('api-key');
            _this.address = _this.root.data('address');
            _this.theme = _this.root.data('theme');
            _this.styles = null;
            _this.container = _this.root.find('.map--google-maps');
            _this.center = null;
            _this.load()
        }
        FrameworkMap.prototype.load = function() {
            var _this;
            _this = this;
            if (_this.container.length > 0) {
                return _this.loadMapsApi()
            }
        }
        ;
        FrameworkMap.prototype.loadMapsApi = function() {
            var _this, other_map_loading_checker;
            _this = this;
            if (theme.utils.google_map_api_status === 'loading') {
                return other_map_loading_checker = setInterval(function() {
                    if (theme.utils.google_map_api_status === 'loaded') {
                        _this.geolocate();
                        return clearInterval(other_map_loading_checker)
                    }
                }, 100)
            } else if (typeof window.google === 'undefined') {
                theme.utils.google_map_api_status = 'loading';
                return $.getScript('https://maps.googleapis.com/maps/api/js?key=' + _this.key).then(function() {
                    _this.geolocate();
                    return theme.utils.google_map_api_status = 'loaded'
                })
            } else {
                return _this.geolocate()
            }
        }
        ;
        FrameworkMap.prototype.geolocate = function() {
            var _this, geocoder;
            _this = this;
            geocoder = new google.maps.Geocoder;
            return geocoder.geocode({
                address: _this.address
            }, function(results, status) {
                if (status === 'OK') {
                    _this.center = results[0].geometry.location;
                    _this.buildStyles();
                    return _this.buildMap()
                } else {
                    return console.log('couldn\'t convert address with geocoder')
                }
            })
        }
        ;
        FrameworkMap.prototype.buildMap = function() {
            var _this, center, map, mapOptions, marker;
            _this = this;
            mapOptions = {
                zoom: 15,
                center: _this.center,
                disableDefaultUI: true,
                zoomControl: true,
                scrollwheel: false,
                styles: _this.styles
            };
            map = new google.maps.Map(_this.container[0],mapOptions);
            center = map.getCenter();
            marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
            });
            return _this.map_instance = google.maps.event.addDomListener(window, 'resize', theme.utils.debounce(500, function() {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center)
            }))
        }
        ;
        FrameworkMap.prototype.buildStyles = function() {
            var _this;
            _this = this;
            if (_this.theme === 'grayscale') {
                return _this.styles = [{
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#f5f5f5"
                    }]
                }, {
                    "elementType": "labels.icon",
                    "stylers": [{
                        "visibility": "off"
                    }]
                }, {
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#616161"
                    }]
                }, {
                    "elementType": "labels.text.stroke",
                    "stylers": [{
                        "color": "#f5f5f5"
                    }]
                }, {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#bdbdbd"
                    }]
                }, {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#eeeeee"
                    }]
                }, {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#757575"
                    }]
                }, {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#e5e5e5"
                    }]
                }, {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#9e9e9e"
                    }]
                }, {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#ffffff"
                    }]
                }, {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#757575"
                    }]
                }, {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#dadada"
                    }]
                }, {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#616161"
                    }]
                }, {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#9e9e9e"
                    }]
                }, {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#e5e5e5"
                    }]
                }, {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#eeeeee"
                    }]
                }, {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#c9c9c9"
                    }]
                }, {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#9e9e9e"
                    }]
                }]
            } else if (_this.theme === 'dark') {
                return _this.styles = [{
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#212121"
                    }]
                }, {
                    "elementType": "labels.icon",
                    "stylers": [{
                        "visibility": "off"
                    }]
                }, {
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#757575"
                    }]
                }, {
                    "elementType": "labels.text.stroke",
                    "stylers": [{
                        "color": "#212121"
                    }]
                }, {
                    "featureType": "administrative",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#757575"
                    }]
                }, {
                    "featureType": "administrative.country",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#9e9e9e"
                    }]
                }, {
                    "featureType": "administrative.land_parcel",
                    "stylers": [{
                        "visibility": "off"
                    }]
                }, {
                    "featureType": "administrative.locality",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#bdbdbd"
                    }]
                }, {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#757575"
                    }]
                }, {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#181818"
                    }]
                }, {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#616161"
                    }]
                }, {
                    "featureType": "poi.park",
                    "elementType": "labels.text.stroke",
                    "stylers": [{
                        "color": "#1b1b1b"
                    }]
                }, {
                    "featureType": "road",
                    "elementType": "geometry.fill",
                    "stylers": [{
                        "color": "#2c2c2c"
                    }]
                }, {
                    "featureType": "road",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#8a8a8a"
                    }]
                }, {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#373737"
                    }]
                }, {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#3c3c3c"
                    }]
                }, {
                    "featureType": "road.highway.controlled_access",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#4e4e4e"
                    }]
                }, {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#616161"
                    }]
                }, {
                    "featureType": "transit",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#757575"
                    }]
                }, {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [{
                        "color": "#000000"
                    }]
                }, {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [{
                        "color": "#3d3d3d"
                    }]
                }]
            }
        }
        ;
        return FrameworkMap
    }
    )();
    theme.classes.FrameworkMediaQueries = (function() {
        function FrameworkMediaQueries() {
            this.screenSizeListener = bind(this.screenSizeListener, this);
            this.getScreenSize = bind(this.getScreenSize, this);
            this.medium_screen = 768;
            this.large_screen = 990;
            this.current_window = null;
            this.getScreenSize();
            this.screenSizeListener()
        }
        FrameworkMediaQueries.prototype.getScreenSize = function() {
            var _this;
            _this = this;
            if (window.matchMedia('only screen and (min-width: ' + _this.large_screen + 'px)').matches) {
                if (_this.current_window !== 'large') {
                    $.event.trigger("largeWindow");
                    return _this.current_window = 'large'
                }
            } else if (window.matchMedia('only screen and (min-width: ' + _this.medium_screen + 'px)').matches) {
                if (_this.current_window !== 'medium') {
                    $.event.trigger("mediumWindow");
                    return _this.current_window = 'medium'
                }
            } else {
                if (_this.current_window !== 'small') {
                    $.event.trigger("smallWindow");
                    return _this.current_window = 'small'
                }
            }
        }
        ;
        FrameworkMediaQueries.prototype.screenSizeListener = function() {
            var _this;
            _this = this;
            return $(window).resize(function() {
                return _this.getScreenSize()
            })
        }
        ;
        return FrameworkMediaQueries
    }
    )();
    theme.classes.FrameworkModal = (function() {
        function FrameworkModal(container1) {
            var _this;
            this.container = container1;
            _this = this;
            _this.fullscreen = _this.container.data('modal--fullscreen') ? true : false;
            if (_this.container.data('modal--custom-close')) {
                _this.custom_close_button = _this.container.data('modal--custom-close')
            } else {
                _this.custom_close_button = ''
            }
            _this.view = _this.container.data('modal--view');
            _this.links = _this.container.find('.modal--link');
            _this.content = _this.container.find('.modal--content');
            _this.window = _this.createModalWindow();
            _this.window_container = _this.window.find('.modal--container');
            _this.mask = _this.window.find('.modal--mask');
            _this.close_button = _this.window.find('.modal--close');
            _this.next_button = _this.window.find('.modal--next');
            _this.prev_button = _this.window.find('.modal--prev');
            _this.slider = null;
            _this.slides = null;
            _this.main_content_window = $('.off-canvas--main-content');
            _this.openListeners();
            _this.modal_state = 'closed';
            _this.nav_lock = false
        }
        FrameworkModal.prototype.createModalWindow = function() {
            var _this, window, window_html;
            _this = this;
            window = null;
            if ($('.modal--window').length) {
                window = $('.modal--window')
            } else {
                window_html = '<div class="modal--window"> <div class="modal--mask"></div> <div class="modal--container"></div> <button class="modal--close">' + theme.utils.addSymbol('cross') + '</button> <button class="modal--prev">' + theme.utils.addSymbol('chevron-left') + '</button> <button class="modal--next">' + theme.utils.addSymbol('chevron-right') + '</button> </div>';
                window = $(window_html).appendTo('body')
            }
            return window
        }
        ;
        FrameworkModal.prototype.openListeners = function() {
            var _this;
            _this = this;
            return _this.links.on('keypress.FrameworkModal, click.FrameworkModal, quick-open', function(e) {
                var clicked_item;
                if (e.type === 'keypress' && theme.utils.a11yClick(e) === false) {
                    return false
                }
                clicked_item = $(this);
                _this.links.each(function(index) {
                    if ($(this).is(clicked_item)) {
                        if (e.type === 'quick-open') {
                            return _this.open(index, true)
                        } else {
                            return _this.open(index)
                        }
                    }
                });
                return false
            })
        }
        ;
        FrameworkModal.prototype.open = function(index, quick_open) {
            var _this, scrolled_position;
            if (quick_open == null) {
                quick_open = false
            }
            _this = this;
            if (_this.modal_state === 'closed') {
                _this.modal_state = 'opened';
                $('html').addClass('modal-open');
                _this.window.attr('data-modal--fullscreen', _this.fullscreen);
                _this.window.attr('data-modal--custom-close', _this.custom_close_button);
                _this.window.attr('data-modal--view', _this.view);
                _this.closeListeners();
                _this.positionListeners();
                scrolled_position = $(window).scrollTop();
                _this.main_content_window.css({
                    position: 'fixed',
                    top: -scrolled_position
                });
                _this.moveContentToWindow();
                if (_this.slides.length > 1) {
                    _this.next_button.show();
                    _this.prev_button.show();
                    _this.prevListeners();
                    _this.nextListeners()
                }
                _this.window.show();
                _this.window_container.show();
                _this.renderVideo(_this.slides.eq(index));
                if (quick_open) {
                    _this.slides.eq(index).addClass('active');
                    return _this.position()
                } else {
                    _this.mask.fadeIn();
                    return _this.loadModal(_this.slides.eq(index), function() {
                        return setTimeout(function() {
                            return _this.window_container.find('input[type="text"]').focus()
                        }, 0)
                    })
                }
            }
        }
        ;
        FrameworkModal.prototype.moveContentToWindow = function(index) {
            var _this, content;
            _this = this;
            content = _this.container.find('.modal--content');
            _this.window_container.append(content);
            return _this.slides = _this.window_container.find('.modal--content')
        }
        ;
        FrameworkModal.prototype.detectImageSlide = function(slide) {
            var _this;
            return _this = this
        }
        ;
        FrameworkModal.prototype.renderVideo = function(slide) {
            var _this, id, iframe, src_url, type, video;
            _this = this;
            video = slide.find('.responsive-video').first();
            src_url = video.data('video');
            type = _this.extractVideoType(src_url);
            id = _this.extractVideoId(src_url, type);
            iframe = _this.createIframe(type, id);
            if (type === 'vimeo') {
                video.addClass('vimeo')
            }
            if (type === 'kickstarter') {
                video.addClass('kickstarter')
            }
            return video.append(iframe)
        }
        ;
        FrameworkModal.prototype.extractVideoType = function(src_url) {
            var _this, matches, re;
            _this = this;
            re = /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i;
            matches = re.exec(src_url);
            if (matches) {
                return 'youtube'
            }
            re = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
            matches = re.exec(src_url);
            if (matches) {
                return 'vimeo'
            }
            re = /^.*(kickstarter)\.com/g;
            matches = re.exec(src_url);
            if (matches) {
                return 'kickstarter'
            }
            return false
        }
        ;
        FrameworkModal.prototype.extractVideoId = function(src_url, type) {
            var _this, match, regExp;
            _this = this;
            if (type === 'youtube') {
                regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                match = src_url.match(regExp);
                if (match && match[2].length === 11) {
                    return match[2]
                }
            } else if (type === "vimeo") {
                regExp = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
                match = src_url.match(regExp);
                if (match) {
                    return match[2]
                }
            } else if (type === "kickstarter") {
                regExp = /(?:kickstarter\.com\/projects\/)(.*)(|\?)/;
                match = src_url.match(regExp);
                if (match) {
                    return match[1]
                }
            }
        }
        ;
        FrameworkModal.prototype.createIframe = function(type, id) {
            var _this;
            _this = this;
            if (type === "youtube") {
                return '<iframe  src="//www.youtube.com/embed/' + id + '?autoplay=1" frameborder="0" allowfullwidth></iframe>'
            } else if (type === "vimeo") {
                return '<iframe src="//player.vimeo.com/video/' + id + '?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>'
            } else if (type === "kickstarter") {
                return '<iframe src="//www.kickstarter.com/projects/' + id + '/widget/video.html" frameborder="0" webkitallowfullwidth mozallowfullwidth allowfullwidth></iframe>'
            }
        }
        ;
        FrameworkModal.prototype.removeVideos = function() {
            var _this;
            _this = this;
            return _this.slides.find('.responsive-video').each(function() {
                if ($(this).data('video')) {
                    return $(this).find('iframe').remove()
                }
            })
        }
        ;
        FrameworkModal.prototype.loadModal = function(modal, callback) {
            var _this;
            _this = this;
            modal.addClass('active');
            _this.position();
            if (callback) {
                callback()
            }
            return _this.nav_lock = false
        }
        ;
        FrameworkModal.prototype.position = function() {
            var _this, active_modal, entire_modal_height, modal_height, modal_width;
            _this = this;
            if (_this.window_container != null) {
                active_modal = _this.content.filter('.active');
                _this.window_container.attr('style', '');
                _this.positionVideoColumns(active_modal);
                _this.detectImageSlide(active_modal);
                _this.window.removeClass('fixed');
                modal_height = active_modal.outerHeight();
                modal_width = active_modal.outerWidth();
                entire_modal_height = modal_height + parseInt(_this.window.css('padding-top')) + parseInt(_this.window.css('padding-bottom'));
                if (_this.fullscreen) {
                    return
                }
                if (active_modal.hasClass('type--image')) {
                    entire_modal_height = modal_height
                }
                if ($(window).height() >= entire_modal_height) {
                    return _this.window.addClass('fixed')
                } else {
                    $("html, body").animate({
                        scrollTop: 0
                    }, '0');
                    $('body,html').on('DOMMouseScroll.FrameworkModal mousewheel.FrameworkModal touchmove.FrameworkModal', function(e) {
                        if (e.which > 0 || e.type === "mousewheel" || e.type === "touchmove") {
                            return $("html,body").stop()
                        }
                    });
                    return _this.window.removeClass('fixed')
                }
            }
        }
        ;
        FrameworkModal.prototype.positionVideoColumns = function(modal) {
            var _this, column_one, column_two, height_one, height_two;
            _this = this;
            if (modal.find('.responsive-video').length > 0) {
                column_one = modal.find('.fw--blocks > div').eq(0);
                column_two = modal.find('.fw--blocks > div').eq(1);
                column_one.css({
                    width: ''
                });
                column_two.css({
                    width: ''
                });
                height_one = column_one.outerHeight();
                height_two = column_two.outerHeight();
                if (height_one < height_two) {
                    column_one.css({
                        width: '100%'
                    });
                    return column_two.css({
                        width: '100%'
                    })
                }
            }
        }
        ;
        FrameworkModal.prototype.positionListeners = function() {
            var _this;
            _this = this;
            return $(window).on('resize.FrameworkModal', function() {
                return _this.position()
            })
        }
        ;
        FrameworkModal.prototype.nextListeners = function() {
            var _this;
            _this = this;
            $(document).on('keydown.FrameworkModal', function(e) {
                if (e.keyCode === 39) {
                    return _this.next()
                }
            });
            return _this.next_button.on('click.FrameworkModal', function() {
                return _this.next()
            })
        }
        ;
        FrameworkModal.prototype.next = function() {
            var _this, active_slide, index;
            _this = this;
            if (!_this.nav_lock) {
                _this.nav_lock = true;
                index = _this.slides.filter('.active').index();
                _this.slides.removeClass('active');
                _this.removeVideos();
                if ((index + 1) === _this.slides.length) {
                    active_slide = _this.slides.eq(0)
                } else {
                    active_slide = _this.slides.eq(index + 1)
                }
                _this.renderVideo(active_slide);
                return _this.loadModal(active_slide)
            }
        }
        ;
        FrameworkModal.prototype.prevListeners = function() {
            var _this;
            _this = this;
            $(document).on('keydown.FrameworkModal', function(e) {
                if (e.keyCode === 37) {
                    return _this.prev()
                }
            });
            return _this.prev_button.on('click.FrameworkModal', function() {
                return _this.prev()
            })
        }
        ;
        FrameworkModal.prototype.prev = function() {
            var _this, active_slide, index;
            _this = this;
            if (!_this.nav_lock) {
                _this.nav_lock = true;
                index = _this.slides.filter('.active').index();
                _this.slides.removeClass('active');
                _this.removeVideos();
                if (index === 0) {
                    active_slide = _this.slides.eq(_this.slides.length - 1)
                } else {
                    active_slide = _this.slides.eq(index - 1)
                }
                _this.renderVideo(active_slide);
                return _this.loadModal(active_slide)
            }
        }
        ;
        FrameworkModal.prototype.closeListeners = function() {
            var _this;
            _this = this;
            _this.container.on('quick-close', function() {
                return _this.close(true)
            });
            $(document).on('keydown.FrameworkModal', function(e) {
                if (e.keyCode === 27) {
                    return _this.close()
                }
            });
            _this.mask.on('click.FrameworkModal', function() {
                return _this.close()
            });
            _this.window_container.on('click.FrameworkModal', function() {
                return _this.close()
            });
            _this.content.on('click.FrameworkModal', function(e) {
                return e.stopPropagation()
            });
            return _this.close_button.on('click.FrameworkModal', function() {
                return _this.close()
            })
        }
        ;
        FrameworkModal.prototype.close = function(quick_close) {
            var _this, scrolled_position;
            if (quick_close == null) {
                quick_close = false
            }
            _this = this;
            scrolled_position = parseInt(_this.main_content_window.css('top')) * -1;
            _this.container.trigger('modalClosed');
            _this.main_content_window.css({
                top: '0',
                position: 'relative'
            });
            $(window).scrollTop(scrolled_position);
            _this.putBackContent();
            _this.next_button.hide();
            _this.prev_button.hide();
            _this.window.hide();
            if (quick_close) {
                _this.mask.hide();
                this.window_container.empty();
                _this.modal_state = 'closed'
            } else {
                _this.mask.fadeOut(function() {
                    _this.window_container.empty();
                    return _this.modal_state = 'closed'
                })
            }
            $('html').removeClass('modal-open');
            _this.removeListeners();
            return $(window).trigger('FrameworkModal.afterClose')
        }
        ;
        FrameworkModal.prototype.putBackContent = function() {
            var _this;
            _this = this;
            _this.removeVideos();
            return _this.slides.removeClass('active').appendTo(_this.container)
        }
        ;
        FrameworkModal.prototype.removeListeners = function() {
            var _this;
            _this = this;
            $(document).off('keydown.FrameworkModal');
            $(window).off('resize.FrameworkModal');
            $('body,html').off('DOMMouseScroll.FrameworkModal mousewheel.FrameworkModal touchmove.FrameworkModal');
            _this.next_button.off('click.FrameworkModal');
            _this.prev_button.off('click.FrameworkModal');
            _this.close_button.off('click.FrameworkModal');
            _this.mask.off('click.FrameworkModal');
            return _this.window_container.off('click.FrameworkModal')
        }
        ;
        return FrameworkModal
    }
    )();
    theme.classes.FrameworkOffCanvas = (function() {
        function FrameworkOffCanvas(root) {
            var _this;
            this.root = root;
            this.touchListener = bind(this.touchListener, this);
            this.closeRight = bind(this.closeRight, this);
            this.closeLeft = bind(this.closeLeft, this);
            this.fadeInOverlay = bind(this.fadeInOverlay, this);
            this.openRight = bind(this.openRight, this);
            this.openLeft = bind(this.openLeft, this);
            this.toggle = bind(this.toggle, this);
            this.toggleListeners = bind(this.toggleListeners, this);
            this.viewPortHeightListener = bind(this.viewPortHeightListener, this);
            this.setViewPortHeight = bind(this.setViewPortHeight, this);
            this.setState = bind(this.setState, this);
            this.unload = bind(this.unload, this);
            this.load = bind(this.load, this);
            _this = this;
            _this.viewport = $('.off-canvas--viewport');
            _this.left_sidebar = $('.off-canvas--left-sidebar');
            _this.right_sidebar = $('.off-canvas--right-sidebar');
            _this.main_content = $('.off-canvas--main-content');
            _this.overlay = $('.off-canvas--overlay');
            _this.state = 'closed';
            _this.load()
        }
        FrameworkOffCanvas.prototype.load = function() {
            var _this;
            _this = this;
            _this.close = $('.off-canvas--close');
            _this.triggers = $('.off-canvas--open');
            _this.setViewPortHeight();
            _this.viewPortHeightListener();
            _this.toggleListeners();
            return _this.touchListener()
        }
        ;
        FrameworkOffCanvas.prototype.unload = function() {
            var _this;
            _this = this;
            _this.triggers.off('mousedown');
            _this.overlay.add(_this.close).off('click');
            $(document).off('touchstart.FrameworkOffCanvas');
            return $(document).off('touchend.FrameworkOffCanvas')
        }
        ;
        FrameworkOffCanvas.prototype.setState = function(state) {
            var _this;
            _this = this;
            _this.state = state;
            return _this.root.attr('data-off-canvas--state', state)
        }
        ;
        FrameworkOffCanvas.prototype.setViewPortHeight = function() {
            var _this;
            _this = this;
            return _this.viewport.css({
                'min-height': $(window).height()
            })
        }
        ;
        FrameworkOffCanvas.prototype.viewPortHeightListener = function() {
            var _this;
            _this = this;
            return $(window).resize(function() {
                return _this.setViewPortHeight()
            })
        }
        ;
        FrameworkOffCanvas.prototype.toggleListeners = function() {
            var _this;
            _this = this;
            _this.triggers.on('mousedown', function() {
                if ($(this).data('off-canvas--open') === 'left-sidebar') {
                    _this.toggle('left-sidebar')
                } else if ($(this).data('off-canvas--open') === 'right-sidebar') {
                    _this.toggle('right-sidebar')
                }
                return false
            });
            return _this.overlay.add(_this.close).on('click', function() {
                if (_this.state === 'left-open') {
                    return _this.toggle('left-sidebar')
                } else if (_this.state === 'right-open') {
                    return _this.toggle('right-sidebar')
                }
            })
        }
        ;
        FrameworkOffCanvas.prototype.toggle = function(element) {
            var _this;
            _this = this;
            if (element === 'left-sidebar' && _this.state === 'closed') {
                return _this.openLeft()
            } else if (element === 'left-sidebar' && _this.state === 'left-open') {
                return _this.closeLeft()
            } else if (element === 'right-sidebar' && _this.state === 'closed') {
                return _this.openRight()
            } else if (element === 'right-sidebar' && _this.state === 'right-open') {
                return _this.closeRight()
            }
        }
        ;
        FrameworkOffCanvas.prototype.openLeft = function() {
            var _this;
            _this = this;
            _this.setState('left-open');
            _this.main_content.css({
                position: 'fixed',
                top: -($(window).scrollTop())
            });
            _this.left_sidebar.velocity({
                translateX: [0, '-100%']
            }, {
                complete: function() {
                    return _this.left_sidebar.css({
                        position: 'absolute'
                    })
                }
            });
            return _this.fadeInOverlay()
        }
        ;
        FrameworkOffCanvas.prototype.openRight = function() {
            var _this;
            _this = this;
            _this.setState('right-open');
            _this.main_content.css({
                position: 'fixed',
                top: -($(window).scrollTop())
            });
            _this.right_sidebar.velocity({
                translateX: ['-100%', 0]
            }, {
                complete: function() {
                    return _this.right_sidebar.css({
                        position: 'relative'
                    })
                }
            });
            return _this.fadeInOverlay()
        }
        ;
        FrameworkOffCanvas.prototype.fadeInOverlay = function() {
            var _this;
            _this = this;
            _this.overlay.show();
            return _this.overlay.velocity({
                opacity: '0.3'
            })
        }
        ;
        FrameworkOffCanvas.prototype.closeLeft = function() {
            var _this, scrolled_position;
            _this = this;
            if (_this.state !== 'left-open') {
                return false
            }
            _this.setState('closed');
            scrolled_position = parseInt(_this.main_content.css('top')) * -1;
            _this.left_sidebar.velocity({
                translateX: ['-100%', 0]
            }, {
                complete: function() {
                    _this.left_sidebar.css({
                        position: 'absolute'
                    });
                    _this.main_content.css({
                        position: 'relative',
                        top: 'initial'
                    });
                    return $(window).scrollTop(scrolled_position)
                }
            });
            return _this.overlay.velocity('fadeOut')
        }
        ;
        FrameworkOffCanvas.prototype.closeRight = function() {
            var _this, scrolled_position;
            _this = this;
            if (_this.state !== 'right-open') {
                return false
            }
            _this.setState('closed');
            scrolled_position = parseInt(_this.main_content.css('top')) * -1;
            _this.right_sidebar.velocity({
                translateX: [0, '-100%']
            }, {
                complete: function() {
                    _this.right_sidebar.css({
                        position: 'absolute'
                    });
                    _this.main_content.css({
                        position: 'relative',
                        top: 'initial'
                    });
                    return $(window).scrollTop(scrolled_position)
                }
            });
            return _this.overlay.velocity('fadeOut')
        }
        ;
        FrameworkOffCanvas.prototype.touchListener = function() {
            var _this, position;
            _this = this;
            if (!Modernizr.touchevents) {
                return false
            }
            position = {
                start: {},
                end: {}
            };
            $(document).on('touchstart.FrameworkOffCanvas', function(e) {
                position.start.x = e.originalEvent.touches[0].clientX;
                position.start.y = e.originalEvent.touches[0].clientY
            });
            return $(document).on('touchend.FrameworkOffCanvas', function(e) {
                position.end.x = e.originalEvent.changedTouches[0].clientX;
                position.end.y = e.originalEvent.changedTouches[0].clientY;
                if (Math.abs(position.start.y - position.end.y) > 30) {
                    return false
                }
                if (position.start.x > position.end.x + 5) {
                    return _this.closeLeft()
                } else if (position.start.x < position.end.x - 5) {
                    return _this.closeRight()
                }
            })
        }
        ;
        return FrameworkOffCanvas
    }
    )();
    theme.classes.FrameworkSearch = (function() {
        function FrameworkSearch(root) {
            var _this;
            this.root = root;
            this.linkRows = bind(this.linkRows, this);
            this.hideResults = bind(this.hideResults, this);
            this.getResults = bind(this.getResults, this);
            this.clear = bind(this.clear, this);
            this.focusModalAlways = bind(this.focusModalAlways, this);
            this.listenForKeyEntered = bind(this.listenForKeyEntered, this);
            this.loadSpinners = bind(this.loadSpinners, this);
            _this = this;
            _this.toggle_link = _this.root.find('.search--toggle');
            _this.form = _this.root.find('form');
            _this.text_box = _this.root.find('.search--textbox');
            _this.loading = _this.root.find('.search--loading');
            _this.no_results = _this.root.find('.search--no-results');
            _this.results = _this.root.find('.search--results');
            _this.view = _this.root.data('search--view');
            _this.icon = _this.root.find('.search--icon');
            _this.clear_button = _this.root.find('.search--clear');
            _this.max_results = 12;
            _this.ajax_request = null;
            _this.search_term = null;
            _this.search_url = null;
            _this.close_results_timer = null;
            _this.typing_timer = null;
            _this.focusModalAlways();
            _this.listenForKeyEntered();
            _this.loadSpinners();
            _this.clear()
        }
        FrameworkSearch.prototype.loadSpinners = function() {
            var _this, spinner;
            _this = this;
            spinner = _this.loading.find('.animation');
            if (spinner.hasClass('tiny')) {
                return spinner.spin('tiny')
            } else {
                return spinner.spin('small')
            }
        }
        ;
        FrameworkSearch.prototype.listenForKeyEntered = function() {
            var _this;
            _this = this;
            return _this.text_box.attr("autocomplete", "off").on("keyup paste", function() {
                var term;
                clearTimeout(_this.typing_timer);
                term = $(this).val();
                if (term.length < 2) {
                    _this.results.empty();
                    _this.hideResults();
                    _this.loading.hide();
                    _this.icon.show();
                    _this.no_results.hide();
                    _this.clear('checkToggle');
                    return false
                }
                _this.results.hide();
                _this.loading.show();
                _this.icon.hide();
                _this.no_results.hide();
                _this.clear('checkToggle');
                return _this.typing_timer = setTimeout(function() {
                    _this.search_url = "/search?type=product&q=" + term;
                    return _this.getResults(term)
                }, 300)
            })
        }
        ;
        FrameworkSearch.prototype.focusModalAlways = function() {
            var _this;
            _this = this;
            if (_this.view === 'grid') {
                return _this.root.on('click', function() {
                    return _this.text_box.focus()
                })
            }
        }
        ;
        FrameworkSearch.prototype.clear = function(event) {
            var _this;
            _this = this;
            if (event === 'checkToggle') {
                if (_this.text_box.val().length > 0) {
                    return _this.clear_button.show()
                } else {
                    _this.clear_button.hide();
                    return _this.text_box.trigger('keyup')
                }
            } else {
                return _this.clear_button.on('click', function() {
                    _this.text_box.val('');
                    return _this.clear('checkToggle')
                })
            }
        }
        ;
        FrameworkSearch.prototype.getResults = function(term) {
            var _this;
            _this = this;
            _this.results.empty();
            _this.ajax_request = $.getJSON(_this.search_url + "&view=json", function(data) {
                if (data.results_count === 0) {
                    _this.close_results_timer = setTimeout(function() {
                        _this.hideResults();
                        _this.no_results.show();
                        _this.loading.hide();
                        return _this.icon.show()
                    }, 300)
                } else {
                    clearTimeout(_this.close_results_timer);
                    _this.loading.hide();
                    _this.icon.show();
                    _this.no_results.hide();
                    _this.results.show();
                    _this.results.stop(true, true).fadeIn(0);
                    $.each(data.results, function(index, item) {
                        var image, row;
                        if (index >= _this.max_results) {
                            return
                        }
                        if (_this.view === 'modal') {
                            image = item.image_modal
                        } else if (_this.view === 'sidebar') {
                            image = item.image_sidebar
                        }
                        row = $('<a class="search--item" href="' + item.url + '"> <span class="search--image"><img src="' + image + '" /></span> <span class="search--title">' + item.title + '</span> </a>');
                        _this.results.append(row);
                        if (_this.view === 'modal') {
                            $(window).trigger('resize.FrameworkModal');
                            setTimeout(function() {
                                return $(window).trigger('resize.FrameworkModal')
                            }, 100)
                        }
                    });
                    $.event.trigger("ie8ClearingFix");
                    if (data.results_count > _this.max_results) {
                        _this.results.append('<div class="search--view-more"> <a href="' + _this.search_url + '">' + theme.translations.general_search_see_all_results + ' ("' + data.results_count + '") </a> </div>')
                    }
                }
            }).fail(function() {
                return console.log("error retrieving search.json results")
            })
        }
        ;
        FrameworkSearch.prototype.hideResults = function() {
            var _this;
            _this = this;
            return _this.results.fadeOut(0)
        }
        ;
        FrameworkSearch.prototype.linkRows = function() {
            var _this;
            _this = this;
            return _this.results.find("td").on('click', function() {
                var link;
                link = $(this).parent().attr('data-link');
                if (link.length) {
                    return window.location = link
                }
            })
        }
        ;
        return FrameworkSearch
    }
    )();
    theme.classes.Sections = (function() {
        function Sections() {
            this.unload = bind(this.unload, this);
            this.deselectBlock = bind(this.deselectBlock, this);
            this.selectBlock = bind(this.selectBlock, this);
            this.deselectSection = bind(this.deselectSection, this);
            this.selectSection = bind(this.selectSection, this);
            this.load = bind(this.load, this);
            this.getActiveBlock = bind(this.getActiveBlock, this);
            this.getActiveSection = bind(this.getActiveSection, this);
            this.listeners = bind(this.listeners, this);
            var _this;
            _this = this;
            _this.listeners()
        }
        Sections.prototype.listeners = function() {
            var _this;
            _this = this;
            _this.load();
            _this.unload();
            _this.selectSection();
            _this.deselectSection();
            _this.selectBlock();
            return _this.deselectBlock()
        }
        ;
        Sections.prototype.getActiveSection = function(evt) {
            var _this, active_section;
            _this = this;
            active_section = $(evt.target).find('[data-section-id]');
            return active_section
        }
        ;
        Sections.prototype.getActiveBlock = function(evt) {
            var _this, active_block;
            _this = this;
            active_block = $(evt.target);
            return active_block
        }
        ;
        Sections.prototype.load = function(evt) {
            var _this;
            _this = this;
            return $(document).on('shopify:section:load', function(evt) {
                var active_section;
                theme.utils.loadJsClasses();
                active_section = _this.getActiveSection(evt);
                active_section.triggerHandler("theme:section:load");
                return active_section.find('[data-js-class]').each(function() {
                    return $(this).triggerHandler("theme:section:load")
                })
            })
        }
        ;
        Sections.prototype.selectSection = function() {
            var _this;
            _this = this;
            return $(document).on('shopify:section:select', function(evt) {
                var active_section;
                active_section = _this.getActiveSection(evt);
                return active_section.triggerHandler("theme:section:select")
            })
        }
        ;
        Sections.prototype.deselectSection = function() {
            var _this;
            _this = this;
            return $(document).on('shopify:section:deselect', function(evt) {
                var active_section;
                active_section = _this.getActiveSection(evt);
                return active_section.triggerHandler('theme:section:deselect')
            })
        }
        ;
        Sections.prototype.selectBlock = function() {
            var _this;
            _this = this;
            return $(document).on('shopify:block:select', function(evt) {
                var active_block;
                active_block = _this.getActiveBlock(evt);
                return active_block.triggerHandler('theme:block:select')
            })
        }
        ;
        Sections.prototype.deselectBlock = function() {
            var _this;
            _this = this;
            return $(document).on('shopify:block:deselect', function(evt) {
                var active_block;
                active_block = _this.getActiveBlock(evt);
                return active_block.triggerHandler('theme:block:deselect')
            })
        }
        ;
        Sections.prototype.unload = function(evt) {
            var _this;
            _this = this;
            return $(document).on('shopify:section:unload', function(evt) {
                var active_section;
                active_section = _this.getActiveSection(evt);
                active_section.triggerHandler("theme:section:unload");
                return active_section.find('[data-js-loaded="true"]').each(function() {
                    return $(this).triggerHandler("theme:section:unload")
                })
            })
        }
        ;
        return Sections
    }
    )();
    theme.classes.FrameworkSlider = (function() {
        function FrameworkSlider(container1) {
            this.container = container1;
            this.eventListeners = bind(this.eventListeners, this);
            this.alignPlayButton = bind(this.alignPlayButton, this);
            this.updateContextMenu = bind(this.updateContextMenu, this);
            this.autoplay = bind(this.autoplay, this);
            this.formatPaginationNumbers = bind(this.formatPaginationNumbers, this);
            this.getActiveIndex = bind(this.getActiveIndex, this);
            this.createSlider = bind(this.createSlider, this);
            this.autoplay_enabled = this.container.data('autoplay') ? true : false;
            this.navigation = this.container.data('navigation') ? true : false;
            this.pagination_numbers = this.container.data('pagination-numbers') ? true : false;
            this.autoplay_frequency = 3000;
            this.slide_length = this.container.children().length;
            this.active_index = 0;
            this.news_panel = this.container.data('news-panel') ? true : false;
            this.createSlider();
            this.eventListeners();
            this.owl = this.container.data('owlCarousel')
        }
        FrameworkSlider.prototype.createSlider = function() {
            var _this, slider;
            _this = this;
            slider = this.container.owlCarousel({
                singleItem: true,
                navigation: _this.navigation,
                navigationText: false,
                pagination: _this.container.data('pagination') ? true : false,
                paginationNumbers: _this.pagination_numbers,
                scrollPerPageNav: true,
                slideSpeed: 800,
                autoHeight: false,
                autoPlay: _this.autoplay(),
                afterInit: function() {},
                afterAction: function() {
                    _this.alignPlayButton();
                    _this.active_index = _this.getActiveIndex();
                    _this.updateContextMenu(_this.active_index);
                    return _this.formatPaginationNumbers()
                }
            });
            if (_this.navigation) {
                slider.find('.owl-prev').html(theme.utils.addSymbol('chevron-left'));
                slider.find('.owl-next').html(theme.utils.addSymbol('chevron-right'))
            }
            return slider
        }
        ;
        FrameworkSlider.prototype.getActiveIndex = function() {
            return this.container.find('.owl-pagination .owl-page.active').index()
        }
        ;
        FrameworkSlider.prototype.formatPaginationNumbers = function() {
            return this.container.find('.owl-page.active .owl-numbers').text((this.active_index + 1) + "/" + this.slide_length)
        }
        ;
        FrameworkSlider.prototype.autoplay = function() {
            if (this.autoplay_enabled) {
                return this.autoplay_frequency
            }
            return false
        }
        ;
        FrameworkSlider.prototype.updateContextMenu = function(index) {
            var context_navigation, type_class;
            if (this.news_panel) {
                type_class = '.' + this.container.find('.slide').eq(index).data('feed-type');
                context_navigation = this.container.closest('.template--index--news').find('.context-navigation');
                context_navigation.find('.item').hide();
                return context_navigation.find(type_class).show()
            }
        }
        ;
        FrameworkSlider.prototype.alignPlayButton = function() {
            var play_button, play_button_height, slide, slide_height, video_offset;
            slide = this.container.find('.owl-item').eq(this.active_index);
            play_button = slide.find('.play-button');
            if (play_button.length === 0) {
                return
            }
            play_button.css('visibility', 'hidden');
            if (PAGE.hasClass('transparent-menu') && $('.main-header').css('position') === 'absolute') {
                slide_height = slide.outerHeight();
                play_button_height = play_button.outerHeight();
                video_offset = (slide_height - play_button_height) / 2;
                play_button.css({
                    'margin-top': 0,
                    'top': video_offset
                })
            } else {
                play_button.css({
                    'margin-top': '-40px',
                    'top': '50%'
                })
            }
            return play_button.css('visibility', 'visible')
        }
        ;
        FrameworkSlider.prototype.eventListeners = function() {
            var _this;
            _this = this;
            this.container.find(".play-button").on('click', function() {
                var video_modal;
                video_modal = new VideoModal($(this).closest('.video'));
                video_modal.open();
                _this.owl.stop();
                return false
            });
            return this.container.find('.owl-pagination .owl-page, .skip-to-next').on('click', function() {
                _this.owl.next();
                return false
            })
        }
        ;
        return FrameworkSlider
    }
    )();
    theme.classes.FrameworkStickyColumn = (function() {
        function FrameworkStickyColumn(container1, column_a, column_b, mq) {
            this.container = container1;
            this.column_a = column_a;
            this.column_b = column_b;
            this.mq = mq;
            this.Listeners = bind(this.Listeners, this);
            this.setColumnPosition = bind(this.setColumnPosition, this);
            this.getAlignment = bind(this.getAlignment, this);
            this.getState = bind(this.getState, this);
            this.resetLargerColumn = bind(this.resetLargerColumn, this);
            this.getSmallerColumn = bind(this.getSmallerColumn, this);
            this.heightsHaveChanged = bind(this.heightsHaveChanged, this);
            this.setHeights = bind(this.setHeights, this);
            this.loadColumns = bind(this.loadColumns, this);
            if (Modernizr.touchevents) {
                return false
            }
            this.current_state = 'auto';
            this.column_a_height = 0;
            this.column_b_height = 0;
            this.loadColumns()
        }
        FrameworkStickyColumn.prototype.loadColumns = function() {
            var _this;
            _this = this;
            return theme.utils.imagesLoaded(_this.container, function() {
                _this.Listeners();
                return _this.setColumnPosition()
            })
        }
        ;
        FrameworkStickyColumn.prototype.setHeights = function() {
            this.column_a_height = this.column_a.outerHeight();
            return this.column_b_height = this.column_b.outerHeight()
        }
        ;
        FrameworkStickyColumn.prototype.heightsHaveChanged = function() {
            if (this.column_a.outerHeight() !== this.column_a_height) {
                this.setHeights();
                return true
            }
            if (this.column_b.outerHeight() !== this.column_b_height) {
                this.setHeights();
                return true
            }
            return false
        }
        ;
        FrameworkStickyColumn.prototype.getSmallerColumn = function() {
            if (this.column_a_height < this.column_b_height) {
                return this.column_a
            } else {
                return this.column_b
            }
        }
        ;
        FrameworkStickyColumn.prototype.resetLargerColumn = function() {
            if (this.column_a_height > this.column_b_height) {
                return this.column_a.css({
                    'position': 'relative',
                    'top': 'auto',
                    'bottom': 'auto'
                })
            } else {
                return this.column_b.css({
                    'position': 'relative',
                    'top': 'auto',
                    'bottom': 'auto'
                })
            }
        }
        ;
        FrameworkStickyColumn.prototype.getState = function(scroll_pos, window_height, column) {
            var column_height, height_for_bottom, overflowing_column, state;
            state = 'auto';
            if (this.mq.current_window === 'small') {
                return 'auto'
            }
            column_height = column.outerHeight();
            if (window_height > column_height) {
                overflowing_column = true
            }
            if (scroll_pos < this.container.offset().top) {
                state = 'auto'
            }
            if (overflowing_column) {
                height_for_bottom = column_height
            } else {
                height_for_bottom = window_height
            }
            if ((scroll_pos + height_for_bottom) > (this.container.offset().top + this.container.outerHeight())) {
                state = 'absolute-bottom'
            } else if (scroll_pos > this.container.offset().top && overflowing_column) {
                state = 'fixed-top'
            } else if (window_height < column_height && (scroll_pos + window_height) > (this.container.offset().top + column.outerHeight())) {
                state = 'fixed-bottom'
            }
            return state
        }
        ;
        FrameworkStickyColumn.prototype.getAlignment = function(column) {
            if (column.hasClass('column-a')) {
                return 'left'
            } else if (column.hasClass('column-b')) {
                return 'right'
            }
        }
        ;
        FrameworkStickyColumn.prototype.setColumnPosition = function() {
            var _this, align, column, state;
            _this = this;
            _this.setHeights();
            column = _this.getSmallerColumn();
            state = _this.getState($(window).scrollTop(), $(window).height(), column);
            align = _this.getAlignment(column);
            if (state === 'auto' && this.current_state !== 'auto') {
                this.current_state = 'auto';
                column.css({
                    'position': 'relative',
                    'top': 'auto',
                    'bottom': 'auto'
                })
            } else if (state === 'fixed-bottom' && this.current_state !== 'fixed-bottom') {
                this.current_state = 'fixed-bottom';
                column.css({
                    'position': 'fixed',
                    'top': 'auto',
                    'bottom': 0
                })
            } else if (state === 'fixed-top' && this.current_state !== 'fixed-top') {
                this.current_state = 'fixed-top';
                column.css({
                    'position': 'fixed',
                    'top': 0,
                    'bottom': 'auto'
                })
            } else if (state === 'absolute-bottom' && this.current_state !== 'absolute-bottom') {
                this.current_state = 'absolute-bottom';
                column.css({
                    'position': 'absolute',
                    'top': 'auto',
                    'bottom': 0
                })
            }
            if (align === 'right') {
                return column.css({
                    'right': 0
                })
            }
        }
        ;
        FrameworkStickyColumn.prototype.Listeners = function() {
            var _this;
            _this = this;
            $(window).scroll(function() {
                return _this.setColumnPosition()
            });
            setInterval(function() {
                if (_this.heightsHaveChanged()) {
                    _this.resetLargerColumn();
                    return _this.setColumnPosition()
                }
            }, 250);
            return $(window).resize(function() {
                _this.resetLargerColumn();
                return _this.setColumnPosition()
            })
        }
        ;
        return FrameworkStickyColumn
    }
    )();
    theme.classes.FrameworkUtils = (function() {
        function FrameworkUtils() {
            var _this;
            _this = this;
            _this.google_map_api_status = null
        }
        FrameworkUtils.prototype.debounce = function(delay, fn) {
            var timeoutId;
            timeoutId = void 0;
            return function() {
                if (timeoutId) {
                    clearTimeout(timeoutId)
                }
                timeoutId = setTimeout(fn.bind(this), delay, arguments)
            }
        }
        ;
        FrameworkUtils.prototype.imagesLoaded = function(selector, callback) {
            var count, images_length;
            count = 0;
            images_length = selector.find('img[data-sizes="auto"]').length;
            if (images_length < 1) {
                callback();
                return
            }
            return selector.on('lazybeforeunveil', function(e) {
                return $(e.target).one('load', function() {
                    count += 1;
                    if (count === images_length) {
                        return callback()
                    }
                })
            })
        }
        ;
        FrameworkUtils.prototype.a11yClick = function(event) {
            var code;
            if (event.type === 'click') {
                return true
            } else if (event.type === 'keypress') {
                code = event.charCode || event.keyCode;
                if (code === 32) {
                    event.preventDefault()
                }
                if (code === 32 || code === 13) {
                    return true
                }
            }
            return false
        }
        ;
        FrameworkUtils.prototype.matchImageHeights = function(container, items, image_class) {
            var _this, greatest_image_height, items_per_row, row_items;
            _this = this;
            items_per_row = Math.round(container.width() / items.first().outerWidth());
            greatest_image_height = 0;
            row_items = $();
            items.find(image_class).css('height', 'auto');
            items.find('.placeholder--root').css('height', 'auto');
            return items.each(function(index) {
                var this_height;
                if ($(this).find('.image--root').length > 0) {
                    this_height = $(this).find(image_class + ' .image--root').outerHeight()
                } else {
                    this_height = $(this).find('.placeholder--root').outerHeight()
                }
                row_items = row_items.add($(this));
                if (this_height > greatest_image_height) {
                    greatest_image_height = this_height
                }
                if (index % items_per_row === items_per_row - 1 || index + 1 === items.length) {
                    row_items.find(image_class + ', .placeholder--root').height(greatest_image_height);
                    greatest_image_height = 0;
                    return row_items = $()
                }
            })
        }
        ;
        return FrameworkUtils
    }
    )();
    theme.classes.FrameworkVideo = (function() {
        function FrameworkVideo(root) {
            var _this;
            this.root = root;
            _this = this;
            _this.root.fitVids()
        }
        return FrameworkVideo
    }
    )();
    theme.classes.FrameworkXMenu = (function() {
        function FrameworkXMenu(root) {
            var _this;
            this.root = root;
            this.slideUp = bind(this.slideUp, this);
            this.slideDown = bind(this.slideDown, this);
            this.arrangeMegaNav = bind(this.arrangeMegaNav, this);
            this.resizeListeners = bind(this.resizeListeners, this);
            this.checkOverlap = bind(this.checkOverlap, this);
            this.listeners = bind(this.listeners, this);
            this.load = bind(this.load, this);
            _this = this;
            _this.debugging = false;
            _this.state = 'closed';
            _this.parent_links = _this.root.find('.x-menu--level-1--link > a');
            _this.sub_menu_links = _this.root.find('.x-menu--level-1--link:not([data-x-menu--depth="1"]) > a');
            _this.sub_menu_items = _this.sub_menu_links.parent().find('ul a');
            _this.parents_with_sub_menu = _this.sub_menu_links.parent();
            _this.overlap_parent = _this.root.data('x-menu--overlap-parent');
            _this.load()
        }
        FrameworkXMenu.prototype.load = function() {
            var _this;
            _this = this;
            _this.arrangeMegaNav();
            _this.listeners();
            _this.checkOverlap();
            return _this.resizeListeners()
        }
        ;
        FrameworkXMenu.prototype.listeners = function() {
            var _this;
            _this = this;
            _this.parents_with_sub_menu.on('mouseenter.XMenu', function(e) {
                return _this.slideDown($(this).find('> a'))
            });
            _this.parents_with_sub_menu.on('mouseleave.XMenu', function() {
                return _this.slideUp()
            });
            _this.parent_links.on('focus', function(e) {
                return _this.slideUp()
            });
            _this.sub_menu_links.on('focus', function(e) {
                return _this.slideDown($(this))
            });
            return _this.sub_menu_links.on('touchstart.XMenu', function(e) {
                e.preventDefault();
                if ($(this).parent().attr('data-x-menu--open') === 'true') {
                    return _this.slideUp()
                } else {
                    return _this.slideDown($(this))
                }
            })
        }
        ;
        FrameworkXMenu.prototype.checkOverlap = function() {
            var _this, center_index, center_item, center_item_left_edge, center_item_right_edge, center_item_width, container, container_width, first_center_child, last_center_child, left_break_point, left_item, right_item, right_item_edge;
            _this = this;
            if (Modernizr.touchevents && theme.utils.mqs.current_window !== 'large') {
                _this.root.attr('data-x-menu--overlap', 'true');
                return false
            }
            _this.root.attr('data-x-menu--overlap', 'false');
            center_item = _this.root;
            if (_this.overlap_parent === 1) {
                center_item = center_item.parent()
            } else if (_this.overlap_parent === 2) {
                center_item = center_item.parent().parent()
            }
            container = center_item.parent();
            center_index = center_item.index();
            left_item = false;
            if (center_index > 1) {
                left_item = container.children().eq(center_index - 1)
            }
            right_item = false;
            if (center_index + 1 < container.children().length) {
                right_item = container.children().eq(center_index + 1)
            }
            container_width = container.width();
            center_item_width = _this.root.outerWidth();
            if (left_item) {
                first_center_child = center_item.find('> :first-child');
                center_item_left_edge = first_center_child.offset().left - 1;
                left_break_point = (container_width - center_item_width) / 2;
                if (left_edge >= center_item_left_edge) {
                    _this.root.attr('data-x-menu--overlap', 'true')
                }
            }
            if (right_item) {
                last_center_child = center_item.find('> :last-child');
                center_item_right_edge = last_center_child.outerWidth() + last_center_child.offset().left + 1;
                right_item_edge = right_item.offset().left;
                if (center_item_right_edge >= right_item_edge) {
                    return _this.root.attr('data-x-menu--overlap', 'true')
                }
            }
        }
        ;
        FrameworkXMenu.prototype.resizeListeners = function() {
            var _this;
            _this = this;
            return $(window).on('resize.XMenu', _this.debounce(100, function() {
                return _this.checkOverlap()
            }))
        }
        ;
        FrameworkXMenu.prototype.debounce = function(delay, fn) {
            var timeoutId;
            timeoutId = void 0;
            return function() {
                if (timeoutId) {
                    clearTimeout(timeoutId)
                }
                timeoutId = setTimeout(fn.bind(this), delay, arguments)
            }
        }
        ;
        FrameworkXMenu.prototype.arrangeMegaNav = function() {
            var _this, mega_navs;
            _this = this;
            if (_this.parents_with_sub_menu.length === 0) {
                return false
            }
            mega_navs = _this.root.find('[data-x-menu--depth="3"] .x-menu--level-2--container');
            return mega_navs.each(function() {
                var container, single_parents, single_parents_container;
                container = $(this);
                single_parents = container.find('[data-x-menu--single-parent="true"]');
                if (single_parents.length > 0) {
                    single_parents_container = $('<div class="x-menu--single-parents"></div>').insertAfter(container.find('.x-menu--bg'));
                    return single_parents_container.append('<ul>').find('ul').append(single_parents)
                }
            })
        }
        ;
        FrameworkXMenu.prototype.slideDown = function(link, delay) {
            var _this, display_type, link_wrapper, menu_height, sub_menu;
            if (delay == null) {
                delay = false
            }
            _this = this;
            clearTimeout(_this.timer);
            link_wrapper = link.parent();
            if (link_wrapper.attr('data-x-menu--open') === 'true') {
                return false
            }
            _this.slideUp(false);
            if (delay && delay !== 'complete') {
                _this.timer = setTimeout(function() {
                    return _this.slideDown(link, 'complete')
                }, delay)
            } else {
                link.closest('.x-menu--level-1--link').find('.fw--icon--expand-more').addClass('active');
                link.closest('.x-menu--level-1--link').find('.fw--icon--minus').show();
                link.closest('.x-menu--level-1--link').find('.fw--icon--plus').hide();
                _this.state = 'open';
                link_wrapper.attr('data-x-menu--open', 'true');
                link.attr('aria-expanded', 'true');
                sub_menu = link.closest('.x-menu--level-1--link').find('.x-menu--level-2--container');
                display_type = 'block';
                if (link_wrapper.attr('data-x-menu--depth') === "3") {
                    display_type = 'flex'
                }
                sub_menu.velocity('stop');
                sub_menu.css({
                    height: 'auto',
                    display: display_type
                });
                menu_height = sub_menu.outerHeight();
                sub_menu.css({
                    height: 0,
                    opacity: 1
                });
                sub_menu.find('.x-menu--level-2--list').css({
                    display: display_type
                });
                sub_menu.velocity({
                    height: [menu_height, 0]
                }, {
                    queue: false,
                    duration: 600,
                    easing: "easeOutExpo"
                })
            }
        }
        ;
        FrameworkXMenu.prototype.slideUp = function(delay) {
            var _this, link, link_wrapper, sub_menu;
            if (delay == null) {
                delay = 300
            }
            _this = this;
            if (_this.debugging) {
                return false
            }
            link_wrapper = _this.parents_with_sub_menu.filter('[data-x-menu--open="true"]');
            link = link_wrapper.find('> a');
            if (link_wrapper.attr('data-x-menu--open') === 'false') {
                return false
            }
            if (delay) {
                return _this.timer = setTimeout(function() {
                    return _this.slideUp(false)
                }, delay)
            } else {
                link.closest('.x-menu--level-1--link').find('.fw--icon--expand-more').removeClass('active');
                link.closest('.x-menu--level-1--link').find('.fw--icon--minus').hide();
                link.closest('.x-menu--level-1--link').find('.fw--icon--plus').show();
                sub_menu = link.closest('.x-menu--level-1--link').find('.x-menu--level-2--container');
                link_wrapper.attr('data-x-menu--open', 'false');
                link.attr('aria-expanded', 'false');
                _this.state = 'closed';
                return sub_menu.velocity({
                    opacity: 0
                }, {
                    duration: 200,
                    display: 'none'
                })
            }
        }
        ;
        return FrameworkXMenu
    }
    )();
    theme.classes.FrameworkYMenu = (function() {
        function FrameworkYMenu(root) {
            var _this;
            this.root = root;
            this.slideRight = bind(this.slideRight, this);
            this.slideLeft = bind(this.slideLeft, this);
            this.adjustHeight = bind(this.adjustHeight, this);
            this.listeners = bind(this.listeners, this);
            this.load = bind(this.load, this);
            _this = this;
            _this.state = 'closed';
            _this.sub_menu_links = _this.root.find('.fw--icon--chevron-right').parent();
            _this.back_links = _this.root.find('.y-menu--back-link a');
            _this.timer = null;
            _this.load()
        }
        FrameworkYMenu.prototype.load = function() {
            var _this;
            _this = this;
            return _this.listeners()
        }
        ;
        FrameworkYMenu.prototype.listeners = function() {
            var _this;
            _this = this;
            _this.sub_menu_links.on('click', function(e) {
                _this.slideLeft($(this));
                return false
            });
            return _this.back_links.on('click', function(e) {
                _this.slideRight($(this));
                return false
            })
        }
        ;
        FrameworkYMenu.prototype.adjustHeight = function(open_list) {
            var _this, current_height, open_list_height;
            _this = this;
            _this.root.css({
                height: 'auto'
            });
            current_height = _this.root.outerHeight();
            open_list_height = open_list.outerHeight();
            if (open_list.css('position') === 'absolute') {
                open_list.css('position', 'relative');
                open_list_height = open_list.outerHeight();
                open_list.css('position', 'absolute')
            }
            return _this.root.velocity({
                height: open_list_height
            })
        }
        ;
        FrameworkYMenu.prototype.slideLeft = function(link) {
            var _this, sub_menu;
            _this = this;
            sub_menu = link.closest('li').find('ul').first();
            sub_menu.css({
                display: 'block'
            });
            _this.adjustHeight(sub_menu);
            return sub_menu.velocity({
                translateX: ['-100%', 0]
            })
        }
        ;
        FrameworkYMenu.prototype.slideRight = function(link) {
            var _this, container, parent_container;
            _this = this;
            container = link.closest('ul');
            parent_container = container.parent().closest('ul');
            _this.adjustHeight(parent_container);
            return container.velocity({
                translateX: [0, '-100%']
            })
        }
        ;
        return FrameworkYMenu
    }
    )();
    Accordion = (function() {
        function Accordion() {
            $('.accordion-wrapper').each(function() {
                $(this).find('.content').first().show()
            });
            $('.accordion-wrapper > .accordion  > li:not([data-disabled="true"]) > .trigger').on("click", function() {
                console.log(3);
                var panels, this_panel, child_panels;
                panels = $(this).parent("li").parent(".accordion").find('.content');
                this_panel = $(this).siblings(".content");
                child_panels = $(this).siblings(".content").find('li:first-child');
                if ($(this).parent("li").hasClass("active")) {
                    console.log(1);
                    this_panel.slideUp(200);
                    return $(this).parent("li").removeClass("active")
                } else {
                    panels.not(this_panel).slideUp(200);
                    console.log(child_panels);
                    this_panel.slideDown(200, function() {});
                    $(this).parent("li").parent(".accordion").find("li").removeClass("active");
                    child_panels.addClass("active");
                    child_panels.children('.content').slideDown(200);
                    $(this).parent("li").addClass("active")
                }
            })
        }
        return Accordion
    }
    )();
    theme.classes.FeaturedBlog = (function() {
        function FeaturedBlog(root) {
            var _this;
            this.root = root;
            this.resizeListeners = bind(this.resizeListeners, this);
            this.matchImageHeights = bind(this.matchImageHeights, this);
            _this = this;
            _this.item_container = _this.root.find('.featured-blog--body');
            _this.items = _this.root.find('.featured-blog--item');
            _this.matchImageHeights();
            _this.resizeListeners()
        }
        FeaturedBlog.prototype.matchImageHeights = function() {
            var _this;
            _this = this;
            return theme.utils.matchImageHeights(_this.item_container, _this.items, '.featured-blog--item--image')
        }
        ;
        FeaturedBlog.prototype.resizeListeners = function() {
            var _this;
            _this = this;
            return $(window).on('resize.FeaturedGrid', theme.utils.debounce(100, function() {
                return _this.matchImageHeights()
            }))
        }
        ;
        return FeaturedBlog
    }
    )();
    Footer = (function() {
        function Footer(root) {
            var _this;
            this.root = root;
            this.stickyFooter = bind(this.stickyFooter, this);
            this.addListeners = bind(this.addListeners, this);
            this.load = bind(this.load, this);
            _this = this;
            _this.load()
        }
        Footer.prototype.load = function() {
            var _this;
            _this = this;
            _this.addListeners();
            return _this.stickyFooter()
        }
        ;
        Footer.prototype.addListeners = function() {
            var _this;
            _this = this;
            return WINDOW.on('resize', function() {
                return _this.stickyFooter()
            })
        }
        ;
        Footer.prototype.stickyFooter = function() {
            var total_content_height;
            total_content_height = HEADER.outerHeight() + $('.main-content').outerHeight() + $('.main-footer').outerHeight();
            if (WINDOW.outerHeight() > total_content_height) {
                return $('.main-content').css({
                    'min-height': WINDOW.outerHeight() - $('.main-header').outerHeight() - $('.main-footer').outerHeight()
                })
            }
        }
        ;
        return Footer
    }
    )();
    FullscreenSlider = (function() {
        function FullscreenSlider(slider_element) {
            this.eventListeners = bind(this.eventListeners, this);
            this.alignPlayButton = bind(this.alignPlayButton, this);
            this.alignCaption = bind(this.alignCaption, this);
            this.isFirstSlider = bind(this.isFirstSlider, this);
            this.getActiveIndex = bind(this.getActiveIndex, this);
            this.autoplay = bind(this.autoplay, this);
            this.removeDuplicateVideoModals = bind(this.removeDuplicateVideoModals, this);
            this.createSlider = bind(this.createSlider, this);
            var _this, slide_parent;
            _this = this;
            this.el = slider_element;
            slide_parent = this.el.closest('.slider');
            this.autoplay_enabled = slide_parent.data('autoplay');
            if (slide_parent.find('.slide').length < 2) {
                this.autoplay_enabled = false
            }
            this.autoplay_frequency = slide_parent.data('rotateFrequency');
            this.transition_style = slide_parent.data('transitionStyle');
            _this.removeDuplicateVideoModals();
            this.createSlider();
            this.owl = $(".owl-carousel").data('owlCarousel')
        }
        FullscreenSlider.prototype.createSlider = function() {
            var slider, slider_options;
            slider = this;
            slider_options = {
                singleItem: true,
                navigation: false,
                paginationNumbers: false,
                scrollPerPageNav: true,
                slideSpeed: 800,
                pagination: true,
                autoHeight: false,
                autoPlay: slider.autoplay(),
                afterInit: function() {
                    return slider.eventListeners()
                },
                afterAction: function() {
                    slider.alignCaption();
                    return slider.alignPlayButton()
                }
            };
            if (this.transition_style !== 'default') {
                slider_options['transitionStyle'] = this.transition_style
            }
            var sliderObject = slider.el.owlCarousel(slider_options);
            var sliderVideos = $(slider.el).find('video');
            if (sliderVideos.length) {
                sliderVideos[0].play()
            }
            return sliderObject;
        }
        ;
        FullscreenSlider.prototype.removeDuplicateVideoModals = function() {
            var _this;
            _this = this;
            return $('.modal.video:gt(0)').remove()
        }
        ;
        FullscreenSlider.prototype.autoplay = function() {
            if (this.autoplay_enabled) {
                return this.autoplay_frequency
            }
            return false
        }
        ;
        FullscreenSlider.prototype.getActiveIndex = function() {
            return this.el.find('.owl-pagination .owl-page.active').index()
        }
        ;
        FullscreenSlider.prototype.isFirstSlider = function() {
            var current_section_id, first_section, first_section_id;
            first_section = $('.index-sections').children('div:first');
            first_section_id = first_section.find('.slider').data('sectionId');
            current_section_id = this.el.closest('.slider').data('sectionId');
            if (first_section.hasClass('section--slideshow')) {
                return current_section_id === first_section_id
            }
            return false
        }
        ;
        FullscreenSlider.prototype.alignCaption = function() {
            var caption, caption_height, caption_width, slide, slide_padding, top_offset;
            slide = this.el.find('.owl-item').eq(this.getActiveIndex());
            caption = slide.find('.caption');
            caption.css('visibility', 'hidden');
            caption_height = caption.outerHeight();
            caption_width = caption.outerWidth();
            slide_padding = 30;
            if (theme.utils.transparentMenuIsEnabled() && this.isFirstSlider() === true) {
                top_offset = $('.main-header').outerHeight()
            } else {
                top_offset = 0
            }
            return theme.utils.imagesLoaded(slide.find('img').first(), function() {
                var left_offset, middle_top, slide_height, slide_width;
                slide_height = slide.outerHeight();
                slide_width = slide.outerWidth();
                if (caption.hasClass('top')) {
                    caption.css('top', top_offset + slide_padding)
                } else if (caption.hasClass('middle')) {
                    middle_top = top_offset + (slide_height - top_offset - caption_height) / 2;
                    caption.css('top', middle_top)
                }
                if (caption.hasClass('center')) {
                    left_offset = (slide_width - caption_width) / 2;
                    caption.css('left', left_offset)
                }
                return caption.css('visibility', 'visible')
            })
        }
        ;
        FullscreenSlider.prototype.alignPlayButton = function() {
            var play_button, slide;
            slide = this.el.find('.owl-item').eq(this.getActiveIndex());
            play_button = slide.find('.play');
            play_button.css('visibility', 'hidden');
            if (theme.utils.transparentMenuIsEnabled() && $('.main-header').css('position') === 'absolute') {
                theme.utils.imagesLoaded(slide.find('img').first(), function() {
                    var play_button_height, slide_height, video_offset;
                    slide_height = slide.outerHeight();
                    play_button_height = play_button.outerHeight();
                    video_offset = (slide_height - play_button_height) / 2;
                    return play_button.css({
                        'margin-top': 0,
                        'top': video_offset
                    })
                })
            } else {
                play_button.css({
                    'margin-top': '-40px',
                    'top': '50%'
                })
            }
            return play_button.css('visibility', 'visible')
        }
        ;
        FullscreenSlider.prototype.eventListeners = function() {
            var slider;
            slider = this;
            this.el.find(".play").on('click', function() {
                console.log(1);
                var video_modal;
                video_modal = new VideoModal($(this).closest('.video'));
                video_modal.open();
                slider.owl.stop();
                return false
            });
            this.el.find('.owl-pagination .owl-page').on('click', function() {
                return slider.owl.stop()
            });
            return DOC.on('header.transparentMenuIsUpdated', slider.alignCaption)
        }
        ;
        return FullscreenSlider
    }
    )();
    theme.classes.Header = (function() {
        function Header(root) {
            var _this;
            this.root = root;
            this.moveYMenu = bind(this.moveYMenu, this);
            this.sectionListeners = bind(this.sectionListeners, this);
            this.load = bind(this.load, this);
            _this = this;
            _this.load()
        }
        Header.prototype.load = function() {
            var _this;
            _this = this;
            _this.searchAndAccount();
            _this.sectionListeners();
            return _this.moveYMenu()
        }
        ;
        Header.prototype.sectionListeners = function() {
            var _this;
            _this = this;
            return _this.root.on('theme:section:load', function() {
                theme.partials.FrameworkOffCanvas.unload();
                return theme.partials.FrameworkOffCanvas.load()
            })
        }
        ;
        Header.prototype.moveYMenu = function() {
            var _this;
            _this = this;
            $('.mobile-nav--menu').empty();
            return $('.y-menu').appendTo('.mobile-nav--menu')
        }
        ;
        Header.prototype.searchAndAccount = function() {
            var _this;
            _this = this;
            $('.searchbar-open').click(function() {
                $('.main-header .searchbar-container').fadeToggle(200);
                return $('.main-header .searchbar-container .search-box').focus();
                return false
            });
        }
        ;
        return Header
    }
    )();
    HorizontalTabs = (function() {
        function HorizontalTabs() {
            $('.tabs-horizontal.headings').each(function() {
                return $(this).add($(this).next('.tabs.content')).wrapAll("<div class='tabs-wrapper horizontal'/>")
            });
            $('.tabs-horizontal.headings li').wrapInner('<div class="trigger"></div>');
            $('.tabs-horizontal.headings li .trigger').append('<div class="bg"></div>');
            $('.tabs-wrapper.horizontal').each(function() {
                var tab_content, tab_headings, first_active;
                tab_headings = $(this).find('.headings > li');
                tab_content = $(this).find('.tabs.content > li');
                first_active = $(this).find('.headings').data('first') || 0;
                tab_content.eq(first_active).addClass('active');
                tab_headings.eq(first_active).addClass('active');
                return tab_headings.on('click', function() {
                    tab_headings.removeClass('active');
                    tab_content.removeClass('active');
                    $(this).addClass('active');
                    return tab_content.eq($(this).index()).addClass('active')
                })
            })
        }
        return HorizontalTabs
    }
    )();
    InstagramFeed = (function() {
        function InstagramFeed(root) {
            var _this;
            this.root = root;
            this.load = bind(this.load, this);
            _this = this;
            _this.load()
        }
        InstagramFeed.prototype.load = function() {
            var _this, access_token, getImages, items_to_load;
            _this = this;
            access_token = _this.root.data('instagramAccessToken');
            if ($('.instagram-widget').length < 1) {
                return false
            } else if (access_token == undefined) {
                return false
            } else if (access_token.length < 1) {
                return false
            }
            items_to_load = 5;
            return getImages = (function() {
                return $.ajax({
                    dataType: "jsonp",
                    url: 'https://api.instagram.com/v1/users/self/media/recent/?access_token=' + access_token + '&count=' + items_to_load,
                    success: function(response) {
                        var data, i, img_src, j, ref, results1;
                        if (response.meta.code === 200) {
                            data = response.data;
                            results1 = [];
                            for (i = j = 0,
                            ref = items_to_load - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
                                if (data[i]) {
                                    img_src = data[i].images.low_resolution.url;
                                    img_src = img_src.replace("http:", "https:");
                                    results1.push($('.instagram-widget .items').append('<a class="item" target="_blank" href="' + data[i].link + '"><img src="' + img_src + '" /></a>'))
                                } else {
                                    results1.push(void 0)
                                }
                            }
                            return results1
                        } else {
                            return $('.instagram-widget .items').append('<p class="error">' + response.meta.error_message + '</p><p class="colored-links">Check the <strong>Homepage - social feeds</strong> section in your <a target="_blank" href="/admin/themes">theme settings</a>.</p>')
                        }
                    },
                    error: function(jqXHR, textStatus) {
                        console.log(jqXHR);
                        return console.log(textStatus)
                    }
                })
            }
            )()
        }
        ;
        return InstagramFeed
    }
    )();
    MediaQueries = (function() {
        function MediaQueries() {
            this.load = bind(this.load, this);
            var _this;
            _this = this;
            _this.listeners();
            _this.load()
        }
        MediaQueries.prototype.load = function() {
            var _this, current_window;
            _this = this;
            if (window.matchMedia('only screen and (min-width: ' + mq_medium + 'px)').matches) {
                if (current_window !== 'large') {
                    $.event.trigger("largeWindow");
                    return current_window = 'large'
                }
            } else if (window.matchMedia('only screen and (min-width: ' + mq_small + 'px)').matches) {
                if (current_window !== 'medium') {
                    $.event.trigger("mediumWindow");
                    return current_window = 'medium'
                }
            } else {
                if (current_window !== 'small') {
                    $.event.trigger("smallWindow");
                    return current_window = 'small'
                }
            }
        }
        ;
        MediaQueries.prototype.listeners = function() {
            var _this;
            _this = this;
            return WINDOW.on('resize.section-' + _this.section_id, _this.load)
        }
        ;
        return MediaQueries
    }
    )();
    Popup = (function() {
        function Popup(clazz) {
            var checkContentOverflow, closeDialog, eventListeners, fillPopupDialog, fillSizeChartDialog, getCustomClasses, getImage, getNewsletter, getCloseButton, getPageContent, getSocialIcons, getWrapper, hideMask, ieCenter, isExpired, mask, maskIsActive, modal, modal_clazz, openDialog, passesExpiration, resetExpiration, showMask, storeExpiration;
            this.clazz = clazz;
            modal = null;
            modal_clazz = this.clazz;
            mask = $('.popup-modal-mask');
            storeExpiration = function() {
                var date, e, expires, object, seconds_from_now;
                date = new Date();
                seconds_from_now = 1000 * 60 * 60 * 24 * popup_config.days_until;
                expires = date.setTime(date.getTime() + seconds_from_now);
                object = {
                    expires: expires
                };
                try {
                    return localStorage[popup_config.storage_key] = JSON.stringify(object)
                } catch (error1) {
                    e = error1;
                    return false
                }
            }
            ;
            resetExpiration = function() {
                localStorage.removeItem(popup_config.storage_key);
                return storeExpiration()
            }
            ;
            isExpired = function() {
                var expires, now, object;
                object = JSON.parse(localStorage[popup_config.storage_key]);
                expires = object.expires;
                now = new Date().getTime();
                if (parseFloat(expires - now) <= 0) {
                    resetExpiration();
                    return true
                }
                return false
            }
            ;
            passesExpiration = function() {
                var passed;
                passed = false;
                if (Storage === "undefined" || popup_config.test_mode) {
                    passed = true
                } else if (typeof localStorage[popup_config.storage_key] === "undefined") {
                    passed = true;
                    storeExpiration()
                } else {
                    passed = isExpired()
                }
                return passed
            }
            ;
            maskIsActive = function() {
                return $('.popup-modal').is(':visible') || $('.modal-mask').length > 0 && $('.modal-mask').is(':visible')
            }
            ;
            showMask = function() {
                mask.show();
                return PAGE.addClass("modal-on")
            }
            ;
            hideMask = function() {
                mask.hide();
                return PAGE.removeClass("modal-on")
            }
            ;
            getImage = function() {
                if (popup_config.show_image_enabled === false) {
                    return ""
                }
                if (popup_config.image_link.length > 0) {
                    return $('<div class="popup-image"> <a href="' + popup_config.image_link + '">' + popup_config.show_image_url + '</a> </div>')
                } else {
                    return $('<div class="popup-image">').append(popup_config.show_image_url)
                }
            }
            ;
            getNewsletter = function() {
                var subscribe_module;
                if (popup_config.newsletter_enabled === false) {
                    return ""
                }
                subscribe_module = $("<div id='subscribe_module'></div>").append($("#mailing-list-module > p").clone()).append($("#mailing-list-module form").clone()).append($("#mc-embedded-subscribe-form").clone());
                return subscribe_module
            }
            ;
            getCloseButton = function() {
                var close_button;
                if (popup_config.newsletter_enabled === false) {
                    return ""
                }
                close_button = $("<div id='close_button'></div>").append($('.popup-modal-close').clone());
                return close_button
            }
            ;
            getSocialIcons = function() {
                if (popup_config.social_icons_enabled === false) {
                    return ""
                }
                return $(".social-follow").clone()
            }
            ;
            getCustomClasses = function() {
                var class_list;
                class_list = "";
                class_list += popup_config.show_image_enabled === true ? " has-image" : " has-no-image";
                class_list += popup_config.page_content.length > 0 ? " has-page-content" : " has-no-page-content";
                class_list += popup_config.newsletter_enabled ? " has-newsletter" : " has-no-newsletter";
                class_list += popup_config.social_icons_enabled ? " has-social-icons" : " has-no-social-icons";
                return class_list
            }
            ;
            getWrapper = function() {
                return '<dialog class="' + modal_clazz + ' popup-modal' + getCustomClasses() + '" />'
            }
            ;
            getPageContent = function() {
                var page_content;
                page_content = null;
                if (popup_config.page_content.length < 1) {
                    return ""
                }
                $.getJSON('/pages/' + popup_config.page_content + '.json', function(data, textStatus) {
                    return page_content = "<div class='page-contents'>" + data.page.body_html + "</div>"
                });
                return page_content
            }
            ;
            fillSizeChartDialog = function() {
                var dialog;
                if ($('.popup-modal.size-chart').length < 1) {
                    dialog = {
                        wrapper: getWrapper()
                    };
                    PAGE.append($(dialog.wrapper).append($('.size-chart')))
                }
                return openDialog()
            }
            ;
            fillPopupDialog = function() {
                var dialog, getInnerContent, render;
                dialog = {
                    wrapper: getWrapper(),
                    newsletter: getNewsletter(),
                    closeButton: getCloseButton(),
                    social_icons: getSocialIcons(),
                    image: getImage()
                };
                getInnerContent = function() {
                    if (popup_config.page_content.length < 1 && popup_config.newsletter_enabled === false && popup_config.social_icons_enabled === false) {
                        return ""
                    }
                    return $("<div class='inner' />").append(dialog.body, dialog.newsletter, dialog.closeButton, dialog.social_icons)
                }
                ;
                render = function() {
                    PAGE.append($(dialog.wrapper).append(dialog.image, getInnerContent()));
                    return openDialog()
                }
                ;
                if (popup_config.page_content.length > 0) {
                    return $.getJSON('/pages/' + popup_config.page_content + '.json', function(data, textStatus) {
                        dialog['body'] = "<div class='page-contents'>" + data.page.body_html + "</div>";
                        return render()
                    })
                } else {
                    return render()
                }
            }
            ;
            checkContentOverflow = function() {
                return setTimeout((function() {
                    if (modal.length > 0 && $('.popup-modal-mask').is(':visible')) {
                        return theme.utils.imagesLoaded(modal, function() {
                            var dialog_height;
                            dialog_height = $('dialog[class*="' + modal_clazz + '"]:last-of-type').outerHeight();
                            if (dialog_height >= WINDOW.height()) {
                                return PAGE.addClass('modal-unfix')
                            } else {
                                return PAGE.removeClass('modal-unfix')
                            }
                        })
                    }
                }
                ), 0)
            }
            ;
            ieCenter = function() {
                return modal.css({
                    marginTop: -(modal.outerHeight() * 0.5) + "px",
                    marginLeft: -(modal.outerWidth() * 0.5) + "px"
                })
            }
            ;
            openDialog = function() {
                modal = $('dialog[class*="' + modal_clazz + '"]');
                eventListeners();
                modal.addClass("opened").removeClass("closed");
                checkContentOverflow();
                return showMask()
            }
            ;
            eventListeners = function() {
                var removeAnimation;
                removeAnimation = function(event) {
                    if (event.originalEvent.animationName === 'modal-close') {
                        if (modal_clazz === 'popup') {
                            return modal.remove()
                        } else {
                            return modal.removeClass('closed, completed')
                        }
                    } else {
                        return modal.addClass('completed').removeClass('opened')
                    }
                }
                ;
                DOC.on('click', '.popup-modal', function(e) {
                    e.stopPropagation();
                    if (e.target === this) {
                        return closeDialog()
                    }
                });
                $('.popup-modal-close').click(closeDialog);
                mask.click(closeDialog);
                modal.on('animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd', removeAnimation);
                WINDOW.resize(checkContentOverflow);
                DOC.keydown(function(e) {
                    if (modal.hasClass('completed') && e.keyCode === 27) {
                        return closeDialog()
                    }
                });
                return $('dialog.popup-modal #contact_form').on('submit', function(event) {
                    var form;
                    form = this;
                    modal = $(this).closest('.popup-modal');
                    modal.find('.error, .success').remove();
                    event.preventDefault();
                    if (modal.find('input[type="email"]').val().length === 0) {
                        modal.find('.inner').prepend('<p class="error">' + theme.translation.newsletter_email_blank + '</p>');
                        return false
                    } else {
                        modal.find('.inner > *').hide();
                        modal.find('.inner').prepend('<p class="success">' + theme.translation.newsletter_success_message + '</p>').show();
                        setTimeout(function() {
                            return form.submit()
                        }, 500)
                    }
                    return false
                })
            }
            ;
            closeDialog = function() {
                modal.addClass('closed').removeClass('completed').removeClass('opened');
                return hideMask()
            }
            ;
            if (modal_clazz !== 'popup') {
                fillSizeChartDialog()
            } else {
                if (popup_config.enabled && passesExpiration() && (popup_config.page_content.length > 0 || popup_config.newsletter_enabled || popup_config.show_image_enabled || popup_config.social_icons_enabled)) {
                    setTimeout((function() {
                        if (!(maskIsActive() === true || $('.popup-modal-mask').length < 1)) {
                            return fillPopupDialog()
                        }
                    }
                    ), popup_config.seconds_until * 1000)
                }
            }
        }
        return Popup
    }
    )();
    theme.classes.ProductGrid = (function() {
        function ProductGrid(root) {
            var _this;
            this.root = root;
            this.hoverImagesLoaded = bind(this.hoverImagesLoaded, this);
            this.listeners = bind(this.listeners, this);
            this.matchImageHeights = bind(this.matchImageHeights, this);
            this.detectOnboarding = bind(this.detectOnboarding, this);
            this.load = bind(this.load, this);
            _this = this;
            _this.items = _this.root.find('.product--root');
            _this.onboarding = _this.detectOnboarding();
            _this.in_slider = _this.root.data('in-slider');
            _this.load()
        }
        ProductGrid.prototype.load = function() {
            var _this;
            _this = this;
            _this.listeners();
            _this.hoverImagesLoaded();
            if (!_this.in_slider) {
                return _this.matchImageHeights()
            }
        }
        ;
        ProductGrid.prototype.detectOnboarding = function() {
            var _this;
            _this = this;
            if (_this.items.first().find('.placeholder').length) {
                return true
            }
            return false
        }
        ;
        ProductGrid.prototype.matchImageHeights = function() {
            var _this;
            _this = this;
            return theme.utils.matchImageHeights(_this.root, _this.items, '.product--image-wrapper')
        }
        ;
        ProductGrid.prototype.listeners = function() {
            var _this;
            _this = this;
            if (!_this.in_slider) {
                return $(window).on('resize.ProductGrid', theme.utils.debounce(100, function() {
                    return _this.matchImageHeights()
                }))
            }
        }
        ;
        ProductGrid.prototype.hoverImagesLoaded = function() {
            var _this;
            _this = this;
            return _this.items.filter('[data-hover-image="true"]').each(function() {
                var product;
                product = $(this);
                return theme.utils.imagesLoaded(product, function() {
                    return product.attr('data-hover-image', 'loaded')
                })
            })
        }
        ;
        return ProductGrid
    }
    )();
    ProductSlider = theme.classes.ProductSlider = (function() {
        function ProductSlider(root) {
            var _this;
            this.root = root;
            this.listeners = bind(this.listeners, this);
            this.afterUpdate = bind(this.afterUpdate, this);
            this.load = bind(this.load, this);
            _this = this;
            _this.product_grid = _this.root.find('.product-grid--root');
            _this.product_item = _this.root.find('.product--root');
            _this.load();
            _this.listeners()
        }
        ProductSlider.prototype.load = function() {
            var _this;
            _this = this;
            _this.product_grid.owlCarousel({
                items: 4,
                navigation: true,
                scrollPerPage: true,
                slideSpeed: 800,
                lazyLoad: false,
                pagination: false,
                navigationText: false,
                afterUpdate: _this.afterUpdate()
            });
            return _this.product_item.show()
        }
        ;
        ProductSlider.prototype.afterUpdate = function() {
            var _this;
            _this = this;
            return $(window).trigger('ProductSlider.afterUpdate')
        }
        ;
        ProductSlider.prototype.listeners = function() {
            var _this;
            _this = this;
            return $(window).on('resize.ProductGrid', theme.utils.debounce(100, function() {
                return _this.loadCarousel
            }))
        }
        ;
        return ProductSlider
    }
    )();
    PromoBar = (function() {
        function PromoBar(root) {
            var _this;
            this.root = root;
            this.load = bind(this.load, this);
            _this = this;
            _this.promo_bar = _this.root;
            _this.close_btn = _this.root.find('button');
            _this.load()
        }
        PromoBar.prototype.load = function() {
            var _this;
            _this = this;
            if ((typeof Storage !== "undefined" && Storage !== null) && sessionStorage['promo-bar-closed']) {
                $('.off-canvas--viewport').css('paddingTop', $('.main-header').outerHeight() - 1 + 'px');
                return _this.promo_bar.hide()
            } else {
                _this.promo_bar.show();
                if ($(window).width() <= 406) {
                    $('.off-canvas--viewport').css('paddingTop', $('.main-header').outerHeight() + _this.promo_bar.outerHeight() - 1 + 'px')
                }
                return _this.close_btn.on('click', function() {
                    $('.off-canvas--viewport').css('paddingTop', Math.max(parseInt($('.off-canvas--viewport').css('paddingTop')) - (_this.promo_bar.outerHeight() - 1), 0) + 'px');
                    return _this.close()
                })
            }
        }
        ;
        PromoBar.prototype.close = function() {
            var _this;
            _this = this;
            if ((typeof Storage !== "undefined" && Storage !== null) && !sessionStorage['promo-bar-closed']) {
                sessionStorage['promo-bar-closed'] = true
            }
            return _this.promo_bar.addClass('closed')
        }
        ;
        return PromoBar
    }
    )();
    VerticalTabs = (function() {
        function VerticalTabs() {
            $('.tabs-vertical.headings').each(function() {
                return $(this).add($(this).next('.tabs.content')).wrapAll("<div class='tabs-wrapper vertical'/>")
            });
            $('.tabs-vertical.headings li').wrapInner('<div class="trigger"></div>');
            $('.tabs-vertical.headings li .trigger').append('<div class="bg"></div>');
            $('.tabs-wrapper.vertical').each(function() {
                var tab_content, tab_headings, tab_wrapper, first_active;
                tab_wrapper = $(this);
                tab_headings = $(this).find('.headings > li');
                tab_content = $(this).find('.tabs.content > li');
                first_active = $(this).find('.headings').data('first') || 0;
                tab_content.eq(first_active).addClass('active');
                tab_headings.eq(first_active).addClass('active');
                return tab_headings.on('click', function() {
                    tab_headings.removeClass('active');
                    tab_content.removeClass('active');
                    $(this).addClass('active');
                    tab_content.eq($(this).index()).addClass('active');
                    if (general_scroll_to_active_item) {
                        if (matchMedia('only screen and (min-width: ' + mq_small + 'px)').matches) {
                            return $('html, body').animate({
                                scrollTop: tab_wrapper.offset().top - 50
                            }, 'slow')
                        } else {
                            return $('html, body').animate({
                                scrollTop: tab_wrapper.offset().top + tab_wrapper.find('.headings').outerHeight() - 50
                            }, 'slow')
                        }
                    }
                })
            })
        }
        return VerticalTabs
    }
    )();
    VideoModal = (function() {
        function VideoModal(video) {
            this.createIframe = bind(this.createIframe, this);
            this.extractVideoId = bind(this.extractVideoId, this);
            this.extractVideoType = bind(this.extractVideoType, this);
            this.eventListeners = bind(this.eventListeners, this);
            this.centerPosition = bind(this.centerPosition, this);
            this.close = bind(this.close, this);
            this.open = bind(this.open, this);
            this.opened = false;
            this.video = video;
            this.modal = $('.video.modal');
            this.player_button = video.find('.player-button');
            this.src_url = video.find('.play-button').attr('href');
            this.type = this.extractVideoType();
            this.id = this.extractVideoId();
            this.iframe = this.createIframe();
            this.caption = video.find('.caption')
        }
        VideoModal.prototype.open = function() {
            this.opened = true;
            this.modal.find(".flex-video").append(this.iframe);
            if (this.caption.length > 0) {
                this.modal.find(".caption").append(this.caption.html());
                this.modal.addClass("wide")
            } else {
                this.modal.find(".player").removeClass('large-8');
                this.modal.find('.caption').hide();
                this.modal.removeClass("wide")
            }
            this.player_button.hide();
            $('.modal-mask').show();
            this.modal.find('.close').show();
            this.modal.fadeIn();
            this.centerPosition();
            $(".modal").fadeIn(0);
            return this.eventListeners()
        }
        ;
        VideoModal.prototype.close = function() {
            this.opened = false;
            this.modal.find(".flex-video").empty();
            this.modal.find(".caption").empty();
            this.modal.hide();
            $('.modal-mask').fadeOut();
            if (this.caption.length === 0) {
                this.modal.find(".player").addClass('large-8');
                return this.modal.find('.caption').show()
            }
        }
        ;
        VideoModal.prototype.centerPosition = function() {
            if (WINDOW.height() < this.modal.outerHeight()) {
                return this.modal.css({
                    'position': 'absolute',
                    'top': '30px',
                    'margin-top': 0,
                    'margin-left': -(this.modal.outerWidth() / 2)
                })
            } else {
                return this.modal.css({
                    'position': 'fixed',
                    'top': '50%',
                    'margin-top': -(this.modal.outerHeight() / 2),
                    'margin-left': -(this.modal.outerWidth() / 2)
                })
            }
        }
        ;
        VideoModal.prototype.eventListeners = function() {
            var modal;
            modal = this;
            this.modal.find('.close').on('click', function() {
                return modal.close()
            });
            WINDOW.resize(function() {
                return modal.centerPosition()
            });
            DOC.keydown(function(e) {
                if (modal.opened) {
                    if (e.keyCode === 27) {
                        return modal.close()
                    }
                }
            });
            $('.modal-mask').on('click', function() {
                return modal.close()
            });
            return this.player_button.on('click', function() {
                return false
            })
        }
        ;
        VideoModal.prototype.extractVideoType = function() {
            var matches, re;
            re = /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i;
            matches = re.exec(this.src_url);
            if (matches) {
                return 'youtube'
            } else {
                re = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
                matches = re.exec(this.src_url);
                if (matches) {
                    return 'vimeo'
                }
            }
            return false
        }
        ;
        VideoModal.prototype.extractVideoId = function() {
            var match, regExp;
            if (this.type === 'youtube') {
                regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                match = this.src_url.match(regExp);
                if (match && match[2].length === 11) {
                    return match[2]
                }
            } else if (this.type === "vimeo") {
                regExp = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
                match = this.src_url.match(regExp);
                if (match) {
                    return match[2]
                }
            }
        }
        ;
        VideoModal.prototype.createIframe = function() {
            if (this.type === "youtube") {
                return '<iframe  src="//www.youtube.com/embed/' + this.id + '?autoplay=1&rel=0" frameborder="0" allowfullscreen></iframe>'
            } else if (this.type === "vimeo") {
                return '<iframe src="//player.vimeo.com/video/' + this.id + '?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>'
            }
        }
        ;
        return VideoModal
    }
    )();
    theme.classes.XMenu = (function(superClass) {
        extend(XMenu, superClass);
        function XMenu(root) {
            var _this;
            this.root = root;
            this.slideDown = bind(this.slideDown, this);
            this.hideHeader = bind(this.hideHeader, this);
            this.showHeader = bind(this.showHeader, this);
            this.headerListeners = bind(this.headerListeners, this);
            this.isHeaderTransparent = bind(this.isHeaderTransparent, this);
            _this = this;
            _this.header = $('.main-header');
            _this.header_bg = _this.header.find('.header--bg');
            _this.header_timer = null;
            _this.transparent_header = _this.isHeaderTransparent();
            XMenu.__super__.constructor.apply(this, arguments);
            _this.headerListeners()
        }
        XMenu.prototype.isHeaderTransparent = function() {
            var _this;
            _this = this;
            if ($('.header').attr('data-header--menu-transparent') === 'true') {
                return true
            } else {
                return false
            }
        }
        ;
        XMenu.prototype.headerListeners = function() {
            var _this;
            _this = this;
            _this.parents_with_sub_menu.on('mouseenter', function(e) {
                return clearTimeout(_this.header_timer)
            });
            _this.header.on('mouseenter touchstart', function(e) {
                clearTimeout(_this.header_timer);
                return _this.showHeader()
            });
            return _this.header.on('mouseleave', function(e) {
                return _this.header_timer = setTimeout(function() {
                    return _this.hideHeader()
                }, 500)
            })
        }
        ;
        XMenu.prototype.showHeader = function() {
            var _this;
            _this = this;
            if (parseInt(_this.header_bg.css('opacity')) !== 0) {
                return
            }
            return _this.header_bg.velocity({
                opacity: [0.95]
            }, {
                duration: 400,
                queue: false
            })
        }
        ;
        XMenu.prototype.hideHeader = function() {
            var _this;
            _this = this;
            if (_this.parents_with_sub_menu.filter('[data-main-menu--open="true"]').length > 0) {
                return false
            }
            _this.header_bg.velocity({
                opacity: 0
            }, {
                duration: 400
            });
            return _this.slideUp()
        }
        ;
        XMenu.prototype.slideDown = function(link, delay) {
            var _this, opacity;
            if (delay == null) {
                delay = false
            }
            _this = this;
            if (delay !== 'complete') {
                opacity = Math.round(parseFloat(_this.header_bg.css('opacity')) * 100);
                if (opacity < 90 && _this.transparent_header) {
                    delay = 400
                }
            }
            return XMenu.__super__.slideDown.call(this, link, delay)
        }
        ;
        return XMenu
    }
    )(theme.classes.FrameworkXMenu);
    Cart = (function() {
        function Cart() {
            this.recentCartItemPopUp = bind(this.recentCartItemPopUp, this);
            this.addToCart = bind(this.addToCart, this);
            this.validateSize = bind(this.validateSize, this);
            this.stopResetTimer = bind(this.stopResetTimer, this);
            this.startTimer = bind(this.startTimer, this);
            this.addSampleItemToCart = bind(this.addSampleItemToCart, this);
            this.openMobileModal = bind(this.openMobileModal, this);
            this.slideDownCartDropdown = bind(this.slideDownCartDropdown, this);
            this.listeners = bind(this.listeners, this);
            this.load = bind(this.load, this);
            var _this;
            _this = this;
            _this.cart_dropdown_timer = null;
            _this.listeners()
        }
        Cart.prototype.load = function() {
            var _this;
            return _this = this
        }
        ;
        Cart.prototype.listeners = function() {
            var _this;
            _this = this;
            $('.product-page--cart-form form').off().on('submit', function() {
                _this.addToCart($(this));
                return false
            });
            $('.product-page--cart-form--with-sample form').off().on('submit', function(e) {
                e.preventDefault();
                Shopify.addItem = function(form, callback) {
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        dataType: 'json',
                        data: $(form).serialize(),
                        success: function() {
                            if (typeof callback === 'function') {
                                callback()
                            }
                        },
                        error: function() {}
                    })
                }
                ;
                Shopify.queue = [];
                theme.classes.FrameworkCart.prototype.addItem($(this), function() {
                    for (i = 0; i < $('.free-sample-item').length; i += 1) {
                        $form = $('.free-sample-item')[i];
                        Shopify.queue.push($($form))
                    }
                    Shopify.moveAlong = function() {
                        if (Shopify.queue.length) {
                            var request = Shopify.queue.shift();
                            Shopify.addItem(request, Shopify.moveAlong)
                        } else {
                            document.location.href = '/cart'
                        }
                    }
                    ;
                    Shopify.moveAlong()
                })
            });
            $('.product-grid--root form').off().on('submit', function() {
                _this.addToCart($(this));
                return false
            });
            $('.recently-added.mobile .close').off().on('click', function() {
                return _this.fadeOutCartDropdown()
            });
            $('.recently-added-mask').off().on('click', function() {
                return _this.fadeOutCartDropdown()
            });
            $('.main-header .recently-added').mouseenter(function() {
                return _this.stopResetTimer()
            });
            return $('.main-header .recently-added').mouseleave(function() {
                return _this.startTimer()
            })
        }
        ;
        Cart.prototype.toggleCartDropdown = function() {
            return $('.main-header .recently-added').slideToggle('fast')
        }
        ;
        Cart.prototype.slideDownCartDropdown = function() {
            $('.main-header .recently-added').slideDown('fast');
            return $("html, body").animate({
                scrollTop: 0
            })
        }
        ;
        Cart.prototype.openMobileModal = function() {
            $('.main-header .recently-added.mobile').fadeIn();
            return $('.main-header .recently-added-mask').removeClass('hide')
        }
        ;
        Cart.prototype.fadeOutCartDropdown = function() {
            var _this;
            _this = this;
            clearTimeout(_this.cart_dropdown_timer);
            $('.main-header .recently-added').fadeOut('fast');
            return $('.main-header .recently-added-mask').addClass('hide')
        }
        ;
        Cart.prototype.startTimer = function() {
            var _this;
            _this = this;
            return _this.cart_dropdown_timer = setTimeout((function() {
                return _this.fadeOutCartDropdown()
            }
            ), 4000)
        }
        ;
        Cart.prototype.stopResetTimer = function() {
            var _this;
            _this = this;
            return clearTimeout(_this.cart_dropdown_timer)
        }
        ;
        Cart.prototype.validateSize = function(cart_form) {
            if (cart_form.find('select option:selected').is(':disabled')) {
                cart_form.find('.dropdown').effect('shake', {
                    'times': 2,
                    'distance': 5
                }, 400);
                return false
            }
            return true
        }
        ;
        Cart.prototype.addToCart = function(cart_form) {
            var _this, addToCartFail, addToCartPass;
            _this = this;
            addToCartPass = function(product) {
                if (typeof trigger_messages === 'function') {
                    trigger_messages()
                }
                if (typeof updateMotivator == 'function') {
                    updateMotivator(product, _this.recentCartItemPopUp)
                } else {
                    return _this.recentCartItemPopUp()
                }
            }
            ;
            addToCartFail = function(obj, status) {
                $('.recently-added .error').show();
                $('.recently-added table').hide();
                $('.recently-added div.row').hide();
                _this.slideDownCartDropdown();
                return _this.startTimer()
            }
            ;
            return $.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: "json",
                data: cart_form.serialize(),
                success: addToCartPass,
                error: addToCartFail
            })
        }
        ;
        Cart.prototype.recentCartItemPopUp = function() {
            var _this, cart_item, cart_total, frequency;
            _this = this;
            cart_item = {};
            cart_total = {};
            return $.getJSON("/cart.js", function(cart, textStatus) {debugger
               
                var sellingPlan = "";
                if(cart.items[0].selling_plan_allocation && cart.items[0].selling_plan_allocation.selling_plan){
                  sellingPlan = cart.items[0].selling_plan_allocation.selling_plan.name;
                }
                var new_cart_row, new_mobile_item, raw_price, raw_cart_price;
                cart_item.image_url = Shopify.resizeImage(cart.items[0].image, "160x");
                cart_item.url = cart.items[0].url;
                raw_price = cart.items[0].original_price;
                raw_cart_price = cart.original_total_price;
                cart_item.title = cart.items[0].title;
                cart_item.price = Shopify.formatMoney(cart.items[0].price, shop_money_format);
                cart_total.price = Shopify.formatMoney(cart.total_price, shop_money_format);
                cart_total.quantity = cart.item_count;
                $('.cart-link .number').html(cart_total.quantity);
                $('.cart-link .number-wrapper').removeClass('hide');
                new_cart_row = '<tr>';
                new_cart_row += '<td class="cart-item">';
                new_cart_row += '<a href="' + cart_item.url + '">';
                new_cart_row += '<img src="' + cart_item.image_url + '" alt="' + cart_item.title + '">';
                new_cart_row += '</a>';
                new_cart_row += '</td>';
                new_cart_row += '<td class="cart-detail">';
                new_cart_row += '<h2>';
                new_cart_row += '<a href="' + cart_item.url + '">' + cart_item.title + '</a>';
                if (frequency) {
                    new_cart_row += '<span style="display: block">' + sellingPlan + '</span>'
                }
                new_cart_row += '</h2>';
                new_cart_row += '</td>';
                new_cart_row += '<td class="cart-price"><span data-original-value="' + raw_price + '" class="money">' + cart_item.price + '</span></td>';
                new_cart_row += '</tr>';
                new_mobile_item = '<a class="clearfix" href="' + cart_item.url + '">';
                new_mobile_item += '<img style="float: left; margin-right: 10px;" src="' + cart_item.image_url + '" alt="' + cart_item.title + '">';
                new_mobile_item += '<strong>' + cart_item.title + '</strong>';
                if (frequency) {
                    new_mobile_item += '<span style="display: block">' + frequency + '</span>'
                }
                new_mobile_item += '</a>';
                $('.recently-added tbody').html(new_cart_row);
                $('.recently-added .mobile-item').html(new_mobile_item);
                $('.recently-added .items-count .number').html(cart_total.quantity);
                $('.recently-added .total-price').html('<span class="money" data-original-value="' + raw_cart_price + '">' + cart_total.price + '</span>');
                if (currency_switcher_enabled) {
                    $.each($('.recently-added .total-price').get(0).attributes, function(i, attrib) {
                        if (attrib.name.match("^data-currency")) {
                            return $('.recently-added .total-price').attr(attrib.name, "")
                        }
                    });
                    Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val())
                }
                $('.recently-added .error').hide();
                $('.recently-added table, .recently-added div.row').show();
                if (theme.utils.mqs.current_window === 'small') {
                    _this.openMobileModal()
                } else {
                    _this.slideDownCartDropdown()
                }
                return _this.startTimer()
            })
        }
        ;
        return Cart
    }
    )();
    Collection = (function() {
        function Collection() {
            DOC.on('change', '.tags-listbox', function() {
                var collFilters, newTags, query;
                newTags = [];
                collFilters = $(this);
                collFilters.each(function(index, element) {
                    if ($(this).val()) {
                        return newTags.push($(this).val())
                    }
                });
                if (newTags.length) {
                    query = newTags.join('+');
                    return window.location.href = $(theme.collection.tag).attr('href').replace('tag', query)
                } else {
                    if (theme.collection.handle) {
                        return window.location.href = '/collections/' + theme.collection.handle
                    } else if (theme.collection.products.first_type === theme.collection.title) {
                        return window.location.href = theme.collection.url_for_type
                    } else if (theme.collection.products.first_vendor === theme.collection.title) {
                        return window.location.href = theme.collection.url_for_vendor
                    }
                }
            })
        }
        return Collection
    }
    )();
    Password = (function() {
        function Password() {
            this.listeners = bind(this.listeners, this);
            this.load = bind(this.load, this);
            var _this;
            _this = this;
            _this.listeners();
            _this.load()
        }
        Password.prototype.load = function() {
            var _this;
            _this = this;
            if ($('.login-form .errors').size()) {
                return $('.login-link').click()
            }
        }
        ;
        Password.prototype.listeners = function() {
            var _this;
            _this = this;
            DOC.on('click', '.login-link', function() {
                $(this).css('visibility', 'hidden');
                $(".wrapper").hide();
                $('.login-form').css('visibility', 'visible').find($('[name=password]').focus());
                return false
            });
            return DOC.on('click', '.login-form .cancel', function() {
                $(".login-link").css('visibility', 'visible');
                $(".wrapper").fadeIn();
                $('.login-form').css('visibility', 'hidden');
                return false
            })
        }
        ;
        return Password
    }
    )();
    theme.classes.ProductPage = (function() {
        function ProductPage(root) {
            var _this;
            this.root = root;
            this.cssGridFallback = bind(this.cssGridFallback, this);
            this.modalCloseListener = bind(this.modalCloseListener, this);
            this.resizeListeners = bind(this.resizeListeners, this);
            this.imageZoom = bind(this.imageZoom, this);
            this.getActiveImageId = bind(this.getActiveImageId, this);
            this.updateVariantImage = bind(this.updateVariantImage, this);
            this.thumbListener = bind(this.thumbListener, this);
            this.variantSelected = bind(this.variantSelected, this);
            this.sizeChart = bind(this.sizeChart, this);
            this.updateLowInStock = bind(this.updateLowInStock, this);
            this.getVariantQuantity = bind(this.getVariantQuantity, this);
            this.getLowInStockAmount = bind(this.getLowInStockAmount, this);
            this.getLowInStockMessage = bind(this.getLowInStockMessage, this);
            this.mobileModalHandler = bind(this.mobileModalHandler, this);
            this.load = bind(this.load, this);
            _this = this;
            _this.thumbs = _this.root.find('.product-page--thumb');
            _this.main_images = _this.root.find('.product-page--image');
            _this.zoom_images = _this.root.find('.product-page--zoom-image');
            _this.image_container = _this.root.find('.product-page--images-container');
            _this.magnify = parseFloat(_this.root.data('magnify'));
            _this.size_chart_enabled = _this.root.data('size-chart-enabled');
            _this.size_chart_option = _this.root.data('size-chart-option').toLowerCase();
            _this.load()
        }
        ProductPage.prototype.load = function() {
            var _this, photos;
            _this = this;
            _this.cssGridFallback();
            _this.thumbListener();
            _this.imageZoom();
            _this.resizeListeners();
            _this.modalCloseListener();
            _this.mobileModalHandler();
            _this.root.on('theme:section:load', function() {
                new Cart();
                new Accordion();
                new HorizontalTabs();
                new VerticalTabs();
                return
            });
            photos = $('article .photos');
            DOC.on('click', '.size-chart-trigger', function(e) {
                e.preventDefault();
                return new Popup('size-chart-container')
            });
            photos.on('click', function() {
                return false
            });
            $("article .custom.dropdown").hide();
            if (product_options_size === 1 && product_options_first !== "Title") {
                return $(".selector-wrapper:eq(0)").prepend("<label>" + product_options_first + "</label>")
            }
        }
        ;
        ProductPage.prototype.mobileModalHandler = function() {
            var _this, modal_links;
            _this = this;
            modal_links = _this.image_container.find('.modal--link');
            return modal_links.on('click', function(e) {
                if (theme.utils.mqs.current_window === 'small') {
                    return e.stopImmediatePropagation()
                }
            })
        }
        ;
        ProductPage.prototype.getLowInStockMessage = function(quantity) {
            var _this, message;
            _this = this;
            message = quantity === 1 ? theme.products.low_in_stock.one : theme.products.low_in_stock.other;
            if (quantity > 1) {
                message = message.replace(/\d+/, quantity)
            }
            return message
        }
        ;
        ProductPage.prototype.getLowInStockAmount = function() {
            var _this;
            _this = this;
            return _this.root.data('product-low-in-stock-amount')
        }
        ;
        ProductPage.prototype.getVariantQuantity = function(variant) {
            var option;
            option = $('#variant-listbox').find('[value="' + variant.id + '"]');
            if (option.length > 0) {
                return parseInt(option.data('inventory-quantity'))
            } else {
                return 'not available'
            }
        }
        ;
        ProductPage.prototype.updateLowInStock = function(variant) {
            var _this, quantity, threshold;
            _this = this;
            quantity = _this.getVariantQuantity(variant);
            threshold = _this.getLowInStockAmount();
            if (threshold === 'undefined') {
                return false
            }
            if (quantity > 0 && quantity <= threshold) {
                $('.product-low-in-stock').html('<p>' + _this.getLowInStockMessage(quantity) + '</p>').show()
            } else {
                $('.product-low-in-stock').hide()
            }
            return DOC.on('.shopify-section section--products shopify:section:select', function() {
                return _this.updateLowInStock(variant)
            })
        }
        ;
        ProductPage.prototype.sizeChart = function(product_options) {
            var _this;
            _this = this;
            if (!_this.size_chart_enabled) {
                return
            }
            return $('.selector-wrapper').each(function(index, element) {
                if (product_options[index].toLowerCase() === _this.size_chart_option) {
                    return $(element).append('<a class="size-chart-trigger" href="#">' + theme.products.size_chart.label + '</a>')
                }
            })
        }
        ;
        ProductPage.prototype.variantSelected = function(variant, selector, options) {
            var _this, actual_price, compare_price, show_low_in_stock;
            _this = this;
            $(".compare-price").html("");
            $('.product-unavailable [type="submit"]').prop("disabled", true);
            if (variant && variant.available) {
                $(".quanity-cart-row, .product-page--smart-payment-buttons").show();
                $('.product-unavailable').hide()
            } else {
                $(".quanity-cart-row, .product-page--smart-payment-buttons").hide();
                $('.product-unavailable').show();
                $('.product-low-in-stock').hide();
                $('.product-unavailable [type="submit"]').prop("disabled", false);
                if (product_variant_size > 1 && variant) {
                    $('.product-unavailable form .email-body').attr('value', 'Please notify me when this is back in stock: ' + product_title + ' - ' + variant.title)
                }
            }
            if (variant) {
                actual_price = Shopify.formatMoney(variant.price);
                $(".actual-price").replaceWith('<span class="actual-price money">' + actual_price + '</span>');
                if (variant.compare_at_price > variant.price) {
                    compare_price = Shopify.formatMoney(variant.compare_at_price);
                    $(".compare-price").html(product_language_was + ' <span class="money">' + compare_price + '</span>')
                }
                if (currency_switcher_enabled) {
                    Currency.convertAll(shopCurrency, $('[name=currencies]').val())
                }
                if (variant.featured_image) {
                    _this.updateVariantImage(variant.featured_image.id)
                }
            }
            show_low_in_stock = _this.getLowInStockAmount() === false ? false : true;
            if (show_low_in_stock === true) {
                _this.updateLowInStock(variant)
            }
            _this.sizeChart(selector.product.options)
        }
        ;
        ProductPage.prototype.thumbListener = function() {
            var _this;
            _this = this;
            return _this.thumbs.on('keypress click', function(e) {
                var variant_id;
                if (theme.utils.a11yClick(e)) {
                    variant_id = $(this).data('id');
                    _this.updateVariantImage(variant_id);
                    $('.variant-wrapper[image-id="' + variant_id + '"]').find('input').prop("checked", true)
                }
                return _this.imageZoom()
            })
        }
        ;
        ProductPage.prototype.updateVariantImage = function(variant_id) {
            var _this, variant_image, variant_thumb;
            _this = this;
            _this.main_images.attr('data-active', 'false');
            variant_image = _this.main_images.filter('[data-id="' + variant_id + '"]');
            variant_image.attr('data-active', 'true');
            _this.thumbs.attr('data-active', 'false');
            variant_thumb = _this.thumbs.filter('[data-id="' + variant_id + '"]');
            variant_thumb.attr('data-active', 'true');
            return _this.imageZoom()
        }
        ;
        ProductPage.prototype.getActiveImageId = function() {
            var _this, active_image, active_image_id;
            _this = this;
            active_image = _this.main_images.filter('[data-active="true"]');
            active_image_id = active_image.data('id');
            return active_image_id
        }
        ;
        ProductPage.prototype.imageZoom = function() {
            var _this, active_zoom_image, aspect_ratio, left_position, top_position, wrapper_height, wrapper_width, x_ratio, y_ratio;
            _this = this;
            if (_this.root.data('zoom-enabled') === false) {
                return
            }
            _this.image_container.off('mouseenter.ProductPage.imageZoom');
            _this.image_container.off('mouseleave.ProductPage.imageZoom');
            _this.zoom_images.css('display', 'none');
            active_zoom_image = _this.zoom_images.filter('[data-id="' + _this.getActiveImageId() + '"]');
            aspect_ratio = active_zoom_image.data('aspect-ratio');
            wrapper_width = _this.image_container.width();
            wrapper_height = _this.image_container.height();
            active_zoom_image.find('.image--root').css('width', wrapper_width * _this.magnify);
            top_position = _this.image_container.offset().top;
            left_position = _this.image_container.offset().left;
            x_ratio = (wrapper_width * _this.magnify - wrapper_width) / wrapper_width;
            y_ratio = (wrapper_height * _this.magnify - wrapper_height) / wrapper_height;
            _this.image_container.on('mouseenter.ProductPage.imageZoom', function() {
                return active_zoom_image.css('display', 'block')
            });
            _this.image_container.on('mouseleave.ProductPage.imageZoom', function() {
                return active_zoom_image.css('display', 'none')
            });
            return _this.image_container.on('mousemove', function(e) {
                var relative_left, relative_top;
                relative_left = e.pageX - left_position;
                relative_top = e.pageY - top_position;
                return active_zoom_image.css({
                    'left': relative_left * -x_ratio,
                    'top': relative_top * -y_ratio
                })
            })
        }
        ;
        ProductPage.prototype.resizeListeners = function() {
            var _this;
            _this = this;
            return $(window).on('resize.ProductPage', theme.utils.debounce(100, function() {
                return _this.imageZoom()
            }))
        }
        ;
        ProductPage.prototype.modalCloseListener = function() {
            var _this;
            _this = this;
            return $(window).on('FrameworkModal.afterClose', function() {
                return _this.imageZoom()
            })
        }
        ;
        ProductPage.prototype.cssGridFallback = function() {
            var _this;
            _this = this;
            if (!Modernizr.cssgrid) {
                $('.product-page--title-n-vendor, .product-page--cart-form-block, .product-page--description').wrapAll('<div class="product-page--no-grid--left-column"></div>');
                return $('.product-page--images').wrapAll('<div class="product-page--no-grid--right-column"></div>')
            }
        }
        ;
        return ProductPage
    }
    )();
    theme.classes.Utils = (function(superClass) {
        extend(Utils, superClass);
        function Utils() {
            var _this;
            _this = this;
            _this.sections = new theme.classes.Sections();
            _this.mqs = new theme.classes.FrameworkMediaQueries()
        }
        Utils.prototype.transparentMenuIsEnabled = function() {
            return PAGE.find("[data-header--menu-transparent=true]").length > 0
        }
        ;
        Utils.prototype.loadJsClasses = function() {
            return $('[data-js-class]').each(function() {
                var js_class, partial_class;
                js_class = $(this).attr('data-js-class');
                if ($(this).attr('data-js-loaded') !== 'true') {
                    partial_class = theme.classes[js_class];
                    if (typeof partial_class !== "undefined") {
                        theme.partials[js_class] = new partial_class($(this));
                        return $(this).attr('data-js-loaded', 'true')
                    }
                }
            })
        }
        ;
        Utils.prototype.addSymbol = function(icon_name) {
            return '<svg class="fw--icon fw--icon--' + icon_name + '"> <use xlink:href="#fw--icon--' + icon_name + '" /> </svg>'
        }
        ;
        Utils.prototype.isIE11 = function() {
            if (!!window.MSInputMethodContext && !!document.documentMode) {
                return true
            }
            return false
        }
        ;
        return Utils
    }
    )(theme.classes.FrameworkUtils);
    PAGE = null;
    DOC = null;
    WINDOW = null;
    HEADER = null;
    touchevents_exist = null;
    mq_small = null;
    mq_medium = null;
    mq_large = null;
    log = null;
    current_window = '';
    jQuery(function($) {
        var first_article_img, isFirefox, page_content, pinterest_button;
        PAGE = $('body');
        DOC = $(document);
        WINDOW = $(window);
        HEADER = $('.main-header');
        touchevents_exist = Modernizr.touchevents;
        mq_small = 768;
        mq_medium = 1280;
        mq_large = 1440;
        theme.utils = new theme.classes.Utils();
        if (general_external_links_enabled) {
            $('a[href^="http"]').not('a[href^="' + shop_url + '"]').attr('target', '_blank')
        }
        if (popup_config.enabled) {
            $.preloadImages = function() {
                var i;
                i = 0;
                while (i < arguments.length) {
                    $('<img />').attr('src', arguments[i]);
                    i += 1
                }
            }
            ;
            $.preloadImages(theme.preload_image)
        }
        $('.slider').each(function() {
            return new FullscreenSlider($(this).find('.slides'))
        });
        $('.product-slider').each(function() {
            return new ProductSlider($(this))
        });
        new Popup('popup');
        new Footer($('.footer'));
        new Accordion();
        new HorizontalTabs();
        new VerticalTabs();
        new Cart();
        new PromoBar($('.promo-bar'));
        if (PAGE.hasClass('template-page')) {
            page_content = $('.page-content .rte-content');
            if (page_content.find('.left-side-column').length || page_content.find('.right-side-column').length) {
                if (page_content.find('.left-side-column').length && page_content.find('.right-side-column').length) {
                    page_content.wrapInner("<div class='main-column with-2-sidebars'></div>");
                    $('.left-side-column').addClass('with-2-sidebars');
                    $('.right-side-column').addClass('with-2-sidebars')
                } else {
                    page_content.wrapInner("<div class='main-column'></div>")
                }
                $('.left-side-column').prependTo(page_content);
                $('.right-side-column').appendTo(page_content)
            }
        }
        if (PAGE.hasClass('template-index')) {
            new InstagramFeed($('.instagram-widget'));
            if ($('.twitter-widget').length) {
                window.twttr = (function(d, s, id) {
                    var fjs, js, t;
                    js = void 0;
                    fjs = d.getElementsByTagName(s)[0];
                    t = window.twttr || {};
                    if (d.getElementById(id)) {
                        return t
                    }
                    js = d.createElement(s);
                    js.id = id;
                    js.src = 'https://platform.twitter.com/widgets.js';
                    fjs.parentNode.insertBefore(js, fjs);
                    t._e = [];
                    t.ready = function(f) {
                        t._e.push(f)
                    }
                    ;
                    return t
                }
                )(document, 'script', 'twitter-wjs')
            }
        }
        if (PAGE.hasClass('template-collection')) {
            new Collection()
        }
        if (PAGE.hasClass('template-article')) {
            pinterest_button = $('.social-share .pinterest');
            first_article_img = $('.article img').first().attr('src');
            pinterest_button.attr('href', pinterest_button.attr('href') + '&media=' + first_article_img)
        }
        if ($('.section--password').length > 0) {
            new Password()
        }
        isFirefox = typeof InstallTrigger !== "undefined";
        if (isFirefox) {
            $('img').addClass('image-scale-hack')
        }
        if (touchevents_exist) {
            $("form.custom .hidden-field").removeClass('hidden-field')
        }
        $(document).on("click", "#add_bulk_product > ", function(e) {
            e.preventDefault();
            $this = $(this);
            $this.attr('disabled', true);
            $this.text('Adding to bag...');
            var pro_list = $('.product_list').text();
            console.log(pro_list);
            Shopify.queue = [];
            var newArray = pro_list.split(',');
            for (var i = 0; i < newArray.length; i += 1) {
                product = newArray[i];
                Shopify.queue.push({
                    variantId: product
                })
            }
            Shopify.moveAlong = function() {
                if (Shopify.queue.length) {
                    var request = Shopify.queue.shift();
                    var data = 'id=' + request.variantId + '&quantity=1';
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        dataType: 'json',
                        data: data,
                        success: function(res) {
                            Shopify.moveAlong()
                        }
                    })
                } else {
                    $this.attr('disabled', false);
                    $this.text('Added to bag');
                    return Cart.prototype.recentCartItemPopUp()
                }
            }
            ;
            Shopify.moveAlong()
        });
        current_window = '';
        new MediaQueries();
        $('.hide-until-js').show();
        DOC.on('shopify:section:load', function(e) {
            var section_wrapper;
            section_wrapper = $(e.target).closest('.shopify-section');
            section_wrapper.css('min-height', '2000px');
            if (section_wrapper.hasClass('section--slideshow')) {
                new FullscreenSlider($(e.target).find('.slides'))
            } else if (section_wrapper.hasClass('section--featured-collection')) {
                new ProductSlider($(e.target).find('.product-slider'))
            } else if (section_wrapper.hasClass('social-feeds')) {
                new InstagramFeed($('.instagram-widget'));
                window.twttr = (function(d, s, id) {
                    var fjs, js, t;
                    js = void 0;
                    fjs = d.getElementsByTagName(s)[0];
                    t = window.twttr || {};
                    if (d.getElementById(id)) {
                        return t
                    }
                    js = d.createElement(s);
                    js.id = id;
                    js.src = 'https://platform.twitter.com/widgets.js';
                    fjs.parentNode.insertBefore(js, fjs);
                    t._e = [];
                    t.ready = function(f) {
                        t._e.push(f)
                    }
                    ;
                    return t
                }
                )(document, 'script', 'twitter-wjs')
            } else if (section_wrapper.hasClass('section--header')) {
                setTimeout(function() {
                    if ($('.slider').length > 0) {
                        return DOC.trigger('header.transparentMenuIsUpdated')
                    }
                }, 0);
                new PromoBar($('.promo-bar'))
            } else if (section_wrapper.hasClass('section--products')) {
                DOC.trigger('set-option-selectors');
                new ProductModal($('.modal'))
            }
            return section_wrapper.css('min-height', 'auto')
        });
        DOC.on('shopify:section:unload', function(e) {
            var mask, section_wrapper;
            section_wrapper = $(e.target).closest('.shopify-section');
            if (section_wrapper.hasClass('section--featured-collection')) {
                return setTimeout((function() {
                    if ($('.section--featured-collection').length === 0) {
                        return WINDOW.off("resize.ProductSlider")
                    }
                }
                ), 0)
            } else if (section_wrapper.hasClass('section--products')) {
                mask = $(".popup-modal-mask");
                $(".size-chart").remove();
                if (mask.is(":visible")) {
                    return mask.trigger("click")
                }
            } else if (section_wrapper.hasClass('section--slideshow')) {
                return setTimeout(function() {
                    if ($('.slider').length === 0) {
                        return DOC.off('header.transparentMenuIsUpdated')
                    }
                }, 0)
            }
        });
        DOC.on('shopify:block:select', function(e) {
            var section_wrapper, slide_selected;
            section_wrapper = $(e.target).closest('.shopify-section');
            if (section_wrapper.hasClass('section--slideshow')) {
                slide_selected = section_wrapper.find('.slide').index(e.target);
                return $(e.target).closest('.owl-carousel').trigger('owl.jumpTo', slide_selected).trigger('owl.stop')
            }
        });
        DOC.on('shopify:section:deselect', function(e) {
            var section_wrapper, should_autoplay, slider;
            section_wrapper = $(e.target).closest('.shopify-section');
            if (section_wrapper.hasClass('section--slideshow')) {
                should_autoplay = section_wrapper.find('.slider').data('autoplay');
                if (should_autoplay === true) {
                    slider = section_wrapper.find('.slides');
                    return slider.trigger('owl.play', section_wrapper.find('.slider').data('rotateFrequency'))
                }
            }
        });
        theme.utils.loadJsClasses();
        return false
    })
}
).call(this);
window.loveRewards = (function() {
    function openWidgetModal(value) {
        if (theme.customer_signed_in) {
            window.location.href = '/account'
        } else {
            $('#join-lr').removeClass('inactive')
        }
    }
    return {
        openWidgetModal: openWidgetModal
    }
}
)();
$(document).ready(function() {
    $('body').on('click', '.lion-notification__action', function(e) {
        e.stopPropagation();
        window.loveRewards.openWidgetModal()
    });
    objectFitImages();
    window.sr = ScrollReveal();
    sr.reveal('.shopify-section .featured-grid--item--container', 200, {
        origin: 'left',
        duration: 500,
        delay: 100,
        easing: 'linear'
    });
    sr.reveal('.featured-video--body', 200, {
        origin: 'bottom',
        duration: 500,
        delay: 100,
        easing: 'linear'
    });
    sr.reveal('.newsletter--container .fly', 500, {
        origin: 'right',
        duration: 500,
        delay: 100,
        easing: 'linear'
    });
    sr.reveal('.number-wrapper', 200, {
        origin: 'right',
        duration: 500,
        delay: 2000,
        easing: 'linear'
    });
    $('.quick-view, .quick-view--atc').on('click', function(evt) {
        evt.preventDefault();
        var productHandle = $(this).data('product-handle');
        var productlink = '/products/' + productHandle;
        var $modalContainer = $('.product-grid-modal[data-product-handle="' + productHandle + '"]');
        $modalContainer.find('.modal--link').trigger('click');
        var $modal = $('.modal--window').attr('data-modal--fullscreen', 'false');
        var $contentPlaceholder = $modal.find('.modal--content-placeholder');
        if (!$contentPlaceholder.length || !productHandle) {
            return
        }
        $contentPlaceholder.addClass('loading');
        $.get('/products/' + productHandle, function(response) {
            var productContent = $(response.trim()).find('#shopify-section-product');
            $('.product-page--thumbs', $(productContent)).remove();
            $modal.find('.modal--content').html($(productContent).html());
            $modal.find('.modal--content .modal--root').removeAttr('data-js-class');
            $modal.find('.modal--content .product-page--root').attr('data-modal-enabled', 'false').attr('data-zoom-enabled', 'false');
            theme.utils.loadJsClasses();
            $modal.find('.modal--content .product-page--root').triggerHandler('theme:section:load');
            $modal.find('.modal--content .product-page--root .product-page--images-container .product-page--image').first().append('<span class="quick-view__view-more-btn button">View Full Product</span>').on('click', function() {
                window.location.href = productlink
            });
            $modal.find('.modal--content .add-to-cart input[type="submit"]').on('click', function() {
                $modalContainer.trigger('quick-close')
            });
            $(window).trigger('resize.FrameworkModal');
            window._swat.initializeActionButtons('.modal--content');
            BOLD.recurring_orders.app.reboot()
        })
    });
    $('.accordion-wrapper > .accordion  > li[data-tab-name="reviews"] > .trigger').on("click", function(evt) {
        evt.stopImmediatePropagation();
        $('html, body').animate({
            scrollTop: $('#shopify-section-product-review').offset().top
        }, 500)
    });
    $('.accordion-wrapper > .accordion  > li[data-tab-name="rewards-scroll"] > .trigger').on("click", function(evt) {
        evt.stopImmediatePropagation();
        $('html, body').animate({
            scrollTop: $('#shopify-section-love-rewards-slideshow').offset().top
        }, 500)
    });
    $('.show-register').on("click", function(evt) {
        $('.love-rewards-box').addClass('show-form')
    });
    $('#review-badge').on("click", function(evt) {
        $('html, body').animate({
            scrollTop: $('#shopify-section-product-review').offset().top
        }, 500)
    });
    $('a[href="#love-rewards"], a[href="#loverewards"]').on('click', function(evt) {
        evt.preventDefault();
        loveRewards.openWidgetModal()
    });
    $('a[href="#"]').on('click', function(evt) {
        evt.preventDefault()
    })
});
document.addEventListener("DOMContentLoaded", function() {
    var div, n, v = document.getElementsByClassName("youtube-player");
    for (n = 0; n < v.length; n += 1) {
        div = document.createElement("div");
        div.setAttribute("data-id", v[n].dataset.id);
        div.innerHTML = labnolThumb(v[n].dataset.id);
        div.onclick = labnolIframe;
        v[n].appendChild(div)
    }
});
function labnolThumb(id) {
    var thumb = '<img src="https://i.ytimg.com/vi/ID/maxresdefault.jpg" onload="labnolThumbOnload(this)">'
      , play = '<div class="play"></div>';
    return thumb.replace("ID", id) + play
}
function labnolThumbOnload(image) {
    if (image.naturalWidth < 200) {
        if (image.src.indexOf('hqdefault') >= 0) {
            return
        } else {
            image.src = image.src.replace('sddefault', 'hqdefault').replace('maxresdefault', 'sddefault')
        }
    }
}
function labnolIframe() {
    var iframe = document.createElement("iframe");
    var embed = "https://www.youtube.com/embed/ID?autoplay=1&rel=0&modestbranding=0&showinfo=0";
    iframe.setAttribute("src", embed.replace("ID", this.dataset.id));
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allowfullscreen", "1");
    this.parentNode.replaceChild(iframe, this)
}
let quiz = {
    container: 'quiz',
    results: {},
    products: {},
    pages: {},
    titles: {},
    currentTab: 0,
    totalTabs: 0,
    title: function() {
        return $('#quiz').attr('data-name')
    },
    selectAnswer: function(context) {
        let sectionTag = $(context).data('tag')
          , sectionAnswer = $(context).data('answer')
          , sectionProduct = $(context).data('producthandle')
          , sectionPage = $(context).data('pageurl');
        let sectionTagClass = '.quiz__answer--' + sectionTag;
        $(sectionTagClass + '.active').removeClass('active');
        $(context).addClass('active');
        this.titles[this.currentTab] = sectionTag;
        this.results[this.currentTab] = sectionAnswer;
        if (sectionProduct != '' && sectionProduct != null) {
            this.products[this.currentTab] = sectionProduct
        }
        ;if (sectionPage != '' && sectionPage != null) {
            this.pages[this.currentTab] = sectionPage
        }
        ;this.allowNext(context);
        this.goNext()
    },
    allowNext: function(context) {
        $(context).closest('.quiz__section').find('.next').removeAttr('disabled')
    },
    goNext: function() {
        if (this.currentTab == 0) {
            this.totalTabs = $('.quiz__page').length
        }
        $currentTab = $('.quiz__page')[this.currentTab];
        $($currentTab).removeClass('active').addClass('inactive');
        this.currentTab = this.currentTab + 1;
        if (this.currentTab < this.totalTabs) {
            $destinationTab = $('.quiz__page')[this.currentTab];
            $($destinationTab).removeClass('inactive').addClass('active');
            $($destinationTab).find('.prev').removeAttr('disabled');
            if (this.currentTab + 1 == this.totalTabs) {
                $($destinationTab).find('.next').text('Finish')
            }
        } else {
            this.displayResults()
        }
        $('html,body').animate({
            scrollTop: $("#" + this.container).offset().top
        }, 'slow');
        this.updateProgressBar()
    },
    goPrev: function() {
        if (this.currentTab == 0) {
            return
        }
        $currentTab = $('.quiz__page')[this.currentTab];
        $($currentTab).removeClass('active').addClass('inactive');
        this.currentTab = this.currentTab - 1;
        $destinationTab = $('.quiz__page')[this.currentTab];
        $($destinationTab).removeClass('inactive').addClass('active');
        this.updateProgressBar();
        $('html,body').animate({
            scrollTop: $("#" + this.container).offset().top
        }, 'slow')
    },
    updateProgressBar: function() {
        $progressBar = $('.quiz_progress-bar');
        progressPercent = (this.currentTab + 1) / this.totalTabs * 100;
        if (progressPercent > 100) {
            progressPercent = 100
        }
        $($progressBar).width(progressPercent + '%')
    },
    displayResults: function() {
        $('.quiz__results').removeClass('inactive');
        var resultProducts = Object.values(quiz.products)
          , resultProductsCount = resultProducts.length
          , $resultProductsContainer = $('<div></div>');
        var productsToRender = [];
        for (i = 0; i < resultProductsCount; i += 1) {
            let targetProduct = resultProducts[i];
            if ($.inArray(targetProduct, productsToRender) > -1) {
                continue
            }
            ;productsToRender.push(targetProduct)
        }
        var productsToRenderCount = productsToRender.length;
        for (i = 0; i < productsToRenderCount; i += 1) {
            let targetProduct = productsToRender[i]
              , targetURL = '/products/' + targetProduct;
            $.ajax({
                type: 'GET',
                dataType: 'html',
                url: targetURL + '?view=quiz-result',
                success: function(data) {
                    $($resultProductsContainer).append(data);
                    var returnedProductsCount = $($resultProductsContainer).find('.shopify-section.section--products').length;
                    if (returnedProductsCount == productsToRenderCount) {
                        renderProducts($resultProductsContainer);
                        window._swat.initializeActionButtons('.product-page--main-content');
                        StampedFn.loadBadges()
                    }
                }
            })
        }
        var targetURL = '/products/' + productsToRender[0];
        $.ajax({
            type: 'GET',
            dataType: 'html',
            url: targetURL + '?view=related',
            success: function(data) {
                $('.quiz__results').append($($.trim(data)).find('.related-products'));
                theme.utils.loadJsClasses();
                $('.related-products .product-grid--root').triggerHandler('theme:section:load');
                var relatedProductsSlider = new ProductSlider($('.related-products .product-slider'))
            }
        });
        function renderProducts(data) {
            $('.quiz__results-loading-visible').css('display', 'none');
            $('.quiz__results-loading-hidden').css('display', 'block');
            $('.quiz__result-product').html(data)
        }
        let $form = $('form#create_customer')
          , $formFieldsContainer = $('.quiz_form-fields');
        for (var i = 0; i < Object.keys(this.titles).length; i += 1) {
            let fieldName = function(i) {
                j = Object.keys(quiz.titles)[i];
                return 'customer[quiz' + quiz.title() + j + 'Title]'
            };
            let $field = $($formFieldsContainer).find('[name="' + fieldName(i) + '"]')
              , value = Object.values(this.titles)[i];
            $($field).val(value)
        }
        ;for (var i = 0; i < Object.keys(this.results).length; i += 1) {
            let fieldName = function(i) {
                j = Object.keys(quiz.results)[i];
                return 'customer[quiz' + quiz.title() + j + 'Value]'
            };
            let $field = $($formFieldsContainer).find('[name="' + fieldName(i) + '"]')
              , value = Object.values(this.results)[i];
            $($field).val(value)
        }
        ;for (var i = 0; i < Object.keys(this.products).length; i += 1) {
            let fieldName = function(i) {
                j = Object.keys(quiz.products)[i];
                return 'customer[quiz' + quiz.title() + j + 'Product]'
            };
            let $field = $($formFieldsContainer).find('[name="' + fieldName(i) + '"]')
              , value = Object.values(this.products)[i];
            $($field).val(value)
        }
        ;$($formFieldsContainer).clone().appendTo($form)
    },
    restart: function() {
        location.reload()
    },
    saveResult: function() {
        if (theme.customer_signed_in) {
            $('.quiz_save-result').text('SAVING RESULTS...');
            $('.create_customer__default-fields').detach();
            let $form = $('form#create_customer');
            $form.submit()
        } else {
            $('#join-lr').removeClass('inactive')
        }
    }
};
$(document).ready(function() {
    $('body').on('click', 'a[href="#join-love-rewards"]', function(e) {
        e.preventDefault;
        loveRewards.openWidgetModal()
    });
    $('body').on('click', 'a[href="#power-through-beauty"]', function(e) {
        e.preventDefault;
        $('#power-through-beauty').removeClass('inactive')
    });
    $('body').on('click', '.ptb__close', function() {
        $('#power-through-beauty').addClass('inactive')
    });
    $('body').on('click', '.lr__close', function() {
        $('#join-lr').addClass('inactive')
    });
    $('.ingredients .open-trigger').on('click', function() {
        $('.ingredients').removeClass('closed');
        $('.ingredients').addClass('open')
    });
    $('.ingredients .close-trigger').on('click', function() {
        $('.ingredients').removeClass('open');
        $('.ingredients').addClass('closed')
    });
    $(".product-page--images-container").swipe({
        swipeLeft: function(event, direction, distance, duration, fingerCount) {
            let $navContainer = $('.product-page--thumbs-container')
              , $thumbs = $($navContainer).find('.product-page--thumb')
              , $thumbActive = $($navContainer).find('.product-page--thumb[data-active="true"]')
              , $thumbNext = $($thumbActive).next()
              , $thumbFirst = $($thumbs).first()
              , $imagesContainer = $('.product-page--images-container')
              , $images = $($imagesContainer).find('.product-page--image');
            if ($($thumbActive).is(':last-child')) {
                return
            } else {
                $($thumbs).attr('data-active', 'false');
                $($images).attr('data-active', 'false');
                $($thumbNext).attr('data-active', 'true')
            }
            ;$thumbActive = $($navContainer).find('.product-page--thumb[data-active="true"]');
            let targetImageId = $($thumbActive).attr('data-id')
              , $targetImage = $($imagesContainer).find('.product-page--image[data-id="' + targetImageId + '"]');
            $($targetImage).attr('data-active', 'true')
        },
        swipeRight: function(event, direction, distance, duration, fingerCount) {
            let $navContainer = $('.product-page--thumbs-container')
              , $thumbs = $($navContainer).find('.product-page--thumb')
              , $thumbActive = $($navContainer).find('.product-page--thumb[data-active="true"]')
              , $thumbPrev = $($thumbActive).prev()
              , $thumbLast = $($thumbs).last()
              , $imagesContainer = $('.product-page--images-container')
              , $images = $($imagesContainer).find('.product-page--image');
            if ($($thumbActive).is(':first-child')) {
                return
            } else {
                $($thumbs).attr('data-active', 'false');
                $($images).attr('data-active', 'false');
                $($thumbPrev).attr('data-active', 'true')
            }
            ;$thumbActive = $($navContainer).find('.product-page--thumb[data-active="true"]');
            let targetImageId = $($thumbActive).attr('data-id')
              , $targetImage = $($imagesContainer).find('.product-page--image[data-id="' + targetImageId + '"]');
            $($targetImage).attr('data-active', 'true')
        },
        threshold: 75
    })
});
let createAKit = {
    containerId: 'create-a-kit',
    title: '',
    products: [],
    productsQueue: {},
    renderedProducts: [],
    init: function() {
        this.title = $('#' + this.containerId).attr('data-createAkit-title');
        $('.create-a-kit__add-item').on('click', function() {
            createAKit.addProduct(this)
        });
        $('.' + this.kitContainerClass).on('click', '.create-a-kit__remove', function() {
            createAKit.removeProduct(this)
        });
        $('#create-a-kit').on('click', '.create-a-kit__submit', function() {
            createAKit.checkForKitInCart()
        });
        var floatingKit = true;
        $(window).scroll(function() {
            var hT = $('#create-a-kit').offset().top
              , hH = $('#create-a-kit').outerHeight()
              , wH = $(window).height()
              , wS = $(this).scrollTop()
              , eH = $('.create-a-kit__kit-container').outerHeight();
            if (wS > (hT + hH - wH + eH - 25) && floatingKit == true) {
                floatingKit = false;
                $('.create-a-kit__kit-container').removeClass('fixed')
            }
            ;if (wS < (hT + hH - wH - 100) && floatingKit == false) {
                floatingKit = true;
                $('.create-a-kit__kit-container').addClass('fixed')
            }
        });
        $('.create-a-kit__type-title').on('click', function() {
            let $target = $(this).closest('.create-a-kit__show-hide-container')
              , status = $($target).attr('data-show')
              , $all = $('.create-a-kit__show-hide-container');
            if (status == 'false') {
                $($all).attr('data-show', 'false');
                $($target).attr('data-show', 'true')
            } else {
                $($target).attr('data-show', 'false')
            }
        });
        this.renderPlaceholders();
        this.updatePrice()
    },
    priceFiveItems: function() {
        let price = $('#' + this.containerId).attr('data-createAkit-priceFiveItems');
        if (price != null && price != undefined && price != "" && price != " ") {
            return price
        } else {
            return false
        }
    },
    priceFourItems: function() {
        let price = $('#' + this.containerId).attr('data-createAkit-priceFourItems');
        if (price != null && price != undefined && price != "" && price != " ") {
            return price
        } else {
            return false
        }
    },
    priceThreeItems: function() {
        let price = $('#' + this.containerId).attr('data-createAkit-priceThreeItems');
        if (price != null && price != undefined && price != "" && price != " ") {
            return price
        } else {
            return false
        }
    },
    priceTwoItems: function() {
        let price = $('#' + this.containerId).attr('data-createAkit-priceTwoItems');
        if (price != null && price != undefined && price != "" && price != " ") {
            return price
        } else {
            return false
        }
    },
    maxItems: function() {
        if (this.priceFiveItems() != false) {
            return 5
        } else if (this.priceFourItems() != false) {
            return 4
        } else if (this.priceThreeItems() != false) {
            return 3
        } else {
            return 2
        }
    },
    minItems: function() {
        if (this.priceTwoItems() != false) {
            return 2
        } else if (this.priceThreeItems() != false) {
            return 3
        } else if (this.priceFourItems() != false) {
            return 4
        } else {
            return 5
        }
    },
    addProduct: function(e) {
        var id = $(e).attr('data-productid');
        var handle = $(e).attr('data-producthandle');
        var s = $(e).attr('data-s');
        var product = {};
        product[handle] = {
            v: id,
            s: s
        };
        console.info(id);
        var productsArray = this.products;
        if (productsArray.length == this.maxItems()) {
            console.error('Max products reached');
            return false
        }
        ;function checkIfProductExistsInArray(handle) {
            for (i = 0; i < productsArray.length; i += 1) {
                var p = productsArray[i]
                  , h = Object.values(p)
                  , v = Object.values(h)[0].v;
                if (v == id) {
                    console.error('Variant exists in array');
                    return true
                }
            }
            ;return false
        }
        ;if (checkIfProductExistsInArray(handle) == false) {
            this.products.push(product)
        }
        ;this.renderKit();
        this.updatePrice();
        return
    },
    removeProduct: function(e) {
        var handle = $(e).attr('data-producthandle')
          , id = $(e).attr('data-variantid')
          , productsArray = this.products;
        for (i = 0; i < productsArray.length; i += 1) {
            var p = productsArray[i]
              , h = Object.values(p)
              , v = Object.values(h)[0].v;
            if (v == id) {
                var y = this.products
                  , removeItem = this.products[i];
                y = jQuery.grep(y, function(value) {
                    return value != removeItem
                });
                this.products = y
            }
        }
        ;this.deleteFromKit();
        this.updatePrice();
        return
    },
    renderKit: function() {
        var productsArray = this.products
          , renderedProductsArray = this.renderedProducts;
        for (i = 0; i < productsArray.length; i += 1) {
            var p = productsArray[i]
              , handle = Object.keys(p)
              , product = Object.values(p)
              , variant = Object.values(product)[0].v;
            if (checkIfProductHasBeenRendered(variant) == false) {
                this.renderProduct(handle, variant);
                $('input[data-producthandle="' + handle + '"]').val('In your kit');
                $('input[data-producthandle="' + handle + '"]').css('background', '#ac1e65')
            }
            ;function checkIfProductHasBeenRendered(v) {
                for (j = 0; j < renderedProductsArray.length; j += 1) {
                    var v = renderedProductsArray[i];
                    if (v == variant) {
                        return true
                    }
                }
                ;return false
            }
        }
    },
    deleteFromKit: function() {
        var productsArray = this.products
          , renderedProductsArray = this.renderedProducts;
        for (i = 0; i < renderedProductsArray.length; i += 1) {
            let variant = renderedProductsArray[i];
            console.info('loop = ' + i);
            console.info('renderedProductsArray.length = ' + renderedProductsArray.length);
            if (checkIfProductHasBeenRemoved(variant) == true) {
                this.deleteProduct(variant);
                $('input[data-productid="' + variant + '"]').val('Add to kit');
                $('input[data-productid="' + variant + '"]').css('background', '');
                renderedProductsArray = this.renderedProducts
            }
        }
        ;function checkIfProductHasBeenRemoved(variant) {
            for (j = 0; j < productsArray.length; j += 1) {
                var p = productsArray[j]
                  , handle = Object.keys(p)
                  , product = Object.values(p)
                  , v = Object.values(product)[0].v;
                if (v == variant) {
                    return false
                }
            }
            ;return true
        }
    },
    kitContainerClass: 'create-a-kit__kit-container',
    renderProduct: function(handle, variant) {
        var view = 'create-a-kit__kit-thumb';
        productURL = '/products/' + handle + '?variant=' + variant + '&view=' + view;
        var $kitContainer = $('.' + this.kitContainerClass);
        this.renderedProducts.push(variant);
        $.ajax({
            type: 'GET',
            dataType: 'html',
            url: productURL,
            success: function(data) {
                $($kitContainer).append(data);
                createAKit.renderPlaceholders()
            }
        })
    },
    deleteProduct: function(variant) {
        var $kitContainer = $('.' + this.kitContainerClass)
          , itemClass = 'create-a-kit__item';
        target = '.' + itemClass + '[data-variantid="' + variant + '"]';
        for (i = 0; i < this.renderedProducts.length; i += 1) {
            let v = this.renderedProducts[i];
            if (v == variant) {
                var y = createAKit.renderedProducts
                  , removeItem = createAKit.renderedProducts[i];
                y = jQuery.grep(y, function(value) {
                    return value != removeItem
                });
                this.renderedProducts = y
            }
        }
        ;$($kitContainer).find(target).remove();
        this.renderPlaceholders()
    },
    renderPlaceholders: function() {
        $('.create-a-kit__kit-container .create-a-kit__item--blank').remove();
        let renderedProductsArray = this.renderedProducts
          , renderedProductsCount = renderedProductsArray.length
          , maxItems = this.maxItems()
          , placeholdersToRender = maxItems - renderedProductsCount
          , $placeholder = $('.create-a-kit__placeholder-container .create-a-kit__item--blank')
          , $target = $('.' + this.kitContainerClass);
        for (i = 0; i < placeholdersToRender; i += 1) {
            $($target).append($($placeholder).clone())
        }
    },
    updatePrice: function() {
        var price = 0
          , buyString = 'Add selection to bag | $'
          , currentProductCount = this.products.length
          , minItems = this.minItems()
          , requiredItems = minItems - currentProductCount
          , pluraiseString = 's';
        if (requiredItems == 1) {
            pluraiseString = ''
        }
        ;var needMoreItemsString = 'Add ' + requiredItems + ' more item' + pluraiseString;
        if (currentProductCount < minItems) {
            $('.create-a-kit__submit').text(needMoreItemsString)
        } else {
            if (currentProductCount == 5) {
                price = this.priceFiveItems()
            }
            ;if (currentProductCount == 4) {
                price = this.priceFourItems()
            }
            ;if (currentProductCount == 3) {
                price = this.priceThreeItems()
            }
            ;if (currentProductCount == 2) {
                price = this.priceTwoItems()
            }
            ;console.info('buyString+price = ' + buyString + price);
            $('.create-a-kit__submit').text(buyString + price)
        }
    },
    submitProducts: function() {
        let productsArray = this.products
          , queue = [];
        for (i = 0; i < productsArray.length; i += 1) {
            let product = {
                'id': Object.values(productsArray[i])[0].v,
                'quantity': '1',
                'properties': {
                    '_s': Object.values(productsArray[i])[0].s,
                    '_p': this.priceTwoItems() + '-' + this.priceThreeItems() + '-' + this.priceFourItems() + '-' + this.priceFiveItems(),
                    '_k': this.title
                }
            };
            queue.push(product)
        }
        ;this.queue = queue;
        this.processQueue()
    },
    queue: [],
    processQueue: function() {
        if (this.queue.length > 0) {
            let product = this.queue.shift();
            this.addItemToCart(product)
        } else {
            document.location.href = '/cart'
        }
    },
    addItemToCart: function(product) {
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: product
        }).done(function(data) {
            createAKit.processQueue()
        })
    },
    checkForKitInCart: function() {
        let currentProductCount = this.products.length
          , minItems = this.minItems()
          , submittingItemsString = 'Adding items to bag';
        if (currentProductCount < minItems) {
            return
        }
        ;$('.create-a-kit__submit').text(submittingItemsString);
        $('.create-a-kit__submit').attr('disabled', 'disabled');
        $.ajax({
            type: "GET",
            url: "/cart.js",
            dataType: "json"
        }).done(function(data) {
            var cart = data
              , checkItems = true
              , unique = 0
              , products = cart.items.length;
            if (products != 0) {
                while (checkItems) {
                    for (i = 0; i < products; i += 1) {
                        if (cart.items[i].properties._k == createAKit.title) {
                            createAKit.title = createAKit.title + unique;
                            unique = unique + 1;
                            i = 0
                        }
                    }
                    ;checkItems = false
                }
            }
            ;createAKit.submitProducts()
        })
    }
};
$(document).ready(function() {
    $('[href="#live-chat"]').on('click', function() {
        $zopim.livechat.window.show()
    });
    $('.account__main').on('click', '.section__title', function() {
        let $parent = $(this).closest('.section__container')
          , state = $($parent).attr('data-show');
        if (state == 'true') {
            $($parent).attr('data-show', 'false')
        } else {
            $($parent).attr('data-show', 'true')
        }
    });
    $('.table__overflow-title').on('click', function() {
        let $t = $(this).closest('.table__overflow');
        $($t).attr('data-show', 'true')
    });
    $('.quiz-result .section__title a').on('click', function(evt) {
        evt.stopPropagation()
    });
    $('.table__overflow-items').on('click', function() {
        let $t = $(this).closest('.table__overflow');
        $($t).attr('data-show', 'false')
    });
    $('.orders__reorder').on('click', function() {
        let string = $(this).attr('data-items')
          , products = JSON.parse(string);
        $(this).text('Adding items');
        $(this).attr('disabled', 'disabled');
        autoOrder.submitProducts(products, true)
    });
    $('.products__reorder').on('click', function() {
        var products = $('.product__reorder').map(function() {
            let string = $(this).attr('data-items')
              , product = JSON.parse(string);
            return product
        }).get();
        $(this).text('Adding items');
        $(this).attr('disabled', 'disabled');
        autoOrder.submitProducts(products, true)
    });
    $('.product__reorder').on('click', function() {
        let string = $(this).attr('data-items')
          , products = JSON.parse(string);
        $(this).text('Adding item');
        autoOrder.submitProducts(products, false);
        $(this).text('Item added')
    })
});
let autoOrder = {
    submitProducts: function(products, redirect) {
        let queue = [];
        for (i = 0; i < products.length; i += 1) {
            let product = products[i];
            queue.push(product)
        }
        ;this.redirect = redirect;
        this.queue = queue;
        this.processQueue()
    },
    queue: [],
    redirect: true,
    processQueue: function() {
        if (this.queue.length > 0) {
            let product = this.queue.shift();
            console.info('Adding item');
            console.info(product);
            this.addItemToCart(product)
        } else {
            if (this.redirect == true) {
                document.location.href = '/cart'
            }
        }
    },
    addItemToCart: function(product) {
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: product
        }).done(function(data) {
            autoOrder.processQueue()
        }).fail(function(data) {
            if (data.responseText != null && data.responseText != undefined) {
                console.error(data.responseText)
            } else {
                console.error(data)
            }
            ;autoOrder.processQueue()
        })
    }
};
function initVariantWrapperSelectors() {
    $('.variant-wrapper').on("click", function() {
        $(this).find('input').prop('checked', true);
        let listboxClosed = $('.listbox.closed').length;
        if (listboxClosed == 0) {
            let targetImageId = $(this).attr('image-id')
              , $navContainer = $('.product-page--thumbs-container')
              , $thumbs = $($navContainer).find('.product-page--thumb')
              , $imagesContainer = $('.product-page--images-container')
              , $images = $($imagesContainer).find('.product-page--image')
              , $targetThumb = $($navContainer).find('.product-page--thumb[data-id="' + targetImageId + '"]')
              , $targetImage = $($imagesContainer).find('.product-page--image[data-id="' + targetImageId + '"]');
            if (targetImageId != null && targetImageId != undefined && targetImageId != '') {
                $($thumbs).attr('data-active', 'false');
                $($images).attr('data-active', 'false');
                $($targetThumb).attr('data-active', 'true');
                $($targetImage).attr('data-active', 'true')
            }
        } else {}
    })
}
